// TODO: #debito-tecnico Desmembrar esse componente. Ele é muito grande (5000+ linhas!!!) e difícil de dar manutenção.
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import { sub, isAfter, isBefore, startOfMonth, addMonths, isSameDay, addDays, format, subDays, parse, differenceInDays, differenceInHours, subMonths, startOfDay, endOfMonth, isEqual, getYear, getMonth } from 'date-fns';

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';
import { SolicitacaoController, TiposSolicitacao } from '@/assets/ts/controller/SolicitacaoController';
import SituacaoFuncionalController from '@/assets/ts/controller/SituacaoFuncionalController';
import EscalaController from '@/assets/ts/controller/EscalaController';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import FormatUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FormatUtils';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import DocumentoUtil from '@/assets/ts/utils/DocumentoUtil';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import Periodo from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import TreinamentoController from '@/assets/ts/controller/TreinamentoController';
import Action from '@/../bower_components/teknisavuecomponents/assets/interfaces/Action';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import EditableTableColumn from '@/../bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import Messages from '@/assets/ts/utils/Messages';
import AdmissaoController from '@/assets/ts/controller/AdmissaoController';
import VinculoController from '@/assets/ts/controller/VinculoController';
import User from '@/assets/ts/interfaces/User';
import NovoDocumentoSolicitacaoPopup from '../documentos/NovoDocumentoSolicitacaoPopup/NovoDocumentoSolicitacaoPopup.vue';
import NovaSolicitacaoFerias from './solicitacoes/NovaSolicitacaoFerias';
import Dictionary from '@tekvue/assets/interfaces/Dictionary';
import { INovaSolicitacao, NovaSolicitacaoClass, SolicitacaoActionsRelation } from './interfaces';
import NovaSolicitacaoEstruturaGerencial from './solicitacoes/NovaSolicitacaoEstruturaGerencial';
import NovaSolicitacaoEstruturaLegal from './solicitacoes/NovaSolicitacaoEstruturaLegal';
import NovaSolicitacaoOcupacaoSalario from './solicitacoes/NovaSolicitacaoOcupacaoSalario';

const dataAtualStr = format(new Date(), 'dd/MM/yyyy');
const dataAtualDate = startOfDay(new Date());

@Component({
  name: 'NovaSolicitacaoPopup',
  components: {
    TkForm,
    EditableTable,
    NovoDocumentoSolicitacaoPopup
  },
})
class NovaSolicitacaoPopup extends Vue {
  private static readonly TIPOS_NOVA_SOLICITACAO: NovaSolicitacaoClass[] = [
    NovaSolicitacaoFerias, // Solicitação de Férias,
    NovaSolicitacaoEstruturaGerencial, // Solicitação de Remanejamento/Transferência - Gerencial
    NovaSolicitacaoEstruturaLegal, // Solicitação de Remanejamento/Transferência - Legal
    NovaSolicitacaoOcupacaoSalario, // Solicitação de Movimentação, Ocupação e Salário
  ];

  // #region [ PROPS ]
  @Prop({ default: false })
  private readonly value: boolean;

  @Prop({ default: false })
  readonly isEdit: boolean;

  @Prop({ default: {} })
  private readonly selectedRow: any;

  @Prop({ default: [], required: true })
  private readonly vinculosProp: any;

  @Prop({ default: [], required: true })
  private readonly tiposSolicitacao: any;
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    NovaSolicitacaoPopup.TIPOS_NOVA_SOLICITACAO.forEach((novaSolicitacaoClass) => {
      const novaSolicitacaoInstance = new novaSolicitacaoClass();
      novaSolicitacaoInstance.main = this;
      this.injectActions(novaSolicitacaoInstance);
      this.injectFields(novaSolicitacaoInstance);

      this.injectedSolicitacoes.push(novaSolicitacaoInstance);
    });
  }

  // #region [ STORE ]
  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  get user(): User {
    return this.$store.getters.user;
  }

  private get periodoDemonstrativoAtual(): Periodo {
    return this.$store.getters.periodoDemonstrativoAtual;
  }

  get cancelText(): string {
    return this.isCurrentMain ? this.actionText.closeDialog.close : this.actionText.closeDialog.back;
  }

  private get isCurrentMain(): boolean {
    return this.current === 'main';
  }

  public get tipoSolicitacaoSelected(): any {
    return this.tiposSolicitacao.find((tipo) => tipo.NRTIPOSOLICITACAO === this.row.NRTIPOSOLICITACAO);
  }

  private get overrideSaveActionExistsForCurrentType(): boolean {
    return !!this.currentTypeActionsConfig.overrideSaveAction;
  }

  private get currentNomeVinculo(): string | null {
    return this.isCurrentMain ? null : this.row.NMVINCULOM;
  }

  get cardTitle(): string {
    if (this.isCurrentMain || !this.currentNomeVinculo) {
      return 'Solicitação';
    }
    return `Solicitação - ${this.currentNomeVinculo}`;
  }

  private get loadingVisibility(): boolean {
    return this.$store.getters.loadingVisibility;
  }

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('close')
  private emitClose(value: boolean) {}

  @Emit('input')
  private emitInput(value: boolean): boolean {
    return value;
  }
  // #endregion

  // #region [ DATA ]
  /** Os tipos de solicitação nos quais o campo de vínculo
  * deve ser readonly. */
  private readonly TP_SOLICITACAO_VINC_NOT_VISIBLE = [ '28' ];

  /** Os tipos de solicitação que busca todos os vinculos (demitidos). */
  private readonly TP_SOLICITACAO_TODOS_VINC = [ '25' ];

  /** Lista das instâncias das solicitações injetadas. */
  private injectedSolicitacoes: INovaSolicitacao[] = [];

  /** Os tipos de solicitação que a data não pode ser anterior a hoje. */
  private readonly TP_SOLICITACAO_BLOCK_DATA_ANTERIOR = [ '1' ];

  private internalValue = false;

  private readonly defaultMainPanelsExpansion = [0];

  current = 'main';

  row: Dictionary<any> = {};

  loading = false;

  private vinculos = [];
  private todosVinculos = [];

  rowsDocumentos: any[] = [];

  public isSoliSalarioRequired = false;
  public isSoliEscalaRequired = false;
  public isSoliMovimentRequired = false;
  private isSoliOcupacaoRequired = false;
  private isAumentoQuadroReadonly = false;

  private dataMinimimaSolicitacao: string | null = null;
  private hintDataSolicitacao: string | null = null;

  public actionText = {
    closeDialog: {
      back: 'Voltar',
      close: 'Fechar',
    },
    situFuncWanr: {
      title: 'Alerta de Situação Funcional',
    },
    periodoEstabWanr: {
      title: 'Alerta de Período de Estabilidade',
    },
  };

  // Main
  private defaultRowMain = {
    IDAPROVACAOPRI: 'P',
    IDAPROVACAOSEC: 'P',
    DTSOLICITACAO: DateUtil.getCurrentDate(),
  };

  mainPanelsExpansion = [];

  private tiposSolicitacaoBloqueioDemitido: any[] = ['3', '9', '14'];

  private vinculoLabel = 'Vínculo';
  private isDocRequired = false;

  // Escala
  public escalas: any[] = [];
  public turnos: any[] = [];
  public turnos_hist: any[] = [];
  public isEscala12x36 = false;
  private escalaVinculo: any = {};

  // Ocupação
  public ocupacoes: any[] = [];
  public motivosOcupa: any[] = [];

  // Salário
  public tiposAlteraSal: any[] = [];
  private modalidadesSal: any[] = [];
  public dadosUltimoSal: any = {};

  // Desligamento
  private tiposAviso: any[] = [];
  private tiposDemissao: any[] = [];
  private motivosRescisao: any[] = [];
  public periodosEstabVinculo: any[] = [];
  private isAvisoPrevioRequired = false;

  // Dependente
  private tiposRelacionamento: any[] = [];

  // Vale transporte
  private linhas: any[] = [];
  private tiposLinha: any[] = [];
  private numerosIntegracao: any[] = [];
  private sentidosLinha: any[] = [];
  private tarifasVT: any[] = [];
  private linhasVTVinculo: any[] = [];
  private isInclusaoVT = true;
  private isRequiredVTInit = {
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false
  }

  private isRequiredVT = this.isRequiredVTInit;

  // Benefício
  private beneficios: any[] = [];
  private tiposBeneficio: any[] = [];
  private beneficiosFiltrados: any[] = [];
  private pessoas: any[] = [];

  private defaultRowBeneficio = {
    IDTPBENEFICIARIO: 'T',
  };

  // Treinamento
  private defaultRowTreinamento = {
    IDTREINAMENTOINT: 'N',
  };

  private cursos: any[] = [];
  private perfisAcesso: any[] = [];
  private metodos: any[] = [];

  // Pessoal
  private readonly defaultRowAdmissao = {
    NRVAGAS: 1,
    IDPUBLICAVAGA: 'N - Não',
    NRPARCNEGOCIOSOLICITA: `${this.user.nrparcnegocio} - ${this.user.nmoperador}`,
  };

  // Substituição
  private motivosAdmissao: any[] = [];
  public dadosVinculo: any = null;

  // Aumento de Quadro
  private vinculoCpf: any = {};
  private isNmPessoaReadOnly = false;

  // Vale Combustível
  private isInclusaoVC = true;

  // Advertência/Suspensão - Anotações do Vínculo
  private tiposAnotacao: any[] =[];

  private templates: any[] = [];
  private tiposProcesso: any[] = [];
  private responsaveis: any[] = [];
  private estruturas: any[] = [];
  public estruturasLegais: any[] = [];
  public estruturasGerenciais: any[] = [];
  private estruturasSindicais: any[] = [];
  private vinculosEmpregaticios: any[] = [];
  private tiposVinculo: any[] = [];
  private grausInstrucao: any[] = [];

  public tiposTransferencia: any[];
  public transferencias: any[] = [];
  public motivosTransferencia: any[] = [];

  // Apenas para MPs de movimentação (gerencial, legal, ocupação/salário)
  public get minDtInitMovimentMovimentacao(): string | null {
    const regra = this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO;
    const admissao = this.row.DTADMISSAOVINC;
  
    if (!admissao) return null;
  
    const minRegra = this.getIntervaloDataRegra('min');
    if (!minRegra) {
      return DateUtil.startOfNextMonthStr(admissao);
    }
  
    if (regra === 'A') {
      const admissaoDate = parse(admissao, 'dd/MM/yyyy', new Date());
      const hoje = new Date();
  
      const mesmoMes =
        getMonth(admissaoDate) === getMonth(hoje) &&
        getYear(admissaoDate) === getYear(hoje);
  
      if (mesmoMes) {
        const base = addMonths(startOfMonth(hoje), 1);
        return format(startOfMonth(base), 'yyyy-MM-dd');
      }
    }
  
    return minRegra;
  }

  public get maxDtInitMovimentMovimentacao(): string | null {
    const regra = this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO;
    const admissao = this.row.DTADMISSAOVINC;
  
    if (!admissao) return null;
  
    const maxRegra = this.getIntervaloDataRegra('max');
    if (!maxRegra) {
      return null;
    }
  
    if (regra === 'A') {
      const admissaoDate = parse(admissao, 'dd/MM/yyyy', new Date());
      const hoje = new Date();
  
      const mesmoMes =
        getMonth(admissaoDate) === getMonth(hoje) &&
        getYear(admissaoDate) === getYear(hoje);
  
      if (mesmoMes) {
        const base = addMonths(startOfMonth(hoje), 1);
        return format(endOfMonth(base), 'yyyy-MM-dd');
      }
    }
  
    return maxRegra;
  }
  // Endereço
  public enderecoVinculo: any = {};
   



  private ignoreFields = {
    main: [
      'IDAPROVACAOPRI',
      'IDAPROVACAOSEC',
      '__is_valid',
      'NRPESSOAPRINC',
      '_eula',
    ],
    salario: [
      'VRSALARIOATUAL',
      'PERCALTERA',
    ],
  };

  public considerationsIsVisible = false;

  typeActionsConfig: SolicitacaoActionsRelation = {
    [TiposSolicitacao.TP_SOLI_ALTERAESCALA]: {
      onAdvanceAction: () => this.setEscalaFields(),
      afterAdvanceAction: () => this.afterAdvanceActionHistoric(),
    },
    [TiposSolicitacao.TP_SOLI_OCUPACAO]: {
      onAdvanceAction: async () => await this.setOcupacaoFields(),
      afterAdvanceAction: () => this.afterAdvanceActionHistoric(),
      onSaveValidation: async () => await this.onSaveOcupacaoValidations(),
    },
    [TiposSolicitacao.TP_SOLI_SALARIO]: {
      onAdvanceAction: () => this.setSalarioFields(),
      afterAdvanceAction: () => this.afterAdvanceActionHistoric(),
      onSaveValidation: async () => await this.onSaveAlteSalario(),
    },
    [TiposSolicitacao.TP_SOLI_DESLIGAMENTO]: {
      onAdvanceAction: async () => await this.setDesligamentoFields(),
      afterAdvanceAction: () => this.afterAdvanceActionDesligamento(),
      onSaveValidation: async () => await this.onSaveDesligamentoValidations(),
    },
    [TiposSolicitacao.TP_SOLI_DEP]: {
      onAdvanceAction: () => this.setDependenteFields(),
      afterAdvanceAction: () => null,
      onSaveValidation: () => this.onSaveDependenteValidation(),
    },
    [TiposSolicitacao.TP_SOLI_VTRANS]: {
      onAdvanceAction: async () => await this.setVTFields(),
      afterAdvanceAction: () => null,
      onSaveValidation: () => this.onSaveVTValidation(),
    },
    [TiposSolicitacao.TP_SOLI_PLANOSAUDE]: {
      onAdvanceAction: () => this.setBeneficioFields(),
      afterAdvanceAction: () => null,
      overrideSaveAction: this.overrideBeneficioSaveAction,
    },
    [TiposSolicitacao.TP_SOLI_PESSOAL]: {
      onAdvanceAction: () => this.setPessoalFields(),
      afterAdvanceAction: () => null,
      onSaveValidation: () => this.onSavePessoalValidation(),
    },
    [TiposSolicitacao.TP_SOLI_TREINAMENTO]: {
      onAdvanceAction: () => this.setTreinamentoFields(),
      onSaveValidation: () => this.onSaveTreinamentoValidations(),
    },
    [TiposSolicitacao.TP_SOLI_ADVERTENCIA]: {
      onAdvanceAction: () => this.setAdvertenciaFields(),
      afterAdvanceAction: () => null,
      onSaveValidation: () =>this.onSaveAdvertenciaValidation(),
    },
    [TiposSolicitacao.TP_SOLI_VCOMBUST]: {
      onAdvanceAction: async () => await this.setVCFields(),
      afterAdvanceAction: () => null,
      onSaveValidation: () =>this.onSaveValeCombustivelValidation(),
    },
    [TiposSolicitacao.TP_SOLI_AUXILIOMORADIA]: {
      onAdvanceAction: async () => await this.setAuxilioMoradiaFields(),
      afterAdvanceAction: () => null,
      onSaveValidation: () => this.onSaveAdvertenciaValidation(),
    },
    [TiposSolicitacao.TP_SOLI_VMANUTENCAO]: {
      onAdvanceAction: async () => await this.setVManutencaoFields(),
      afterAdvanceAction: () => null,
    },
    [TiposSolicitacao.TP_SOLI_BENEFICIOS]: {
      onAdvanceAction: async () => await this.setBeneficiosFields(),
      afterAdvanceAction: () => null,
    },
    [TiposSolicitacao.TP_SOLI_SUBSTITUICAO]: {
      onAdvanceAction: async () => await this.setSubstituicaoFields(),
      afterAdvanceAction: () => null,
      onSaveValidation: async () => await this.onSaveSubstituicaoValidation()
    },
    [TiposSolicitacao.TP_SOLI_AUMENTO_QUADRO]: {
      onAdvanceAction: () => this.setAumentoQuadroFields(),
      afterAdvanceAction: () => null,
      onSaveValidation: async () => await this.onSaveAumentoQuadroValidation(),
    },
    [TiposSolicitacao.TP_SOLI_SALARIO_ESCALA]: {
      onAdvanceAction: async () => await this.setSalarioEscalaFields(),
      afterAdvanceAction: () => this.afterAdvanceActionHistoric(),
      onSaveValidation: async () => await this.onSaveSalarioEscalaValidations(),
    },
    [TiposSolicitacao.TP_SOLI_REEMBOLSO]: {
      onAdvanceAction: () => this.onAdvanceDefault(),
    },
    [TiposSolicitacao.TP_SOLI_APROVAHE]: {
      onAdvanceAction: () => this.onAdvanceDefault(),
    },
    [TiposSolicitacao.TP_SOLI_CARTAO]: {
      onAdvanceAction: () => this.onAdvanceDefault(),
      itemsStageNotNecessary: true,
    },
    [TiposSolicitacao.TP_SOLI_ALIMENTACAO]: {
      onAdvanceAction: () => this.onAdvanceDefault(),
      itemsStageNotNecessary: true,
    },
    [TiposSolicitacao.TP_SOLI_FARMACIA]: {
      onAdvanceAction: () => this.onAdvanceDefault(),
      itemsStageNotNecessary: true,
    },
    [TiposSolicitacao.TP_SOLI_ADVERTENCIA_ANOT_VINC]: {
      onAdvanceAction: () => this.setAdvertenciaFields(),
      afterAdvanceAction: () => null,
      onSaveValidation: () => this.onSaveAdvertenciaValidation(),
    },
  }

  private tiposIniciativa: any = {
    iniciativaEmpresa: 'E',
    iniciativaColaborador: 'C',
    iniciativaMutua: 'A',
  }

  private defaultItemsRows = {
    [TiposSolicitacao.TP_SOLI_DESLIGAMENTO]: [
      {
        justaCausa: true,
        row: {
          NRTPDEMISSAO: '1',
        }
      },
      {
        justaCausa: false,
        periodoExperiencia: true,
        iniciativaColaborador: true,
        row: {
          NRTPDEMISSAO: '24',
        }
      },
      {
        justaCausa: false,
        periodoExperiencia: true,
        iniciativaEmpresa: true,
        row: {
          NRTPDEMISSAO: '21',
        }
      },
      {
        justaCausa: false,
        iniciativaEmpresa: true,
        row: {
          NRTPDEMISSAO: '2',
        }
      },
      {
        justaCausa: false,
        iniciativaColaborador: true,
        row: {
          NRTPDEMISSAO: '5',
        }
      },
      {
        justaCausa: false,
        iniciativaMutua: true,
        row: {
          NRTPDEMISSAO: '45',
        }
      },
    ],
  };
  // #endregion

  // #region [ COMPUTED ]
  private get nrOrg(): string {
    const nrOrg = this.user ?
      this.user.nrorg :
      undefined;

    return nrOrg;
  }

  private get nrVinculo(): string {
    const nrVinculo = this.user ?
      this.user.nrvinculom :
      undefined;

    return nrVinculo;
  }

  public get vinculoSelected(): any {
    return this.vinculos.find((vinculo) => vinculo.NRVINCULOM == this.row.NRVINCULOM);
  }

  private get nrEstrutura(): string {
    const nrEstrutura = this.estruturaGerencialAtual ?
      this.estruturaGerencialAtual.NRESTRUTURAM :
      undefined;

    return nrEstrutura;
  }

  get showAdvanceButton(): boolean {
    return this.isCurrentMain && !this.isNextStageNotNecessary;
  }

  private get currentTypeActionsConfig(): any {
    return this.typeActionsConfig ? this.typeActionsConfig[this.current] || {} : {};
  }

  private get selectedTypeActionsConfig(): any {
    return this.typeActionsConfig ? this.typeActionsConfig[this.row.NRTIPOSOLICITACAO] || {} : {};
  }

  get isNextStageNotNecessary(): boolean {
    return this.selectedTypeActionsConfig.itemsStageNotNecessary;
  }

  private get defaultDesligamentoItemsRow(): any {
    const configDefault = this.defaultItemsRows[TiposSolicitacao.TP_SOLI_DESLIGAMENTO].find(
      (item) => {
        return (!item.justaCausa || (item.justaCausa && this.row.CDJUSTACAUSA === 'S')) &&
          (!item.periodoExperiencia || (item.periodoExperiencia && this.row.CDPEREXP === 'S')) &&
          (!item.iniciativaColaborador || (item.iniciativaColaborador && this.row.CDINICIATIVA === this.tiposIniciativa.iniciativaColaborador)) &&
          (!item.iniciativaEmpresa || (item.iniciativaEmpresa && this.row.CDINICIATIVA === this.tiposIniciativa.iniciativaEmpresa)) &&
          (!item.iniciativaMutua || (item.iniciativaMutua && this.row.CDINICIATIVA === this.tiposIniciativa.iniciativaMutua));
      }
    );
    
    if (configDefault) {
      return configDefault.row;
    }

    return {};
  }

  injectedFieldRelation: Dictionary<Field[]> = {};

  get fields(): Field[] {
    const fieldRelation = {
      main: this.fieldsMain,
      [TiposSolicitacao.TP_SOLI_ALTERAESCALA]: this.fieldsEscala,
      [TiposSolicitacao.TP_SOLI_OCUPACAO]: this.fieldsOcupacao,
      [TiposSolicitacao.TP_SOLI_SALARIO]: this.fieldsSalario,
      [TiposSolicitacao.TP_SOLI_DESLIGAMENTO]: this.fieldsDesligamento,
      [TiposSolicitacao.TP_SOLI_DEP]: this.fieldsDependente,
      [TiposSolicitacao.TP_SOLI_VTRANS]: this.fieldsVT,
      [TiposSolicitacao.TP_SOLI_PLANOSAUDE]: this.fieldsBeneficio,
      //[TiposSolicitacao.TP_SOLI_PESSOAL]: this.fieldsPessoal,
      [TiposSolicitacao.TP_SOLI_TREINAMENTO]: this.fieldsTreinamento,
      [TiposSolicitacao.TP_SOLI_APROVAHE]: this.fieldsAprovaHE,
      [TiposSolicitacao.TP_SOLI_REEMBOLSO]: this.fieldsReembolso,
      [TiposSolicitacao.TP_SOLI_ADVERTENCIA]: this.fieldsAdvertencia,
      [TiposSolicitacao.TP_SOLI_VCOMBUST]: this.fieldsVC,
      [TiposSolicitacao.TP_SOLI_AUXILIOMORADIA]: this.fieldsAuxilioMoradia,
      [TiposSolicitacao.TP_SOLI_VMANUTENCAO]: this.fieldsVManutencao,
      [TiposSolicitacao.TP_SOLI_BENEFICIOS]: this.fieldsBeneficios,
      [TiposSolicitacao.TP_SOLI_SUBSTITUICAO]: this.fieldsSubstituicao,
      [TiposSolicitacao.TP_SOLI_AUMENTO_QUADRO]: this.fieldsAumentoQuadro,
      [TiposSolicitacao.TP_SOLI_SALARIO_ESCALA]: this.fieldsSalarioEscala,
      [TiposSolicitacao.TP_SOLI_ADVERTENCIA_ANOT_VINC]: this.fieldsAdvertenciaAnotVinc,
      ...this.injectedFieldRelation,
    };

    const fields = fieldRelation[this.current];

    return fields || [];
  }

  private get additionalMainFields(): Field[] {
    const fieldRelation = {
      [TiposSolicitacao.TP_SOLI_DESLIGAMENTO]: this.fieldsMainDesligamento,
      [TiposSolicitacao.TP_SOLI_PLANOSAUDE]: this.fieldsMainBeneficio,
      [TiposSolicitacao.TP_SOLI_ALIMENTACAO]: this.fieldsMainAlimentacao,
      [TiposSolicitacao.TP_SOLI_FARMACIA]: this.fieldsMainFarmacia,
      [TiposSolicitacao.TP_SOLI_CARTAO]: this.fieldsMainCartao,
      [TiposSolicitacao.TP_SOLI_VTRANS]: this.fieldsMainVT,
      [TiposSolicitacao.TP_SOLI_VCOMBUST]: this.fieldsMainVC,
      [TiposSolicitacao.TP_SOLI_VMANUTENCAO]: this.fieldsMainVManutencao,
      [TiposSolicitacao.TP_SOLI_BENEFICIOS]: this.fieldsMainBeneficios,
    }

    if (!this.tipoSolicitacaoSelected) {
      return;
    }

    const fields = fieldRelation[this.tipoSolicitacaoSelected.NRTIPOSOLICITACAO];

    return fields || [];
  }

  private get additionalMainFieldsExist(): boolean {
    return !!this.additionalMainFields;
  }

  private tiposSolicitacaoProperties: any = {
    clearFieldsOnBack: [
      TiposSolicitacao.TP_SOLI_ALTERAESCALA,
      TiposSolicitacao.TP_SOLI_OCUPACAO,
      TiposSolicitacao.TP_SOLI_SALARIO,
      TiposSolicitacao.TP_SOLI_DESLIGAMENTO,
      TiposSolicitacao.TP_SOLI_DEP,
      TiposSolicitacao.TP_SOLI_VTRANS,
      TiposSolicitacao.TP_SOLI_PLANOSAUDE,
      TiposSolicitacao.TP_SOLI_PESSOAL,
      TiposSolicitacao.TP_SOLI_MOVIM_LEGAL,
      TiposSolicitacao.TP_SOLI_MOVIM_GERENCIAL,
      TiposSolicitacao.TP_SOLI_ADVERTENCIA,
      TiposSolicitacao.TP_SOLI_BENEFICIOS,
      TiposSolicitacao.TP_SOLI_VMANUTENCAO,
      TiposSolicitacao.TP_SOLI_VCOMBUST,
      TiposSolicitacao.TP_SOLI_AUMENTO_QUADRO,
      TiposSolicitacao.TP_SOLI_SUBSTITUICAO,
      TiposSolicitacao.TP_SOLI_ADVERTENCIA_ANOT_VINC,
    ],
  };
 
  private get fieldsMain(): Field[] {
    const firstFieldSet: Field[] = [
      {
        name: 'NRTIPOSOLICITACAO',
        label: 'Tipo de Solicitação',
        size: 9,
        required: true,
        type: 'autocomplete',
        descriptionField: 'NMTIPOSOLICITACAO',
        valueField: 'NRTIPOSOLICITACAO',
        readonly: this.tipoSolicitacaoIsReadonly,
        items: this.tiposSolicitacao,
        onInput: this.tipoSolicitacaoOnInput,
      },
      {
        name: 'DTSOLICITACAO',
        label: 'Data de Solicitação',
        size: 3,
        required: true,
        type: 'date',
        onInput: () => this.dataDeSolicitacaoOnInput(),
        readonly: this.dataSolicitacaoIsReadonly,
        minDate: this.dataMinimimaSolicitacao,
        persistentHint: true,
        hint: this.hintDataSolicitacao,
      },
      {
        name: 'NRVINCULOM',
        label: this.vinculoLabel,
        size: 9,
        required: true,
        type: 'autocomplete',
        readonly: this.vinculoIsReadonly,
        isVisible: this.vinculoIsNotVisible,
        descriptionField: 'NRNMVINCULO',
        valueField: 'NRVINCULOM',
        items: this.vinculos,
        outData: {
          NRVINCULOM: 'NRVINCULOM',
          NRPESSOAPRIN: 'NRPESSOA',
          NMVINCULOM: 'NMVINCULOM',
          DTADMISSAOVINC: 'DTADMISSAOVINC',
        },
        onInput: this.vinculoOnInput,
      },
      {
        name: 'IDAPROVACAOSEC',
        label: 'Aprovação',
        required: true,
        type: 'select',
        descriptionField: 'DSAPROVACAOSEC',
        valueField: 'IDAPROVACAOSEC',
        readonly: true,
        size: this.vinculoIsNotVisible ? 3 : 12,
        items: [
          {
            IDAPROVACAOSEC: 'A',
            DSAPROVACAOSEC: 'Aprovada',
          },
          {
            IDAPROVACAOSEC: 'R',
            DSAPROVACAOSEC: 'Reprovada',
          },
          {
            IDAPROVACAOSEC: 'P',
            DSAPROVACAOSEC: 'Pendente',
          },
        ],
      },
      {
        name: 'DSCONSIDERACAO',
        label: 'Considerações',
        type: 'banner',
        required: false,
        readonly: true,
        isVisible: this.considerationsIsVisible,
        rows: 4,
        size: 12,
      },
      {
        name: 'DSRECUSA',
        label: 'Observações de Recusas',
        type: 'list',
        required: false,
        readonly: true,
        isVisible: this.isEdit,
        rows: 4,
        size: 12,
      },
    ];

    const nextFieldSet: Field[] = [
      {
        name: 'DSOBSSOLICITACAO',
        label: 'Observação',
        type: 'textarea',
        required: false,
        rows: 2,
        size: 12,
      },
      {
        name: '_eula',
        label: `
          Este formulário registra a manifestação livre, informada e inequívoca pela qual o Funcionário
          concorda com o tratamento de seus dados pessoais para finalidade específica,
          em conformidade com a Lei nº 13.709 – Lei Geral de Proteção de Dados Pessoais (LGPD).
          Li e concordo.`,
        type:'checkbox',
        size: 12,
        required: true,
        valueToTrue: true,
        valueToFalse: null,
        isVisible: this.user.nrorg != '1410'
      },
    ];

    if (this.additionalMainFieldsExist) {
      return [ ...firstFieldSet, ...this.additionalMainFields, ...nextFieldSet ];
    }

    return [ ...firstFieldSet, ...nextFieldSet ];
  }

  documentosGrid = {
    showPopup: false,
    currentRow: null,
    toolbarActions: [
      {
        name: 'addDoc',
        label: 'Adicionar',
        icon: 'mdi-plus-circle',
        onClick: this.addDocumento,
      },
    ] as ToolbarAction[],
    actions: [
      {
        name: 'popupEdit',
        label: 'Editar',
        icon: 'mdi-pencil',
        mode: 'view',
        onClick: this.editDocumento,
      },
      'delete',
    ] as (Action | string)[],
    columns: [
      {
        value: 'NMANEXO',
        text: 'Nome',
        type: 'text',
      },
    ] as EditableTableColumn[],
  };

  private get fieldsMainDesligamento(): any[] {
    const fields = [
      {
        name: 'CDINICIATIVA',
        label: 'Iniciativa',
        type: 'radio',
        required: true,
        valueField: 'value',
        outData: {
          DSINICIATIVA: 'label',
        },
        items: [
          {
            label: 'Por iniciativa da empresa.',
            value: 'E',
          },
          {
            label: 'Por iniciativa do colaborador.',
            value: 'C',
          },
          {
            label: 'Acordo mútuo (CLT)',
            value: 'A',
          },
        ],
        size: 3,
      },
      {
        name: 'CDJUSTACAUSA',
        label: 'Justa Causa?',
        type: 'radio',
        required: true,
        valueField: 'value',
        outData: {
          DSJUSTACAUSA: 'label',
        },
        items: [
          {
            label: 'Sim',
            value: 'S',
          },
          {
            label: 'Não',
            value: 'N',
          },
        ],
        size: 3,
        onInput: this.handleJustaCausa
      },
      {
        name: 'CDPEREXP',
        label: 'Período Experiência?',
        type: 'radio',
        required: false,
        valueField: 'value',
        outData: {
          DSPEREXP: 'label',
        },
        items: [
          {
            label: 'Sim',
            value: 'S',
          },
          {
            label: 'Não',
            value: 'N',
          },
        ],
        size: 3,
        isVisible: false,
      },
      {
        name: 'CDCUMPRIRAVISOPREV',
        label: 'Irá cumprir o aviso prévio?',
        type: 'radio',
        required: true,
        valueField: 'value',
        outData: {
          DSCUMPRIRAVISOPREV: 'label',
        },
        items: [
          {
            label: 'Sim',
            value: 'S',
          },
          {
            label: 'Não',
            value: 'N',
          },
        ],
        size: 3,
        readonly: this.row.CDJUSTACAUSA === 'S',
        isVisible: !this.isEmPeriodoExperiencia,
        onInput: this.handleJustaCausa
      },
    ];

    return fields;
  }

  private get fieldsMainBeneficio(): any[] {
    const fields = [
      {
        name: 'CDOPCAO',
        label: 'Selecione uma opção:',
        type: 'radio',
        required: true,
        valueField: 'value',
        outData: {
          DSOPCAO: 'label',
        },
        items: [
          {
            label: 'Adesão',
            value: 'A',
          },
          {
            label: 'Alteração do plano',
            value: 'P',
          },
          {
            label: 'Cancelamento parcial (apenas dependentes)',
            value: 'N',
          },
          {
            label: 'Cancelamento total',
            value: 'C',
          },
          {
            label: 'Migração (possui um plano de saúde da mesma operadora ou de outra e gostaria de migrar)',
            value: 'M',
          },
        ],
        size: 12,
      },
    ];

    return fields;
  }

  private get fieldsMainAlimentacao(): any[] {
    const fields = [
      {
        name: 'CDALTERA',
        label: 'Alterar cartão para:',
        type: 'radio',
        required: true,
        valueField: 'value',
        outData: {
          DSALTERA: 'label',
        },
        items: [
          {
            label: '100% Alimentação',
            value: 'A',
          },
          {
            label: '100% Refeição',
            value: 'B',
          },
          {
            label: '50% Alimentação - 50% Refeição',
            value: 'C',
          },
        ],
        size: 12,
      },
    ];

    return fields;
  }

  private get fieldsMainFarmacia(): any[] {
    const fields = [
      {
        name: 'CDCONVENIO',
        label: 'Convênio Farmácia (ECX Card)',
        type: 'radio',
        required: true,
        valueField: 'value',
        outData: {
          DSCONVENIO: 'label',
        },
        items: [
          {
            label: 'Adesão',
            value: 'A',
          },
          {
            label: 'Cancelamento',
            value: 'C',
          },
        ],
        size: 12,
      },
    ];

    return fields;
  }

  private get fieldsMainCartao(): any[] {
    const fields = [
      {
        name: 'DSNOVAVIA',
        label: 'Nova via',
        type: 'autocomplete',
        multiple: true,
        chips: true,
        deletableChips: true,
        required: true,
        valueField: 'DSNOVAVIA',
        descriptionField: 'CDNOVAVIA',
        size: 12,
        outData: {},
        items: [
          {
            CDNOVAVIA: 'Convênio Farmácia (ECX Card)',
            DSNOVAVIA: 'Convênio Farmácia (ECX Card)',
          },
          {
            CDNOVAVIA: 'Plano de sáude (Unimed-BH)',
            DSNOVAVIA: 'Plano de sáude (Unimed-BH)',
          },
          {
            CDNOVAVIA: 'Vale alimentação (Alelo)',
            DSNOVAVIA: 'Vale alimentação (Alelo)',
          },
          {
            CDNOVAVIA: 'Vale refeição (Alelo)',
            DSNOVAVIA: 'Vale refeição (Alelo)',
          },
          {
            CDNOVAVIA: 'Vale transporte (Betim Card)',
            DSNOVAVIA: 'Vale transporte (Betim Card)',
          },
          {
            CDNOVAVIA: 'Vale transporte (BH Bus)',
            DSNOVAVIA: 'Vale transporte (BH Bus)',
          },
          {
            CDNOVAVIA: 'Vale transporte (Ótimo)',
            DSNOVAVIA: 'Vale transporte (Ótimo)',
          },
          {
            CDNOVAVIA: 'Vale transporte (Via Ouro)',
            DSNOVAVIA: 'Vale transporte (Via Ouro)',
          },
        ],
      },
      {
        name: 'CDMOTIVO',
        label: 'Motivo',
        type: 'radio',
        required: true,
        valueField: 'value',
        outData: {
          DSMOTIVO: 'label',
        },
        items: [
          {
            label: 'Dano físico',
            value: 'D',
          },
          {
            label: 'Perda',
            value: 'P',
          },
          {
            label: 'Roubo',
            value: 'R',
          },
        ],
        size: 12,
      },
      {
        name: '_eula_cartao',
        label: `
          Autorizo a emissão e o desconto em folha de pagamento do valor da via cobrado pela
          operadora em caso de dano por má utilização, perda, roubo ou extravio do cartão.`,
        type:'checkbox',
        size: 12,
        required: true,
        valueToTrue: true,
        valueToFalse: null,
      },
    ];

    return fields;
  }

  private get fieldsMainVT(): any[] {
    const fields = [
      {
        name: 'CDTIPOALTEVT',
        label: 'Tipo de alteração',
        type: 'radio',
        required: true,
        valueField: 'value',
        outData: {
          DSTIPOALTEVC: 'label',
        },
        items: [
          {
            label: 'Inclusão',
            value: 'I',
          },
          {
            label: 'Exclusão',
            value: 'E',
          },
        ],
        size: 6,
      },
      {
        name: 'DTALTELINHAVINC',
        label: 'Data de Alteração',
        type: 'date',
        size: 6,
        required: true,
        onInput: () => this.validaDataAnteriorCompetencia('DTALTELINHAVINC'),
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
      },
    ];

    return fields;
  }

  private get fieldsMainVC(): any[] {
    const fields = [
      {
        name: 'CDTIPOALTEVC',
        label: 'Tipo de alteração',
        type: 'radio',
        required: true,
        valueField: 'value',
        outData: {
          DSTIPOALTEVC: 'label',
        },
        items: [
          {
            label: 'Inclusão',
            value: 'I',
          },
          {
            label: 'Exclusão',
            value: 'E',
          },
        ],
        size: 6,
      },
      {
        name: 'CDTIPOVC',
        label: 'Tipo',
        type: 'radio',
        required: true,
        valueField: 'value',
        outData: {
          DSTIPOVC: 'label',
        },
        items: [
          {
            label: 'Por KM',
            value: 'K',
          },
          {
            label: 'Por Valor',
            value: 'V',
          },
        ],
        size: 6,
      },
    ];

    return fields;
  }

  private get fieldsMainVManutencao(): any[] {
    const fields = [
      {
        name: 'CDTIPOALTEVC',
        label: 'Tipo de alteração',
        type: 'radio',
        required: true,
        valueField: 'value',
        outData: {
          DSTIPOALTEVC: 'label',
        },
        items: [
          {
            label: 'Inclusão',
            value: 'I',
          },
          {
            label: 'Exclusão',
            value: 'E',
          },
        ],
        size: 6,
      },
    ];

    return fields;
  }

  private get fieldsMainBeneficios(): any[] {
    const fields = [
      {
        name: 'CDTIPOALTEVC',
        label: 'Tipo de alteração',
        type: 'radio',
        required: true,
        valueField: 'value',
        outData: {
          DSTIPOALTEVC: 'label',
        },
        items: [
          {
            label: 'Inclusão',
            value: 'I',
          },
          {
            label: 'Exclusão',
            value: 'E',
          },
        ],
        size: 6,
      },
    ];

    return fields;
  }

  private get fieldsEscala(): Field[] {
    const fields = [
      {
        name: 'DSHISTORICO',
        label: 'Histórico',
        type: 'banner',
        required: false,
        readonly: true,
        rows: 1,
        size: 12,
      },
      {
        name: 'NRESCALATRABM_HIST',
        label: 'Escala de Trabalho',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESCALATRABM',
        valueField: 'NRESCALATRABM',
        items: this.escalas,
        readonly: true,
      },
      {
        name: 'NRTURNO_HIST',
        label: 'Turno',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRDSTURNO',
        valueField: 'NRTURNO',
        items: this.turnos_hist,
        readonly: true,
      },
      {
        name: 'DSHIST',
        label: 'Novas informações',
        type: 'banner',
        required: false,
        readonly: true,
        rows: 1,
        size: 12,
      },
      {
        name: 'DTINIESCALA',
        label: 'Início da Escala',
        type: 'date',
        size: 6,
        required: true,
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
        onInput: () => this.validaDataAnteriorComLimite('DTINIESCALA') && this.getTurnoParOuImpar(),
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
      },
      {
        name: 'NRESCALATRABM',
        label: 'Escala de Trabalho',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESCALATRABM',
        valueField: 'NRESCALATRABM',
        required: true,
        items: this.escalas,
      },
      {
        name: 'CDTIPODIATRABALHO',
        label: 'Turno par ou ímpar',
        type: 'radio',
        valueField: 'value',
        outData: {
          DSTIPODIATRABALHO: 'label',
        },
        items: [
          {
            label: 'Trabalho em dia ímpar',
            value: 'I',
          },
          {
            label: 'Trabalho em dia par',
            value: 'P',
          },
        ],
        size: 6,
        isVisible: this.isEscala12x36,
        required: this.isEscala12x36,
        onInput: this.getTurnoParOuImpar
      },
      {
        name: 'NRTURNO',
        label: 'Turno',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRDSTURNO',
        valueField: 'NRTURNO',
        required: true,
        items: this.turnos,
        readonly: !this.row.NRESCALATRABM || this.isEscala12x36,
      },
    ];

    return fields;
  }

  private get fieldsOcupacao(): Field[] {
    const fields = [
      {
        name: 'DSHISTORICO',
        label: 'Histórico',
        type: 'banner',
        required: false,
        readonly: true,
        rows: 1,
        size: 12,
      },
      {
        name: 'NROCUPACAOM_HIST',
        label: 'Ocupação',
        size: 6,
        type: 'autocomplete',
        valueField: 'NROCUPACAOM',
        descriptionField: 'NRNMOCUPACAO',
        items: this.ocupacoes,
        readonly: true,
      },
      {
        name: 'NRMOTIVOOCUPA_HIST',
        label: 'Motivo',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRMOTIVOOCUPA',
        descriptionField: 'NMMOTIVOOCUPA',
        items: this.motivosOcupa,
        readonly: true,
      },
      {
        name: 'NRTPMODALIDSAL_HIST',
        label: 'Modalidade',
        valueField: 'NRTPMODALIDSAL',
        descriptionField: 'DSTPMODALIDSAL',
        type: 'autocomplete',
        size: 6,
        readonly: true,
        items: [
          {
            NRTPMODALIDSAL: '1',
            DSTPMODALIDSAL: 'Efetivo',
          },
          {
            NRTPMODALIDSAL: '2',
            DSTPMODALIDSAL: 'Comissionado',
          },
          {
            NRTPMODALIDSAL: '11',
            DSTPMODALIDSAL: 'Cenário I',
          },
          {
            NRTPMODALIDSAL: '12',
            DSTPMODALIDSAL: 'Cenário II',
          },
        ],
      },
      {
        name: 'NRTIPOOCUPACAO_HIST',
        label: 'Tipo',
        valueField: 'NRTIPOOCUPACAO',
        descriptionField: 'DSTIPOOCUPACAO',
        type: 'autocomplete',
        size: 6,
        readonly: true,
        items: [
          {
            NRTIPOOCUPACAO: '1',
            DSTIPOOCUPACAO: 'Cargo Efetivo',
          },
          {
            NRTIPOOCUPACAO: '2',
            DSTIPOOCUPACAO: 'Função',
          },
          {
            NRTIPOOCUPACAO: '3',
            DSTIPOOCUPACAO: 'Especialidade',
          },
          {
            NRTIPOOCUPACAO: '4',
            DSTIPOOCUPACAO: 'Cargo Comissionado',
          },
          {
            NRTIPOOCUPACAO: '5',
            DSTIPOOCUPACAO: 'Cargo Amparado/Apostilado',
          },
          {
            NRTIPOOCUPACAO: '6',
            DSTIPOOCUPACAO: 'Cargo Eletivo',
          },
          {
            NRTIPOOCUPACAO: '7',
            DSTIPOOCUPACAO: 'Recrutamento e Seleção',
          },
        ],
      },
      {
        name: 'DSHIST',
        label: 'Novas informações',
        type: 'banner',
        required: false,
        readonly: true,
        rows: 1,
        size: 12,
      },
      {
        name: 'NROCUPACAOM',
        label: 'Ocupação',
        size: 6,
        type: 'autocomplete',
        valueField: 'NROCUPACAOM',
        descriptionField: 'NRNMOCUPACAO',
        items: this.ocupacoes,
        required: true,
      },
      {
        name: 'NRMOTIVOOCUPA',
        label: 'Motivo',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRMOTIVOOCUPA',
        descriptionField: 'NMMOTIVOOCUPA',
        items: this.motivosOcupa,
        required: true,
      },
      {
        name: 'NRTPMODALIDSAL',
        label: 'Modalidade',
        valueField: 'NRTPMODALIDSAL',
        descriptionField: 'DSTPMODALIDSAL',
        type: 'autocomplete',
        size: 6,
        required: true,
        readonly: true,
        items: [
          {
            NRTPMODALIDSAL: '1',
            DSTPMODALIDSAL: 'Efetivo',
          },
          {
            NRTPMODALIDSAL: '2',
            DSTPMODALIDSAL: 'Comissionado',
          },
          {
            NRTPMODALIDSAL: '11',
            DSTPMODALIDSAL: 'Cenário I',
          },
          {
            NRTPMODALIDSAL: '12',
            DSTPMODALIDSAL: 'Cenário II',
          },
        ],
      },
      {
        name: 'NRTIPOOCUPACAO',
        label: 'Tipo',
        valueField: 'NRTIPOOCUPACAO',
        descriptionField: 'DSTIPOOCUPACAO',
        type: 'autocomplete',
        size: 6,
        required: true,
        items: [
          {
            NRTIPOOCUPACAO: '1',
            DSTIPOOCUPACAO: 'Cargo Efetivo',
          },
          {
            NRTIPOOCUPACAO: '2',
            DSTIPOOCUPACAO: 'Função',
          },
          {
            NRTIPOOCUPACAO: '3',
            DSTIPOOCUPACAO: 'Especialidade',
          },
          {
            NRTIPOOCUPACAO: '4',
            DSTIPOOCUPACAO: 'Cargo Comissionado',
          },
          {
            NRTIPOOCUPACAO: '5',
            DSTIPOOCUPACAO: 'Cargo Amparado/Apostilado',
          },
          {
            NRTIPOOCUPACAO: '6',
            DSTIPOOCUPACAO: 'Cargo Eletivo',
          },
          {
            NRTIPOOCUPACAO: '7',
            DSTIPOOCUPACAO: 'Recrutamento e Seleção',
          },
        ],
      },
      {
        label: 'Início Ocupação',
        name: 'DTINIOCUPACAO',
        type: 'date',
        size: 6,
        required: true,
        month: true,
        onInput: () => this.validaDataAnteriorCompetencia('DTINIOCUPACAO'),
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
      },
      {
        name: 'DSOBSALTEOCUPACAO',
        label: 'Justificativa',
        type: 'textarea',
        required: false,
        rows: 2,
        size: 12,
      },
    ];

    return fields;
  }

  public get defaultRowOcupacao(): any {
    const defaultOcupacao = {
      DTINIOCUPACAO: this.getDataInicialPorRegra(),
      DTALTESALARIO: this.getDataInicialPorRegra(),
      NROCORRENCIA: 1,
    };

    return defaultOcupacao;
  }

  private get fieldsSalario(): Field[] {
    const fields = [
      {
        name: 'DSHISTORICO',
        label: 'Histórico',
        type: 'banner',
        required: false,
        readonly: true,
        rows: 1,
        size: 12,
      },
      {
        name: 'VRSALARIOATUAL_HIST',
        label: 'Salário Atual',
        type: 'text',
        size: 4,
        readonly: true,
      },
      {
        name: 'IDTPSALARIO_HIST',
        label: 'Tipo de Salário',
        valueField: 'IDTPSALARIO',
        descriptionField: 'DSTPSALARIO',
        type: 'autocomplete',
        size: 4,
        readonly: true,
        items: [
          {
            IDTPSALARIO: 'MENSAL',
            DSTPSALARIO: 'Mensal',
          },
          {
            IDTPSALARIO: 'QUINZENAL',
            DSTPSALARIO: 'Quinzenal',
          },
          {
            IDTPSALARIO: 'SEMANAL',
            DSTPSALARIO: 'Semanal',
          },
          {
            IDTPSALARIO: 'DIARIO',
            DSTPSALARIO: 'Diário',
          },
          {
            IDTPSALARIO: 'HORA',
            DSTPSALARIO: 'Hora',
          },
          {
            IDTPSALARIO: 'TAREFA',
            DSTPSALARIO: 'Tarefa',
          },
        ],
      },
      {
        name: 'NRTIPOALTERA_HIST',
        label: 'Tipo de Alteração',
        size: 4,
        type: 'autocomplete',
        valueField: 'NRTIPOALTERA',
        descriptionField: 'NMTIPOALTERA',
        items: this.tiposAlteraSal,
        readonly: true,
      },
      {
        name: 'DSHIST',
        label: 'Novas informações',
        type: 'banner',
        required: false,
        readonly: true,
        rows: 1,
        size: 12,
      },
      {
        name: 'PERCALTERA',
        label: 'Percentual Real(%)',
        type: 'text',
        size: 6,
        readonly: true,
      },
      {
        name: 'VRSALARIO',
        label: 'Salário',
        type: 'number',
        size: 6,
        required: true,
      },
      {
        name: 'IDTPSALARIO',
        label: 'Tipo de Salário',
        valueField: 'IDTPSALARIO',
        descriptionField: 'DSTPSALARIO',
        type: 'autocomplete',
        size: 6,
        required: true,
        items: [
          {
            IDTPSALARIO: 'MENSAL',
            DSTPSALARIO: 'Mensal',
          },
          {
            IDTPSALARIO: 'QUINZENAL',
            DSTPSALARIO: 'Quinzenal',
          },
          {
            IDTPSALARIO: 'SEMANAL',
            DSTPSALARIO: 'Semanal',
          },
          {
            IDTPSALARIO: 'DIARIO',
            DSTPSALARIO: 'Diário',
          },
          {
            IDTPSALARIO: 'HORA',
            DSTPSALARIO: 'Hora',
          },
          {
            IDTPSALARIO: 'TAREFA',
            DSTPSALARIO: 'Tarefa',
          },
        ],
      },
      {
        name: 'NRTIPOALTERA',
        label: 'Tipo de Alteração',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRTIPOALTERA',
        descriptionField: 'NMTIPOALTERA',
        items: this.tiposAlteraSal,
        required: true,
      },
      {
        name: 'NRTPMODALIDSAL',
        label: 'Modalidade Salário',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRTPMODALIDSAL',
        descriptionField: 'NMTPMODALIDSAL',
        items: this.modalidadesSal,
        defaultValue: 1,
        required: true,
        readonly: true,
      },
      {
        name: 'NROCORRENCIA',
        label: 'Nr. Ocorrencia',
        type: 'text',
        size: 3,
        required: true,
        defaultValue: 1,
        readonly: true,
      },
      {
        name: 'DTALTESALARIO',
        label: 'Data da Alteração',
        type: 'date',
        size: 3,
        month: true,
        required: true,
        onInput: () => this.validaDataAnteriorCompetencia('DTALTESALARIO'),
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
      },
      {
        name: 'DSOBSALTESALARIO',
        label: 'Justificativa',
        type: 'textarea',
        required: false,
        rows: 2,
        size: 12,
      }
    ];

    return fields;
  }

  get defaultRowSalario(): any {
    const defaultSalario = {
      NROCORRENCIA: 1,
      DTALTESALARIO: this.getDataInicialPorRegra(),
    };

    return defaultSalario;
  }
  private get fieldsDesligamento(): Field[] {
    const fields = [
      {
        name: 'NRTPAVIPRE',
        label: 'Tipo de Aviso Prévio',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRTPAVIPRE',
        descriptionField: 'DSTPAVIPRE',
        items: this.tiposAviso,
        required: this.isAvisoPrevioRequired,
        readonly: this.isEmPeriodoExperiencia
      },
      {
        name: 'NRTPDEMISSAO',
        label: 'Tipo de Demissão',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRTPDEMISSAO',
        descriptionField: 'NMABREV',
        items: this.tiposDemissao,
        required: true,
        onInput: () => {
          this.calcularDtProjetada();
          this.limpaDtAvisoPrevio();
        }
      },
      {
        name: 'NRMOTIVORESC',
        label: 'Motivo da Rescisão',
        size: 12,
        type: 'autocomplete',
        valueField: 'NRMOTIVORESC',
        descriptionField: 'NMMOTIVORESC',
        items: this.motivosRescisao,
      },
      {
        name: 'DTAVISOPREVIO',
        label: 'Data da Solicitação de Desligamento',
        type: 'date',
        size: 4,
        required: this.row.NRTPDEMISSAO !== '3' ? true : false,
        readonly: this.row.NRTPDEMISSAO !== '3' ? false : true,
        onInput: () => {
          this.validaDataAnteriorCompetencia('DTAVISOPREVIO');
          this.setDateRescicao();
          this.validaPeriodoEstab();
          this.validaAvisoPrevio();
        },
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
      },
      {
        name: 'DTRESCISAOVINC',
        label: 'Data do Último Dia Efetivamente Trabalhado',
        type: 'date',
        size: 4,
        required: true,
        readonly: this.row.NRTPDEMISSAO !== '3' ? true : false,
        onInput: () => {
          this.validaAvisoPrevio();
        }
      },
      {
        name: 'DTRESCISAOPROJETADA',
        label: 'Dt. Rescisão Projetada',
        type: 'date',
        size: 4,
        readonly: true,
      },
      {
        name: 'CDREPOSICAOVAGA',
        label: 'Reposição de Vaga',
        type: 'radio',
        valueField: 'value',
        defaultValue: 'N',
        outData: {
          DSREPOSICAOVAGA: 'label',
        },
        items: [
          {
            label: 'Sim',
            value: 'S',
          },
          {
            label: 'Não',
            value: 'N',
          },
        ],
        size: 4,
      },
      {
        name: 'CDPESSOANAOGRATA',
        label: 'Pessoa não Grata',
        type: 'radio',
        valueField: 'value',
        outData: {
          DSPESSOANAOGRATA: 'label',
        },
        items: [
          {
            label: 'Sim',
            value: 'S',
          },
          {
            label: 'Não',
            value: 'N',
          },
        ],
        size: 4,
        oninput: this.handleChangePessoaNaoGrata
      },
      {
        name: 'CDPOSSUIBENSDAEMPRESA',
        label: 'Possui bens da Empresa (Celular, Notebook e etc)',
        type: 'radio',
        valueField: 'value',
        outData: {
          DSPOSSUIBENSDAEMPRESA: 'label',
        },
        items: [
          {
            label: 'Sim',
            value: 'S',
          },
          {
            label: 'Não',
            value: 'N',
          },
        ],
        size: 4,
      },
      {
        name: 'DSOBSERVACAODESLIGAMENTO',
        label: 'Justificativa',
        type: 'textarea',
        isVisible: this.row.CDPESSOANAOGRATA === 'S',
        required: false,
        rows: 2,
        size: 12,
      },
      {
        name: 'NRCEPENDERECO',
        label: 'Número do CEP',
        type: 'text',
        isVisible: false,
        required: false,
        rows: 2,
        size: 12,
      },
      {
        name: 'CDTIPOENDERECO',
        label: 'CD. Tipo Endereço',
        type: 'text',
        isVisible: false,
        required: false,
        rows: 2,
        size: 12,
      },
      {
        name: 'NMPAIS',
        label: 'País',
        type: 'text',
        isVisible: false,
        required: false,
        rows: 2,
        size: 12,
      },
      {
        name: 'SGESTADO',
        label: 'Sg. Estado',
        type: 'text',
        isVisible: false,
        required: false,
        rows: 2,
        size: 12,
      },
      {
        name: 'NMESTADO',
        label: 'Estado',
        type: 'text',
        isVisible: false,
        required: false,
        rows: 2,
        size: 12,
      },
      {
        name: 'NMMUNICIPIO',
        label: 'Município',
        type: 'text',
        isVisible: false,
        required: false,
        rows: 2,
        size: 12,
      },
      {
        name: 'NMBAIRROENDERECO',
        label: 'Bairro',
        type: 'text',
        isVisible: false,
        required: false,
        rows: 2,
        size: 12,
      },
      {
        name: 'DSLOGRADOURO',
        label: 'Ds. Logradouro',
        type: 'text',
        isVisible: false,
        required: false,
        rows: 2,
        size: 12,
      },
      {
        name: 'DSENDERECO',
        label: 'Endereço',
        type: 'text',
        isVisible: false,
        required: false,
        rows: 2,
        size: 12,
      },
      {
        name: 'NRIMOVELENDERECO',
        label: 'Nr Imovel',
        type: 'text',
        isVisible: false,
        required: false,
        rows: 2,
        size: 12,
      },
      {
        name: 'DSCOMPLEENDERECO',
        label: 'Complemento Imovel',
        type: 'text',
        isVisible: false,
        required: false,
        rows: 2,
        size: 12,
      },
    ];

    return fields;
  }

  private get fieldsDependente(): Field[] {
    const fields = [
      {
        name: 'NRTIPORELACIONA',
        label: 'Tipo Relacionamento',
        type: 'autocomplete',
        size: 4,
        descriptionField: 'NMTIPORELACIONA',
        valueField: 'NRTIPORELACIONA',
        items: this.tiposRelacionamento,
        required: true,
      },
      {
        name: 'NMPESSOADEP',
        label: 'Nome',
        type: 'text',
        size: 8,
        required: true,
      },
      {
        name: 'DTNASCIFUNDPARC',
        label: 'Data de Nascimento',
        type: 'date',
        size: 4,
        required: this.filhoIsSelected,
      },
      {
        name: 'IDSEXOPESSOA',
        label: 'Sexo',
        type: 'select',
        size: 4,
        descriptionField: 'DSSEXOPESSOA',
        valueField: 'IDSEXOPESSOA',
        items: [
          {
            DSSEXOPESSOA: 'Feminino',
            IDSEXOPESSOA: 'F',
          },
          {
              DSSEXOPESSOA: 'Masculino',
              IDSEXOPESSOA: 'M',
          },
        ],
        required: true,
      },
      {
        name: 'NRCPFDEP',
        label: 'CPF',
        type: 'text',
        size: 4,
        mask: '###.###.###-##',
        required: this.filhoIsSelected,
      },
    ];

    return fields;
  }

  public get defaultRowEscala(): any {
    const defaultEscala = {
      DTINIESCALA: this.row.NRTIPOSOLICITACAO == TiposSolicitacao.TP_SOLI_MOVIM_GERENCIAL
        ? (this.isEdit ? this.row.DTINIESCALA : null)
        : (this.isEdit ? this.row.DTINIESCALA : this.getDataInicialPorRegra()),
    };
  
    return defaultEscala;
  }

  private get fieldsVT(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRLINHATRANSP',
        label: 'Linha',
        type: 'autocomplete',
        valueField: 'NRLINHATRANSP',
        descriptionField: 'NRDSLINHATRANSP',
        size: 4,
        required: true,
        items: this.linhas,
      },
      {
        name: 'NRTIPOLINHAVINC',
        label: 'Tipo de Linha',
        type: 'autocomplete',
        valueField: 'NRTIPOLINHAVINC',
        descriptionField: 'DSTIPOLINHAVINC',
        size: 4,
        required: true,
        items: this.tiposLinha,
      },
      {
        name: 'VRTARIFA',
        label: 'Valor',
        type: 'text',
        size: 2,
        readonly: true,
      },
      {
        name: 'QTLINHATARIFA',
        label: 'Quantidade',
        type: 'number',
        size: 2,
        required: true,
      },
      {
        name: 'NRLINHATRANSP_2',
        label: 'Linha (2)',
        type: 'autocomplete',
        valueField: 'NRLINHATRANSP',
        descriptionField: 'NRDSLINHATRANSP',
        size: 4,
        required: false,
        items: this.linhas,
      },
      {
        name: 'NRTIPOLINHAVINC_2',
        label: 'Tipo de Linha (2)',
        type: 'autocomplete',
        valueField: 'NRTIPOLINHAVINC',
        descriptionField: 'DSTIPOLINHAVINC',
        size: 4,
        required: false,
        items: this.tiposLinha,
      },
      {
        name: 'VRTARIFA_2',
        label: 'Valor',
        type: 'text',
        size: 2,
        readonly: true,
      },
      {
        name: 'QTLINHATARIFA_2',
        label: 'Quantidade (2)',
        type: 'number',
        size: 2,
        required: this.isRequiredVT[2],
      },
      {
        name: 'NRLINHATRANSP_3',
        label: 'Linha (3)',
        type: 'autocomplete',
        valueField: 'NRLINHATRANSP',
        descriptionField: 'NRDSLINHATRANSP',
        size: 4,
        required: false,
        items: this.linhas,
      },
      {
        name: 'NRTIPOLINHAVINC_3',
        label: 'Tipo de Linha (3)',
        type: 'autocomplete',
        valueField: 'NRTIPOLINHAVINC',
        descriptionField: 'DSTIPOLINHAVINC',
        size: 4,
        required: false,
        items: this.tiposLinha,
      },
      {
        name: 'VRTARIFA_3',
        label: 'Valor',
        type: 'text',
        size: 2,
        readonly: true,
      },
      {
        name: 'QTLINHATARIFA_3',
        label: 'Quantidade (3)',
        type: 'number',
        size: 2,
        required: this.isRequiredVT[3],
      },
      {
        name: 'NRLINHATRANSP_4',
        label: 'Linha (4)',
        type: 'autocomplete',
        valueField: 'NRLINHATRANSP',
        descriptionField: 'NRDSLINHATRANSP',
        size: 4,
        required: false,
        items: this.linhas,
      },
      {
        name: 'NRTIPOLINHAVINC_4',
        label: 'Tipo de Linha (4)',
        type: 'autocomplete',
        valueField: 'NRTIPOLINHAVINC',
        descriptionField: 'DSTIPOLINHAVINC',
        size: 4,
        required: false,
        items: this.tiposLinha,
      },
      {
        name: 'VRTARIFA_4',
        label: 'Valor',
        type: 'text',
        size: 2,
        readonly: true,
      },
      {
        name: 'QTLINHATARIFA_4',
        label: 'Quantidade (4)',
        type: 'number',
        size: 2,
        required: this.isRequiredVT[4],
      },
      {
        name: 'NRLINHATRANSP_5',
        label: 'Linha (5)',
        type: 'autocomplete',
        valueField: 'NRLINHATRANSP',
        descriptionField: 'NRDSLINHATRANSP',
        size: 4,
        required: false,
        items: this.linhas,
      },
      {
        name: 'NRTIPOLINHAVINC_5',
        label: 'Tipo de Linha (5)',
        type: 'autocomplete',
        valueField: 'NRTIPOLINHAVINC',
        descriptionField: 'DSTIPOLINHAVINC',
        size: 4,
        required: false,
        items: this.tiposLinha,
      },
      {
        name: 'VRTARIFA_5',
        label: 'Valor',
        type: 'text',
        size: 2,
        readonly: true,
      },
      {
        name: 'QTLINHATARIFA_5',
        label: 'Quantidade (5)',
        type: 'number',
        size: 2,
        required: this.isRequiredVT[5],
      },
      {
        name: 'NRLINHATRANSP_6',
        label: 'Linha (6)',
        type: 'autocomplete',
        valueField: 'NRLINHATRANSP',
        descriptionField: 'NRDSLINHATRANSP',
        size: 4,
        required: false,
        items: this.linhas,
      },
      {
        name: 'NRTIPOLINHAVINC_6',
        label: 'Tipo de Linha (6)',
        type: 'autocomplete',
        valueField: 'NRTIPOLINHAVINC',
        descriptionField: 'DSTIPOLINHAVINC',
        size: 4,
        required: false,
        items: this.tiposLinha,
      },
      {
        name: 'VRTARIFA_6',
        label: 'Valor',
        type: 'text',
        size: 2,
        readonly: true,
      },
      {
        name: 'QTLINHATARIFA_6',
        label: 'Quantidade (6)',
        type: 'number',
        size: 2,
        required: this.isRequiredVT[6],
      },
      {
        name: 'NRLINHATRANSP_7',
        label: 'Linha (7)',
        type: 'autocomplete',
        valueField: 'NRLINHATRANSP',
        descriptionField: 'NRDSLINHATRANSP',
        size: 4,
        required: false,
        items: this.linhas,
      },
      {
        name: 'NRTIPOLINHAVINC_7',
        label: 'Tipo de Linha (7)',
        type: 'autocomplete',
        valueField: 'NRTIPOLINHAVINC',
        descriptionField: 'DSTIPOLINHAVINC',
        size: 4,
        required: false,
        items: this.tiposLinha,
      },
      {
        name: 'VRTARIFA_7',
        label: 'Valor',
        type: 'text',
        size: 2,
        readonly: true,
      },
      {
        name: 'QTLINHATARIFA_7',
        label: 'Quantidade (7)',
        type: 'number',
        size: 2,
        required: this.isRequiredVT[7],
      },
      {
        name: 'NRLINHATRANSP_8',
        label: 'Linha (8)',
        type: 'autocomplete',
        valueField: 'NRLINHATRANSP',
        descriptionField: 'NRDSLINHATRANSP',
        size: 4,
        required: false,
        items: this.linhas,
      },
      {
        name: 'NRTIPOLINHAVINC_8',
        label: 'Tipo de Linha (8)',
        type: 'autocomplete',
        valueField: 'NRTIPOLINHAVINC',
        descriptionField: 'DSTIPOLINHAVINC',
        size: 4,
        required: false,
        items: this.tiposLinha,
      },
      {
        name: 'VRTARIFA_8',
        label: 'Valor',
        type: 'text',
        size: 2,
        readonly: true,
      },
      {
        name: 'QTLINHATARIFA_8',
        label: 'Quantidade (8)',
        type: 'number',
        size: 2,
        required: this.isRequiredVT[8],
      },
      {
        name: 'NRSENTIDOLINHA',
        label: 'Sentido da Linha',
        type: 'autocomplete',
        valueField: 'NRSENTIDOLINHA',
        descriptionField: 'DSSENTIDOLINHA',
        size: 6,
        required: this.isInclusaoVT,
        items: this.sentidosLinha,
        readonly: !this.isInclusaoVT
      },
      {
        name: 'DTINILINHAVINC',
        label: 'Início de Validade',
        type: 'date',
        size: 3,
        required: this.isInclusaoVT,
        onInput: () => this.validaDataAnteriorCompetencia('DTINILINHAVINC'),
        readonly: !this.isInclusaoVT,
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
      },
      {
        name: 'DTFIMLINHAVINC',
        label: 'Fim de Validade',
        type: 'date',
        size: 3,
        required: !this.isInclusaoVT
      },
      {
        name: 'DSOBSLINHAVINC',
        label: 'Justificativa da alteração',
        type: 'textarea',
        required: true,
        rows: 2,
        size: 6,
      },
    ];

    return fields;
  }

  private get fieldsBeneficio(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRBENEFICIOM',
        label: 'Benefício',
        type: 'autocomplete',
        size: 6,
        required: true,
        valueField: 'NRBENEFICIOM',
        descriptionField: 'NRDSBENEFICIO',
        items: this.beneficios,
      },
      {
        name: 'DTINSCBENEFICIARIO',
        label: 'Data de Inscrição',
        type: 'date',
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
        required: true,
      },
      {
        name: 'NRPESSOA',
        label: 'Pessoa',
        type: 'autocomplete',
        size: 6,
        required: true,
        valueField: 'NRPESSOA',
        descriptionField: 'DSRELACIONA',
        items: this.pessoas,
      },
      {
        name: 'IDTPBENEFICIARIO',
        label: 'Tipo do Beneficiário',
        type: 'select',
        size: 6,
        required: true,
        valueField: 'value',
        descriptionField: 'name',
        items: [
          {
            name: 'Titular',
            value: 'T',
          },
          {
            name: 'Dependente',
            value: 'D',
          },
        ],
      },
      {
        name: 'NRBENEFICIOM_2',
        label: 'Benefício (2)',
        type: 'autocomplete',
        size: 6,
        required: false,
        valueField: 'NRBENEFICIOM',
        descriptionField: 'NRDSBENEFICIO',
        items: this.beneficios,
      },
      {
        name: 'DTINSCBENEFICIARIO_2',
        label: 'Data de Inscrição (2)',
        type: 'date',
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
        required: false,
      },
      {
        name: 'NRPESSOA_2',
        label: 'Pessoa (2)',
        type: 'autocomplete',
        size: 6,
        required: false,
        valueField: 'NRPESSOA',
        descriptionField: 'DSRELACIONA',
        items: this.pessoas,
      },
      {
        name: 'IDTPBENEFICIARIO_2',
        label: 'Tipo do Beneficiário (2)',
        type: 'select',
        size: 6,
        required: false,
        valueField: 'value',
        descriptionField: 'name',
        items: [
          {
            name: 'Titular',
            value: 'T',
          },
          {
            name: 'Dependente',
            value: 'D',
          },
        ],
      },
      {
        name: 'NRBENEFICIOM_3',
        label: 'Benefício (3)',
        type: 'autocomplete',
        size: 6,
        required: false,
        valueField: 'NRBENEFICIOM',
        descriptionField: 'NRDSBENEFICIO',
        items: this.beneficios,
      },
      {
        name: 'DTINSCBENEFICIARIO_3',
        label: 'Data de Inscrição (3)',
        type: 'date',
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
        required: false,
      },
      {
        name: 'NRPESSOA_3',
        label: 'Pessoa (3)',
        type: 'autocomplete',
        size: 6,
        required: false,
        valueField: 'NRPESSOA',
        descriptionField: 'DSRELACIONA',
        items: this.pessoas,
      },
      {
        name: 'IDTPBENEFICIARIO_3',
        label: 'Tipo do Beneficiário (3)',
        type: 'select',
        size: 6,
        required: false,
        valueField: 'value',
        descriptionField: 'name',
        items: [
          {
            name: 'Titular',
            value: 'T',
          },
          {
            name: 'Dependente',
            value: 'D',
          },
        ],
      },
      {
        name: 'NRBENEFICIOM_4',
        label: 'Benefício (4)',
        type: 'autocomplete',
        size: 6,
        required: false,
        valueField: 'NRBENEFICIOM',
        descriptionField: 'NRDSBENEFICIO',
        items: this.beneficios,
      },
      {
        name: 'DTINSCBENEFICIARIO_4',
        label: 'Data de Inscrição (4)',
        type: 'date',
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
        required: false,
      },
      {
        name: 'NRPESSOA_4',
        label: 'Pessoa (4)',
        type: 'autocomplete',
        size: 6,
        required: false,
        valueField: 'NRPESSOA',
        descriptionField: 'DSRELACIONA',
        items: this.pessoas,
      },
      {
        name: 'IDTPBENEFICIARIO_4',
        label: 'Tipo do Beneficiário (4)',
        type: 'select',
        size: 6,
        required: false,
        valueField: 'value',
        descriptionField: 'name',
        items: [
          {
            name: 'Titular',
            value: 'T',
          },
          {
            name: 'Dependente',
            value: 'D',
          },
        ],
      },
    ];

    return fields;
  }

  private get validate(): (setErrorColor?: boolean) => boolean {
    return (this.$refs.form as any).validate;
  }

  private get filhoIsSelected(): boolean {
    const tiposFilho = ['3', '100001'];
    const isSelected = tiposFilho.includes(this.row.NRTIPORELACIONA);

    return isSelected;
  }

  private get fieldsPessoal(): Field[] {
    const fields: Field[] = [
      {
        name: 'NMPROCESSO',
        label: 'Nome do Processo',
        type: 'text',
        size: 6,
        required: true,
      },
      {
        name: 'NRTEMPLATE',
        label: 'Template',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMTEMPLATE',
        valueField: 'NRTEMPLATE',
        items: this.templates,
      },
      {
        name: 'NRTIPOPROCESSO',
        label: 'Tipo de Processo',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMTIPOPROCESSO',
        valueField: 'NRTIPOPROCESSO',
        items: this.tiposProcesso,
      },
      {
        name: 'DSMOTIVO',
        label: 'Motivo',
        type: 'text',
        size: 6,
      },
      {
        name: 'LOCALIDADE',
        label: 'Localidade',
        type: 'text',
        size: 6,
      },
      {
        name: 'DSDESCRICAO',
        label: 'Descrição (Competências)',
        type: 'textarea',
        size: 12,
        rows: 2,
      },
      {
        name: 'DTSOLICITA',
        label: 'Disponível desde',
        type: 'date',
        size: 3,
        required: true,
        onInput: () => this.validaDataAnteriorCompetencia('DTSOLICITA'),
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
      },
      {
        name: 'DTLIMSOLICITA',
        label: 'Disponível até',
        type: 'date',
        size: 3,
        required: true,
      },
      {
        name: 'NRVAGAS',
        label: 'Número de Vagas',
        type: 'number',
        size: 3,
        required: true,
      },
      {
        name: 'IDPUBLICAVAGA',
        label: 'Publicar Vaga',
        type: 'checkbox',
        size: 3,
        valueToTrue: 'S',
        valueToFalse: 'N',
      },
      {
        name: 'NROCUPACAOM',
        label: 'Ocupação (Cargo)',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'NRNMOCUPACAO',
        valueField: 'NROCUPACAOM',
        items: this.ocupacoes,
      },
      {
        name: 'NRESTRUTURAM',
        label: 'Estrutura',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.estruturasGerenciais,
      },
    ];

    return fields;
  }

  private get vinculoIsReadonly(): boolean {
    return this.isEdit || !this.row.NRTIPOSOLICITACAO;
  }

  private get vinculoIsNotVisible(): boolean {
    const tipoSelecionado: string = this.row.NRTIPOSOLICITACAO;
  
    const existNrvinculom = this.user.nrvinculom;
    const existSoli = this.TP_SOLICITACAO_VINC_NOT_VISIBLE.includes(tipoSelecionado);
    const notVisible = existSoli && !!existNrvinculom;

    if(notVisible) {
      this.row.NRVINCULOM = this.user.nrvinculom;
    }

    return !notVisible;
  }

  private get tipoSolicitacaoIsReadonly(): boolean {
    return this.isEdit;
  }

  private get dataSolicitacaoIsReadonly(): boolean {
    let readonly = false;
    if(this.isEdit) {
      readonly = true;
    } else {
      readonly = false;
    }

    return readonly;
  }

  

  public get defaultRowTransferenciaGeren(): any {
    const defaultTransferencia = {
      DTINIMOVIMENT: this.defaultDtInitMoviment,
    };

    return defaultTransferencia;
  }

  public get defaultRowTransferenciaLegal(): any {
    const defaultTransferencia = {
      DTINIMOVIMENT: this.defaultDtInitMoviment,
      NROCORRENCIA: 1
    };

    return defaultTransferencia;
  }


  private get defaultDtInitMoviment(): string | null {
    const regra = this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO;
    const baseDate = new Date();
  
  
    let base: Date;
    switch (regra) {
      case 'P':
        base = startOfMonth(addMonths(baseDate, 1));
        break;
      case 'A':
        base = startOfMonth(baseDate);
        break;
      default:
        base = DateUtil.parseDate(DateUtil.getDateCompetenc());
        break;
    }
  
    const dtAdmissaoStr = this.row.DTADMISSAOVINC;
    if (!dtAdmissaoStr) {
      return format(base, 'dd/MM/yyyy');
    }
  
    const dtAdmissao = parse(dtAdmissaoStr, 'dd/MM/yyyy', new Date());
  
    const admissaoAntesDaDtBase = isBefore(dtAdmissao, base);
  
    return admissaoAntesDaDtBase ? format(base, 'dd/MM/yyyy') : null;
  }
  

  private get fieldsTreinamento(): Field[] {
    const fields: Field[] = [
      {
        name: 'NMTREINAMENTO',
        label: 'Nome',
        type: 'text',
        size: 6,
        required: true
      },
      {
        name: 'NRCURSO',
        label: 'Curso',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'NMCURSO',
        valueField: 'NRCURSO',
        items: this.cursos,
      },
      {
        name: 'NRPERFACESAPROV',
        label: 'Perfil de Aprovação',
        type: 'autocomplete',
        size: 6,
        required: false,
        descriptionField: 'NMPERFILACESSO',
        valueField: 'NRPERFILACESSO',
        items: this.perfisAcesso,
      },
      {
        name: 'NRMETODOTRE',
        label: 'Método',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'NMMETODOTRE',
        valueField: 'NRMETODOTRE',
        items: this.metodos,
      },
      {
        name: 'NRPERFACESEXEC',
        label: 'Perfil de Execução',
        type: 'autocomplete',
        size: 6,
        required: false,
        descriptionField: 'NMPERFILACESSO',
        valueField: 'NRPERFILACESSO',
        items: this.perfisAcesso,
      },
      {
        name: 'IDTREINAMENTOINT',
        label: 'Treinamento Interno',
        type:'checkbox',
        size: 6,
        valueToTrue: 'S',
        valueToFalse: 'N',
      },
      {
        name: 'DTINIPLANEJADOTRE',
        label: 'Início Planejado',
        type: 'date',
        size: 6,
        required: true,
        onInput: () => this.validaDataAnteriorCompetencia('DTINIPLANEJADOTRE'),
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
      },
      {
        name: 'DTFIMPLANEJADOTRE',
        label: 'Fim Planejado',
        type: 'date',
        size: 6,
        required: true,
      },
    ];

    return fields;
  }

  private get fieldsAprovaHE(): Field[] {
    const fields: Field[] = [
      {
        name: 'DTAPROVAHE',
        label: 'Data da Realização das Horas Extras',
        type: 'date',
        size: 6,
        required: true,
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
      },
      {
        name: 'QTINIHOR',
        label: 'Hora Inicio',
        size: 3,
        type: 'text',
        mask: '##:##',
        required: true,
      },
      {
        name: 'QTFIMHOR',
        label: 'Hora Fim',
        size: 3,
        type: 'text',
        mask: '##:##',
        required: true,
      },
    ];

    return fields;
  }

  private get fieldsReembolso(): Field[] {
    const fields: Field[] = [
      {
        name: 'VRREEMBOLSO',
        label: 'Valor do Reembolso',
        type: 'number',
        size: 6,
        required: true
      },
      {
        name: 'DTMESCOMPETENC',
        label: 'Mês de referência',
        type: 'date',
        month: true,
        size: 6,
        required: true,
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
      }
    ];

    return fields;
  }

  private get defaultRowAdvertencia(): any {
    const defaultAdvertencia = {
      DTALTEADVERTENCIA: this.getDataInicialPorRegra(),
    };

    return defaultAdvertencia;
  }

  private get fieldsAdvertencia(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRSITUFUNCM',
        label: 'Situacação Funcional',
        size: 9,
        type: 'autocomplete',
        valueField: 'NRSITUFUNCM',
        descriptionField: 'NMSITUFUNCH',
        items: [
          {
            NMSITUFUNCH: 'Suspensão',
            NRSITUFUNCM: '100051',
          },
        ],
        required: true,
      },
      {
        label: 'Data Início',
        name: 'DTINISITUFUNC',
        type: 'date',
        size: 4,
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
        required: true,
      },
      {
        name: 'NRQTDIASITUFUNC',
        label: 'Qtde de Dias',
        type: 'number',
        size: 4,
        required: true,
        min: 1,
      },
      {
        label: 'Data Final',
        name: 'DTFIMSITUFUNC',
        type: 'date',
        size: 4,
        required: true,
        readonly: true,
      },
    ];

    return fields;
  }

  private get fieldsAdvertenciaAnotVinc(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRSITUFUNCM',
        label: 'Situacação Funcional',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRSITUFUNCM',
        descriptionField: 'NMSITUFUNCH',
        items: [
          {
            NMSITUFUNCH: 'Advertência',
            NRSITUFUNCM: '18',
          },
          {
            NMSITUFUNCH: 'Suspensão',
            NRSITUFUNCM: '100051',
          },
        ],
        required: true,
      },
      {
        name: 'NRTIPOANOTACAO',
        label: 'Tipo da Anotação',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRTIPOANOTACAO',
        descriptionField: 'NMTIPOANOTACAO',
        items: this.tiposAnotacao,
        required: true,
      },
      {
        label: 'Data Início',
        name: 'DTINISITUFUNC',
        type: 'date',
        size: 4,
        required: true,
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
      },
      {
        name: 'NRQTDIASITUFUNC',
        label: 'Qtde de Dias',
        type: 'number',
        size: 4,
        required: true,
        min: 1,
        readonly: (this.row.NRSITUFUNCM && this.row.NRSITUFUNCM == '18')
      },
      {
        label: 'Data Final',
        name: 'DTFIMSITUFUNC',
        type: 'date',
        size: 4,
        required: true,
        readonly: true,
      },
      {
        label: 'Observação',
        name: 'DSANOTACAO',
        type: 'textarea',
        size: 12,
        rows: 2,
        required: false,
      },
    ];

    return fields;
  }

  private get defaultRowVCombust(): any {
    const defaultVCombust = {
      QTBENEFICIO: 1
    };

    return defaultVCombust;
  }

  private get fieldsVC(): Field[] {
    const fields: Field[] = [
      {
        name: 'TPPERIODOBENEF',
        label: 'Período Benefício',
        type: 'select',
        size: 6,
        descriptionField: 'DSPERIODOBENEF',
        valueField: 'TPPERIODOBENEF',
        items: [
          {
            DSPERIODOBENEF: 'Mensal',
            TPPERIODOBENEF: 'MENSAL',
          },
          {
            DSPERIODOBENEF: 'Diário',
            TPPERIODOBENEF: 'DIARIO',
          },
        ],
      },
      {
        name: 'NRBENEFICIOM',
        label: 'Tipo do vale',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRDSBENEFICIO',
        valueField: 'NRBENEFICIOM',
        required: true,
        items: this.beneficiosFiltrados
      },
      {
        name: 'QTBENEFICIO',
        label: this.row.CDTIPOVC == 'V' ? 'Qtd. Benefício' : 'Qtd. por KM',
        type: 'number',
        size: 6,
        required: this.isInclusaoVC,
        readonly: !this.isInclusaoVC || this.row.CDTIPOVC == 'V'
      },
      {
        name: 'VRBENEFICIO',
        label: 'Vr. Benefício',
        type: 'number',
        size: 6,
        required: this.isInclusaoVC,
        readonly: !this.isInclusaoVC,
        isVisible: this.row.CDTIPOVC == 'V'
      },
      {
        name: 'DTINSCBENEFICIARIO',
        label: 'Início de Validade',
        type: 'date',
        size: this.row.CDTIPOVC == 'V' ? 6 : 3,
        required: this.isInclusaoVC,
        onInput: () => this.validaDataAnteriorCompetencia('DTINSCBENEFICIARIO'),
        readonly: !this.isInclusaoVC,
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
      },
      {
        name: 'DTCANCBENEFICIARIO',
        label: 'Fim de Validade',
        type: 'date',
        size: this.row.CDTIPOVC == 'V' ? 6 : 3,
        required: !this.isInclusaoVC
      },
      {
        name: 'DSOBSBENEFICIARIO',
        label: 'Justificativa da alteração',
        type: 'textarea',
        required: false,
        rows: 2,
        size: 12,
      },
    ];

    return fields;
  }

  private get fieldsAuxilioMoradia(): Field[] {
    const fields: Field[] = [
      {
        name: 'VREVENTOFIXO',
        label: 'Valor do Benefício',
        type: 'number',
        size: 6,
        required: true,
      },
      {
        name: 'DTINIVIGENCIA',
        label: 'Início de Validade',
        type: 'date',
        size: 3,
        onInput: () => this.validaDataAnteriorCompetencia('DTINIVIGENCIA'),
        required: true,
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
      },
      {
        name: 'DTFIMVIGENCIA',
        label: 'Fim de Validade',
        type: 'date',
        size: 3,
      },
      {
        name: 'DSOBSERVACAOAUXIMORADIA',
        label: 'Justificativa da alteração',
        type: 'textarea',
        required: false,
        rows: 2,
        size: 6,
      },
    ];

    return fields;
  }

  private get defaultRowAuxilioMoradia(): any {
    const defaultAuxilioMoradia = {
      NREVENTOM: "100106712 - Auxilio Moradia", 
      IDTIPOMOVIMENTO: "1 - Mensal"
    };

    return defaultAuxilioMoradia;
  }


  private get fieldsVManutencao(): Field[] {
    const fields: Field[] = [
      {
        name: 'TPPERIODOBENEF',
        label: 'Período Benefício',
        type: 'select',
        size: 4,
        descriptionField: 'DSPERIODOBENEF',
        valueField: 'TPPERIODOBENEF',
        items: [
          {
            DSPERIODOBENEF: 'Mensal',
            TPPERIODOBENEF: 'MENSAL',
          },
          {
            DSPERIODOBENEF: 'Diário',
            TPPERIODOBENEF: 'DIARIO',
          },
        ],
      },
      {
        name: 'NRBENEFICIOM',
        label: 'Benefício',
        type: 'autocomplete',
        size: 4,
        descriptionField: 'NRDSBENEFICIO',
        valueField: 'NRBENEFICIOM',
        required: true,
        items: this.beneficiosFiltrados
      },
      {
        name: 'QTBENEFICIO',
        label: 'Qtd. Benefício',
        type: 'number',
        size: 4,
        required: this.isInclusaoVC,
        readonly: !this.isInclusaoVC
      },
      {
        name: 'DSOBSBENEFICIARIO',
        label: 'Justificativa da alteração',
        type: 'textarea',
        required: false,
        rows: 2,
        size: 6,
      },
      {
        name: 'DTINSCBENEFICIARIO',
        label: 'Início de Validade',
        type: 'date',
        size: 3,
        required: this.isInclusaoVC,
        onInput: () => this.validaDataAnteriorCompetencia('DTINSCBENEFICIARIO'),
        readonly: !this.isInclusaoVC,
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
      },
      {
        name: 'DTCANCBENEFICIARIO',
        label: 'Fim de Validade',
        type: 'date',
        size: 3,
        required: !this.isInclusaoVC
      },
    ];

    return fields;
  }

  private get fieldsBeneficios(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRTPBENEFICIO',
        label: 'Tipo Benefício',
        type: 'autocomplete',
        size: 6,
        valueField: 'NRTPBENEFICIO',
        descriptionField: 'DSTPBENEFICIO',
        items: this.tiposBeneficio,
      },
      {
        name: 'TPPERIODOBENEF',
        label: 'Período Benefício',
        type: 'select',
        size: 4,
        descriptionField: 'DSPERIODOBENEF',
        valueField: 'TPPERIODOBENEF',
        items: [
          {
            DSPERIODOBENEF: 'Mensal',
            TPPERIODOBENEF: 'MENSAL',
          },
          {
            DSPERIODOBENEF: 'Diário',
            TPPERIODOBENEF: 'DIARIO',
          },
        ],
        readonly: true,
      },
      {
        name: 'NRBENEFICIOM',
        label: 'Benefício',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRDSBENEFICIO',
        valueField: 'NRBENEFICIOM',
        required: true,
        items: this.beneficiosFiltrados
      },
      {
        name: 'QTBENEFICIO',
        label: 'Qtd. Benefício',
        type: 'number',
        size: 6,
        required: this.isInclusaoVC,
        readonly: !this.isInclusaoVC
      },
      {
        name: 'DSOBSBENEFICIARIO',
        label: 'Justificativa da alteração',
        type: 'textarea',
        required: false,
        rows: 2,
        size: 6,
      },
      {
        name: 'DTINSCBENEFICIARIO',
        label: 'Início de Validade',
        type: 'date',
        size: 3,
        required: this.isInclusaoVC,
        onInput: () => this.validaDataAnteriorCompetencia('DTINSCBENEFICIARIO'),
        readonly: !this.isInclusaoVC,
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
      },
      {
        name: 'DTCANCBENEFICIARIO',
        label: 'Fim de Validade',
        type: 'date',
        size: 3,
        required: !this.isInclusaoVC
      },
    ];
    return fields;
  }
  
  private get defaultRowSubstituicao(): any {
    const defaultSubstituicao = {
      CDSTATUS: 1,
      NRVAGAS: 1,
    };

    return defaultSubstituicao;
  }

  private get fieldsSubstituicao(): Field[] {
    const fields: Field[] = [
      {
        name: 'NMPROCESSO',
        label: 'Nome do Processo',
        type: 'text',
        size: 6,
        required: this.solicitacaoIsReduzido,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'NRTEMPLATE',
        label: 'Template',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMTEMPLATE',
        valueField: 'NRTEMPLATE',
        items: this.templates,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'NRTIPOPROCESSO',
        label: 'Tipo de Processo',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMTIPOPROCESSO',
        valueField: 'NRTIPOPROCESSO',
        items: this.tiposProcesso,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'DSMOTIVO',
        label: 'Motivo',
        type: 'text',
        size: 6,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'LOCALIDADE',
        label: 'Localidade',
        type: 'text',
        size: 6,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'DSDESCRICAO',
        label: 'Descrição (Competências)',
        type: 'textarea',
        size: 12,
        rows: 2,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'DTSOLICITA',
        label: 'Disponível desde',
        type: 'date',
        size: 4,
        onInput: () => this.validaDataAnteriorDataAtual('DTSOLICITA'),
        required: this.solicitacaoIsReduzido,
        isVisible: this.solicitacaoIsReduzido,
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
      },
      {
        name: 'DTLIMSOLICITA',
        label: 'Disponível até',
        type: 'date',
        size: 4,
        onInput: () => this.validaDataAnteriorDataAtual('DTLIMSOLICITA'),
        required: this.solicitacaoIsReduzido,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'DTPREVISTAADMISSAO',
        label: 'Data Prevista de Admissão:',
        type: 'date',
        size: this.solicitacaoIsReduzido ? 4 : 6,
        required: this.solicitacaoIsReduzido,
        onInput: () => this.validaDataAnteriorDataAtual('DTPREVISTAADMISSAO') && this.validaDtAdmissaoPrevista(),
      },
      {
        name: 'NRMOTIVOADMISSAO',
        label: 'Motivo de admissão',
        type: 'autocomplete',
        descriptionField: 'NMMOTIVOADMISSAO',
        valueField: 'NRMOTIVOADMISSAO',
        size: 6,
        items: this.motivosAdmissao,
        required: true,
      },
      {
        name: 'NRESTRUTLEGAL',
        label: 'Estrutura Legal',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.estruturasLegais,
        required: true,
      },
      {
        name: 'NRESTRUTGEREN',
        label: 'Estrutura Gerencial',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.estruturasGerenciais,
        required: true,
      },
      {
        name: 'NROCUPACAOM',
        label: 'Ocupação (Cargo)',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMOCUPACAO',
        valueField: 'NROCUPACAOM',
        items: this.ocupacoes,
        required: true,
      },
      {
        name: 'NRESCALATRABM',
        label: 'Escala de Trabalho',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESCALATRABM',
        valueField: 'NRESCALATRABM',
        items: this.escalas,
        required: true,
      },
      {
        name: 'VRSALARIO',
        label: 'Salário Proposto',
        type: 'number',
        size: 6,
        required: true,
      },
      {
        name: 'NRTIPOVINCULOM',
        label: 'Tipo de Vínculo',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMTIPOVINCULOH',
        valueField: 'NRTIPOVINCULOM',
        items: this.tiposVinculo,
        required: true,
      },
      {
        name: 'NRVINCULOEMPREG',
        label: 'Vínculo Empregatício',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMABREV',
        valueField: 'NRVINCULOEMPREG',
        items: this.vinculosEmpregaticios,
      },
      {
        name: 'NRGRAUINSTR',
        label: 'Grau de Instrução',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRGRAUINSTR',
        descriptionField: 'NMGRAUINSTR',
        items: this.grausInstrucao,
        isVisible: !this.solicitacaoIsReduzido,
      },
      {
        name: 'NRCPFPESSOA',
        label: 'CPF do Indicado',
        size: 6,
        type: 'text',
        mask: '###.###.###-##',
        forceNotReadOnly: true,
        onInput: this.onIputCpfSoliAdmissao,
        required: true,
      },
      {
        name: 'NMPESSOA',
        label: 'Nome do Indicado',
        type: 'text',
        size: 6,
        readonly: this.isNmPessoaReadOnly,
        required: true,
      },
      {
        name: 'NRGRAUINSTR',
        label: 'Grau de Instrução',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRGRAUINSTR',
        descriptionField: 'NMGRAUINSTR',
        items: this.grausInstrucao,
        isVisible: this.solicitacaoIsReduzido,
      },
    ];

    return fields;
  }

  private get defaultRowAumentoQuadro(): any {
    const defaultAumentoQuadro = {
      CDSTATUS: 3,
    };

    return defaultAumentoQuadro;
  }

  private get fieldsAumentoQuadro(): Field[] {
    const fields: Field[] = [
      {
        name: 'NMPROCESSO',
        label: 'Nome do Processo',
        type: 'text',
        size: 6,
        required: this.solicitacaoIsReduzido,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'NRTEMPLATE',
        label: 'Template',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMTEMPLATE',
        valueField: 'NRTEMPLATE',
        items: this.templates,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'NRTIPOPROCESSO',
        label: 'Tipo de Processo',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMTIPOPROCESSO',
        valueField: 'NRTIPOPROCESSO',
        items: this.tiposProcesso,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'DSMOTIVO',
        label: 'Motivo',
        type: 'text',
        size: 6,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'LOCALIDADE',
        label: 'Localidade',
        type: 'text',
        size: 6,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'DSDESCRICAO',
        label: 'Descrição (Competências)',
        type: 'textarea',
        size: 12,
        rows: 2,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'DTSOLICITA',
        label: 'Disponível desde',
        type: 'date',
        size: 3,
        onInput: () => this.validaDataAnteriorDataAtual('DTSOLICITA'),
        required: this.solicitacaoIsReduzido,
        isVisible: this.solicitacaoIsReduzido,
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
      },
      {
        name: 'DTLIMSOLICITA',
        label: 'Disponível até',
        type: 'date',
        size: 3,
        onInput: () => this.validaDataAnteriorDataAtual('DTLIMSOLICITA'),
        required: this.solicitacaoIsReduzido,
        isVisible: this.solicitacaoIsReduzido,
      },
      {
        name: 'DTPREVISTAADMISSAO',
        label: 'Data Prevista de Admissão:',
        type: 'date',
        size: this.solicitacaoIsReduzido ? 3 : 6,
        required: this.solicitacaoIsReduzido,
        onInput: () => this.validaDataAnteriorDataAtual('DTPREVISTAADMISSAO') && this.validaDtAdmissaoPrevista(),
      },
      {
        name: 'NRVAGAS',
        label: 'Número de Vagas',
        type: 'number',
        size: this.solicitacaoIsReduzido ? 3 : 6,
        required: true,
        onInput: this.validaVagasAumentoQuadro,
        readonly: !this.solicitacaoIsReduzido
      },
      {
        name: 'NRESTRUTLEGAL',
        label: 'Estrutura Legal',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.estruturasLegais,
        required: true,
      },
      {
        name: 'NRESTRUTGEREN',
        label: 'Estrutura Gerencial',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.estruturasGerenciais,
        required: true,
      },
      {
        name: 'NROCUPACAOM',
        label: 'Ocupação (Cargo)',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMOCUPACAO',
        valueField: 'NROCUPACAOM',
        items: this.ocupacoes,
        required: true,
      },
      {
        name: 'NRESCALATRABM',
        label: 'Escala de Trabalho',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESCALATRABM',
        valueField: 'NRESCALATRABM',
        items: this.escalas,
        required: true,
      },
      {
        name: 'VRSALARIO',
        label: 'Salário Proposto',
        type: 'number',
        size: 6,
        required: true,
      },
      {
        name: 'NRTIPOVINCULOM',
        label: 'Tipo de Vínculo',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMTIPOVINCULOH',
        valueField: 'NRTIPOVINCULOM',
        items: this.tiposVinculo,
        required: true,
      },
      {
        name: 'NRVINCULOEMPREG',
        label: 'Vínculo Empregatício',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMABREV',
        valueField: 'NRVINCULOEMPREG',
        items: this.vinculosEmpregaticios,
      },
      {
        name: 'NRGRAUINSTR',
        label: 'Grau de Instrução',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRGRAUINSTR',
        descriptionField: 'NMGRAUINSTR',
        items: this.grausInstrucao,
      },
      {
        name: 'NRCPFPESSOA',
        label: 'CPF do Indicado',
        size: 6,
        type: 'text',
        mask: '###.###.###-##',
        forceNotReadOnly: true,
        onInput: this.onIputCpfSoliAdmissao,
        readonly: this.isAumentoQuadroReadonly,
        required: true,
      },
      {
        name: 'NMPESSOA',
        label: 'Nome do Indicado',
        type: 'text',
        size: 6,
        readonly: this.isAumentoQuadroReadonly || this.isNmPessoaReadOnly,
        required: true,
      },
    ];

    return fields;
  }

  private get fieldsSalarioEscala(): Field[] {
    const fields = [
      {
        name: 'DSHISTORICO',
        label: 'Histórico',
        type: 'banner',
        required: false,
        readonly: true,
        rows: 1,
        size: 12,
      },
      {
        name: 'VRSALARIOATUAL_HIST',
        label: 'Salário Atual',
        type: 'text',
        size: 4,
        readonly: true,
      },
      {
        name: 'IDTPSALARIO_HIST',
        label: 'Tipo de Salário',
        valueField: 'IDTPSALARIO',
        descriptionField: 'DSTPSALARIO',
        type: 'autocomplete',
        size: 4,
        readonly: true,
        items: [
          {
            IDTPSALARIO: 'MENSAL',
            DSTPSALARIO: 'Mensal',
          },
          {
            IDTPSALARIO: 'QUINZENAL',
            DSTPSALARIO: 'Quinzenal',
          },
          {
            IDTPSALARIO: 'SEMANAL',
            DSTPSALARIO: 'Semanal',
          },
          {
            IDTPSALARIO: 'DIARIO',
            DSTPSALARIO: 'Diário',
          },
          {
            IDTPSALARIO: 'HORA',
            DSTPSALARIO: 'Hora',
          },
          {
            IDTPSALARIO: 'TAREFA',
            DSTPSALARIO: 'Tarefa',
          },
        ],
      },
      {
        name: 'NRTIPOALTERA_HIST',
        label: 'Tipo de Alteração',
        size: 4,
        type: 'autocomplete',
        valueField: 'NRTIPOALTERA',
        descriptionField: 'NMTIPOALTERA',
        items: this.tiposAlteraSal,
        readonly: true,
      },
      {
        name: 'NRESCALATRABM_HIST',
        label: 'Escala de Trabalho',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESCALATRABM',
        valueField: 'NRESCALATRABM',
        items: this.escalas,
        readonly: true,
      },
      {
        name: 'NRTURNO_HIST',
        label: 'Turno',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRDSTURNO',
        valueField: 'NRTURNO',
        items: this.turnos_hist,
        readonly: true,
      },
      {
        name: 'NRTPMOVTRANSFM_HIST',
        label: 'Transferência',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMTPMOVTRANSFH',
        valueField: 'NRTPMOVTRANSFM',
        items: this.transferencias,
        readonly: true
      },
      {
        name: 'NRMOTIVOTRANSF_HIST',
        label: 'Motivo de Transferência',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMMOTIVOTRANSF',
        valueField: 'NRMOTIVOTRANSF',
        items: this.motivosTransferencia,
        readonly: true,
      },
      {
        name: 'NRESTRUTURAM_LEGAL_HIST',
        label: 'Estrutura Legal',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.estruturasLegais,
        readonly: true
      },
      {
        name: 'NRESTRUTURAM_GEREN_HIST',
        label: 'Estrutura Gerencial',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.estruturasGerenciais,
        readonly: true
      },
      {
        name: 'NROCUPACAOM_HIST',
        label: 'Ocupação',
        size: 6,
        type: 'autocomplete',
        valueField: 'NROCUPACAOM',
        descriptionField: 'NRNMOCUPACAO',
        items: this.ocupacoes,
        readonly: true,
      },
      {
        name: 'NRMOTIVOOCUPA_HIST',
        label: 'Motivo',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRMOTIVOOCUPA',
        descriptionField: 'NMMOTIVOOCUPA',
        items: this.motivosOcupa,
        readonly: true,
      },
      {
        name: 'NRTPMODALIDSAL_HIST',
        label: 'Modalidade',
        valueField: 'NRTPMODALIDSAL',
        descriptionField: 'DSTPMODALIDSAL',
        type: 'autocomplete',
        size: 6,
        readonly: true,
        items: [
          {
            NRTPMODALIDSAL: '1',
            DSTPMODALIDSAL: 'Efetivo',
          },
          {
            NRTPMODALIDSAL: '2',
            DSTPMODALIDSAL: 'Comissionado',
          },
          {
            NRTPMODALIDSAL: '11',
            DSTPMODALIDSAL: 'Cenário I',
          },
          {
            NRTPMODALIDSAL: '12',
            DSTPMODALIDSAL: 'Cenário II',
          },
        ],
      },
      {
        name: 'NRTIPOOCUPACAO_HIST',
        label: 'Tipo',
        valueField: 'NRTIPOOCUPACAO',
        descriptionField: 'DSTIPOOCUPACAO',
        type: 'autocomplete',
        size: 6,
        readonly: true,
        items: [
          {
            NRTIPOOCUPACAO: '1',
            DSTIPOOCUPACAO: 'Cargo Efetivo',
          },
          {
            NRTIPOOCUPACAO: '2',
            DSTIPOOCUPACAO: 'Função',
          },
          {
            NRTIPOOCUPACAO: '3',
            DSTIPOOCUPACAO: 'Especialidade',
          },
          {
            NRTIPOOCUPACAO: '4',
            DSTIPOOCUPACAO: 'Cargo Comissionado',
          },
          {
            NRTIPOOCUPACAO: '5',
            DSTIPOOCUPACAO: 'Cargo Amparado/Apostilado',
          },
          {
            NRTIPOOCUPACAO: '6',
            DSTIPOOCUPACAO: 'Cargo Eletivo',
          },
          {
            NRTIPOOCUPACAO: '7',
            DSTIPOOCUPACAO: 'Recrutamento e Seleção',
          },
        ],
      },
      {
        name: 'DSHIST',
        label: 'Novas informações',
        type: 'banner',
        required: false,
        readonly: true,
        rows: 1,
        size: 12,
      },
      {
        name: 'VRSALARIO',
        label: 'Salário',
        type: 'number',
        size: 6,
        required: true,
      },
      {
        name: 'PERCALTERA',
        label: 'Percentual Real(%)',
        type: 'text',
        size: 6,
        readonly: true,
      },
      {
        name: 'IDTPSALARIO',
        label: 'Tipo de Salário',
        valueField: 'IDTPSALARIO',
        descriptionField: 'DSTPSALARIO',
        type: 'autocomplete',
        size: 6,
        required: true,
        items: [
          {
            IDTPSALARIO: 'MENSAL',
            DSTPSALARIO: 'Mensal',
          },
          {
            IDTPSALARIO: 'QUINZENAL',
            DSTPSALARIO: 'Quinzenal',
          },
          {
            IDTPSALARIO: 'SEMANAL',
            DSTPSALARIO: 'Semanal',
          },
          {
            IDTPSALARIO: 'DIARIO',
            DSTPSALARIO: 'Diário',
          },
          {
            IDTPSALARIO: 'HORA',
            DSTPSALARIO: 'Hora',
          },
          {
            IDTPSALARIO: 'TAREFA',
            DSTPSALARIO: 'Tarefa',
          },
        ],
      },
      {
        name: 'NRTIPOALTERA',
        label: 'Tipo de Alteração',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRTIPOALTERA',
        descriptionField: 'NMTIPOALTERA',
        items: this.tiposAlteraSal,
        required: true,
      },
      {
        name: 'DTINIESCALA',
        label: 'Início da Escala',
        type: 'date',
        size: this.isEscala12x36 ? 6 : 4,
        required: true,
        onInput: () => this.validaDataAnteriorCompetencia('DTINIESCALA') && this.getTurnoParOuImpar(),
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
        month: ['A', 'P'].includes(
          (this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO) || ''
        ),
      },
      {
        name: 'NRESCALATRABM',
        label: 'Escala de Trabalho',
        type: 'autocomplete',
        size: this.isEscala12x36 ? 6 : 4,
        descriptionField: 'NRNMESCALATRABM',
        valueField: 'NRESCALATRABM',
        required: true,
        items: this.escalas,
      },
      {
        name: 'CDTIPODIATRABALHO',
        label: 'Turno par ou ímpar',
        type: 'radio',
        valueField: 'value',
        outData: {
          DSTIPODIATRABALHO: 'label',
        },
        items: [
          {
            label: 'Trabalho em dia ímpar',
            value: 'I',
          },
          {
            label: 'Trabalho em dia par',
            value: 'P',
          },
        ],
        size: 6,
        isVisible: this.isEscala12x36,
        required: this.isEscala12x36,
        onInput: this.getTurnoParOuImpar
      },
      {
        name: 'NRTURNO',
        label: 'Turno',
        type: 'autocomplete',
        size: this.isEscala12x36 ? 6 : 4,
        descriptionField: 'NRDSTURNO',
        valueField: 'NRTURNO',
        required: true,
        items: this.turnos,
        readonly: !this.row.NRESCALATRABM || this.isEscala12x36,
      },
      {
        name: 'NRESTRUTLEGAL',
        label: 'Estrutura Legal',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.estruturasLegais,
      },
      {
        name: 'NRESTRUTGEREN',
        label: 'Estrutura Gerencial',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.estruturasGerenciais,
      },
      {
        name: 'NRTPMOVTRANSFM',
        label: 'Transferência',
        type: 'autocomplete',
        size: 6,
        required: this.isSoliMovimentRequired,
        descriptionField: 'NMTPMOVTRANSFH',
        valueField: 'NRTPMOVTRANSFM',
        items: this.transferencias,
      },
      {
        name: 'NRMOTIVOTRANSF',
        label: 'Motivo de Transferência',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMMOTIVOTRANSF',
        valueField: 'NRMOTIVOTRANSF',
        items: this.motivosTransferencia,
      },
      {
        name: 'NROCUPACAOM',
        label: 'Ocupação',
        size: 6,
        type: 'autocomplete',
        valueField: 'NROCUPACAOM',
        descriptionField: 'NRNMOCUPACAO',
        items: this.ocupacoes,
        required: this.isSoliOcupacaoRequired,
        onFocus: () => SnackbarUtils.showMessage('Atenção: O campo Ocupação deve ser preenchido somente se houver alteração de função', SnackbarUtils.TYPE_INFO2)
      },
      {
        name: 'NRMOTIVOOCUPA',
        label: 'Motivo',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRMOTIVOOCUPA',
        descriptionField: 'NMMOTIVOOCUPA',
        items: this.motivosOcupa,
        required: this.isSoliOcupacaoRequired,
      },
      {
        name: 'NRTPMODALIDSAL',
        label: 'Modalidade',
        valueField: 'NRTPMODALIDSAL',
        descriptionField: 'DSTPMODALIDSAL',
        type: 'autocomplete',
        size: 6,
        required: this.isSoliOcupacaoRequired,
        readonly: true,
        items: [
          {
            NRTPMODALIDSAL: '1',
            DSTPMODALIDSAL: 'Efetivo',
          },
          {
            NRTPMODALIDSAL: '2',
            DSTPMODALIDSAL: 'Comissionado',
          },
          {
            NRTPMODALIDSAL: '11',
            DSTPMODALIDSAL: 'Cenário I',
          },
          {
            NRTPMODALIDSAL: '12',
            DSTPMODALIDSAL: 'Cenário II',
          },
        ],
      },
      {
        name: 'NRTIPOOCUPACAO',
        label: 'Tipo',
        valueField: 'NRTIPOOCUPACAO',
        descriptionField: 'DSTIPOOCUPACAO',
        type: 'autocomplete',
        size: 6,
        required: this.isSoliOcupacaoRequired,
        items: [
          {
            NRTIPOOCUPACAO: '1',
            DSTIPOOCUPACAO: 'Cargo Efetivo',
          },
          {
            NRTIPOOCUPACAO: '2',
            DSTIPOOCUPACAO: 'Função',
          },
          {
            NRTIPOOCUPACAO: '3',
            DSTIPOOCUPACAO: 'Especialidade',
          },
          {
            NRTIPOOCUPACAO: '4',
            DSTIPOOCUPACAO: 'Cargo Comissionado',
          },
          {
            NRTIPOOCUPACAO: '5',
            DSTIPOOCUPACAO: 'Cargo Amparado/Apostilado',
          },
          {
            NRTIPOOCUPACAO: '6',
            DSTIPOOCUPACAO: 'Cargo Eletivo',
          },
          {
            NRTIPOOCUPACAO: '7',
            DSTIPOOCUPACAO: 'Recrutamento e Seleção',
          },
        ],
      },
      {
        name: 'DTINIMOVIMENT',
        label: 'Data de Início',
        type: 'date',
        size: 6,
        month: true,
        required: true,
        onInput: () => this.validaDataAnteriorCompetencia('DTINIMOVIMENT'),
        minDate: this.getIntervaloDataRegra('min'),
        maxDate: this.getIntervaloDataRegra('max'),
      },
      {
        name: 'DTFIMMOVIMENT',
        label: 'Data de Fim',
        type: 'date',
        size: 6,
      },
      {
        name: 'DSOBSALTESALARIO',
        label: 'Justificativa',
        type: 'textarea',
        required: false,
        rows: 2,
        size: 12,
      },
    ];

    return fields;
  }
  // #endregion

  private get solicitacaoIsReduzido(): boolean {
    const nrorgsToExclude = [ '1410'];
    return !nrorgsToExclude.includes(this.user.nrorg);
  }

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.value) {
      this.vinculos = this.vinculosProp;
      this.setMainFields();

      this.mainPanelsExpansion = [...this.defaultMainPanelsExpansion];
    }
  }
  // #endregion

  // #region [ METHODS ]
  closePopup() {
    this.internalValue = false;
    this.updateMainGridFieldsVisibility();
    this.resetVariaveis();
    this.removeCssClassFromBannerHistoric();

    this.emitInput(this.internalValue);
  }

  private resetVariaveis() {
    this.isDocRequired = false;
    this.rowsDocumentos = [];
  }

  async advanceButtonOnClick() {
    const nrTipoSolicitacao: string = this.row.NRTIPOSOLICITACAO;

    if (!this.validate(true) || !nrTipoSolicitacao) {
      this.alertAllFieldsIsRequired();

      return;
    }

    if (!this.alertDataMinimaSolicitacao()) return;

    if(this.alertDocumentoRequired()) return;

    await this.executeOnAdvanceActions();

    this.current = nrTipoSolicitacao;
    this.executeAfterAdvanceActions();
  }


  private alertAllFieldsIsRequired() {
    const message = 'Favor preencher todos os campos obrigatórios!';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
  }

  private async executeOnAdvanceActions(): Promise<void> {
    const onAdvanceAction = this.getOnAdvanceAction();
    if (onAdvanceAction) {
      await onAdvanceAction();
    }
  }

  private executeAfterAdvanceActions(): void {
    const afterAdvanceAction = this.getAfterAdvanceAction();
    if (afterAdvanceAction) {
      afterAdvanceAction();
    }
  }

  private async executeOnSaveValidation(): Promise<boolean> {
    const onSaveValidation = await this.getOnSaveValidation();
    return await onSaveValidation();
  }

  private getOnAdvanceAction(): () => void {
    return this.selectedTypeActionsConfig.onAdvanceAction || (() => null);
  }

  private async executeOverideSaveAction(row: any): Promise<void> {
    const overrideSaveAction = this.getOverrideSaveAction();
    await overrideSaveAction(row);
  }

  private getAfterAdvanceAction(): () => void {
    return this.currentTypeActionsConfig.afterAdvanceAction || (() => null);
  }

  private async getOnSaveValidation(): Promise<() => boolean> {
    return this.currentTypeActionsConfig.onSaveValidation || (() => true);
  }

  private getOverrideSaveAction(): (row: any) => Promise<void> {
    return this.currentTypeActionsConfig.overrideSaveAction || (() => null);
  }

  private async setMainFields() {
    this.current = 'main';

    const defaultRowMainCopy = Util.deepCopy(this.defaultRowMain);
    this.row = defaultRowMainCopy;

    this.loading = true;

    try {

      if(this.isEdit) {
        this.row = {
          ...this.row, 
          NRVINCULOM: Number(this.selectedRow.NRVINCULOM), 
          NMVINCULOM: this.selectedRow.NMVINCULOM, 
          NRTIPOSOLICITACAO: this.selectedRow.NRTIPOSOLICITACAO,
          _eula: true,
          DSOBSSOLICITACAO: this.selectedRow.DSOBSSOLICITACAO,
          NRSOLICITACAO: this.selectedRow.NRSOLICITACAO,
          DTSOLICITACAO: this.selectedRow.DTSOLICITACAO,
          DSAPROVACAOSEC: this.selectedRow.DSAPROVACAOSEC,
          DSPATH: this.selectedRow.DSPATH,
        };

        const motivoRecusa = await NovaSolicitacaoController.getMotivoRecusa(this.row.NRSOLICITACAO);

        this.row = {
          ...this.row, 
          NRTIPOSOLICITACAO: this.selectedRow.NRTIPOSOLICITACAO,
          DSRECUSA: motivoRecusa,
        };
      }
    } finally {
      this.loading = false;
    }
  }

  saveDocumento(row: any) {
    if (this.documentosGrid.currentRow !== null) {
      // Substitui a row antiga pela editada
      Util.replaceItem(row, this.rowsDocumentos, (doc: any) => {
        return doc.__id === row.__id;
      });
    } else {
      this.rowsDocumentos.push(row);
    }

    this.closeDocumentoPopup();
  }

  private addDocumento() {
    this.documentosGrid.currentRow = null;
    this.documentosGrid.showPopup = true;
  }

  private editDocumento(row: any) {
    this.documentosGrid.currentRow = row;
    this.documentosGrid.showPopup = true;
  }

  private closeDocumentoPopup() {
    this.documentosGrid.showPopup = false;
  }

  // Escala
  private async setEscalaFields() {
    this.loading = true;
    this.isEscala12x36 = false;

    try {
      const [previousData] = await Promise.all([
        this.getPreviousDataSolicitation(),
        this.loadEscalas(),
      ]);

      if(this.isEdit) {
        await this.preencherCamposEdit();
      }

      await this.setDefaultRowEscala( previousData, this.row, true);

      const defaultRowEscalaCopy = Util.deepCopy(this.defaultRowEscala);
      this.row = {...this.row, ...defaultRowEscalaCopy};

    } finally {
      this.loading = false;
    }
  }

  public async loadEscalas() {
    const escalas = await NovaSolicitacaoController.getEscalasTrab(false);
    this.escalas = escalas;
  }

  private async loadTurnos() {
    const nrEscala = this.row.NRESCALATRABM;

    const turnos = await NovaSolicitacaoController.getTurnos(nrEscala, false);
    this.turnos = turnos;

    if(this.turnos.length == 1) {
      this.row.NRTURNO = this.turnos[0].NRTURNO;
    }
  }

  public async setDefaultRowEscala(dataPrevious: any, row: any = false, turnoImparPar: boolean = false) {
     if(dataPrevious && dataPrevious.ESCALATRABALHO ) {
      this.defaultRowEscala.NRESCALATRABM_HIST = dataPrevious.ESCALATRABALHO.NRESCALATRABM;
      this.defaultRowEscala.NRTURNO_HIST = dataPrevious.TURNO.NRTURNO;
      
      if ( row && row.NRESCALATRABM) {
        const turnosHist = await NovaSolicitacaoController.getTurnos(dataPrevious.ESCALATRABALHO.NRESCALATRABM, false);
        const turnos = await NovaSolicitacaoController.getTurnos(row.NRESCALATRABM, false);
        this.turnos = turnos;
        this.turnos_hist = turnosHist;
        if(turnoImparPar) {
          const escalaAtual = this.escalas.find((escala) => escala.NRESCALATRABM == row.NRESCALATRABM);
          if(escalaAtual) {
            this.isEscala12x36 = escalaAtual.NRTPJORNADA == '2';
            this.isEscala12x36 ? this.getTurnoParOuImpar() : null;
          }  
        }
      } else {
        const turnos = await NovaSolicitacaoController.getTurnos(dataPrevious.ESCALATRABALHO.NRESCALATRABM, false);
        this.turnos = turnos;
        this.turnos_hist = turnos;
      }
    }
  }




  async save() {
    if (!this.validate(true)) {
      this.alertAllFieldsIsRequired();

      return;
    }

    if (this.hasMatchingPreviousSolicitationType()) {
      await DialogUtils.show('Salvar Solicitação', 'Os dados fornecidos na solicitação são idênticos aos dados atuais do colaborador. Deseja continuar?');
    }

    const isValidToSave = await this.executeOnSaveValidation();
    if (!isValidToSave) {
      return;
    }
    
    const row = Util.deepCopy(this.row);

    // Adicionando a descrição nos valores dos itens
    this.setDescriptionInRowValues();

    const rowCopy = Util.deepCopy(this.row);

    this.row = row;

    // Removendo campos que não serão utilizados no back-end
    // e que podem causar erro
    const fieldsToRemove: string[] = [
      ...this.ignoreFields.main,
      ...this.ignoreFields[this.current] || [],
    ];

    fieldsToRemove.forEach((field) => {
      rowCopy[field] = undefined;
    });

    if(!this.isEdit) {
      rowCopy.DSOBSSOLICITACAO = this.getObservacaoLGPD(rowCopy.DSOBSSOLICITACAO);
      rowCopy.DSOBSERVACAO = rowCopy.DSOBSSOLICITACAO;
    }

    const fileValid = await this.setFile(rowCopy);
    if(!fileValid) return;

    if (this.overrideSaveActionExistsForCurrentType) {
      return this.executeOverideSaveAction(rowCopy);
    }

    this.loading = true;

    try {
      await NovaSolicitacaoController.solicitaAlteracao(rowCopy, false, this.isEdit);

      SnackbarUtils.showMessage(Messages.SOLI_CRIADA_SUCCESS, SnackbarUtils.TYPE_SUCCESS);

      this.closePopup();
      this.emitAfterSave();
    } finally {
      this.loading = false;
    }
  }

  private async setFile(row: any) {
    const files = [];

    for (const docs of this.rowsDocumentos) {
      const file: File = docs.FILE;
      const fileName = file.name;
      try {
        const base64 = await FileUtils.toBase64(file);

        files.push({
          DSFILE: base64,
          NMFILE: fileName
        });
      } catch (error) {
          const message = `Não foi possível carregar o arquivo "${fileName}"!`;
          SnackbarUtils.showMessage(message, 'alert', 5000);
          return false;
      }
    }

    row.FILES = files;
    return true;
  }


  onFieldInput(fieldName, value) {

    const beneficios = this.current === TiposSolicitacao.TP_SOLI_BENEFICIOS ||
      this.current === TiposSolicitacao.TP_SOLI_VMANUTENCAO ||
      this.current === TiposSolicitacao.TP_SOLI_VCOMBUST;

    const escala = this.current === TiposSolicitacao.TP_SOLI_ALTERAESCALA ||
      this.current === TiposSolicitacao.TP_SOLI_MOVIM_LEGAL ||
      this.current === TiposSolicitacao.TP_SOLI_MOVIM_GERENCIAL ||
      this.current === TiposSolicitacao.TP_SOLI_SALARIO_ESCALA;;

    const salario = this.current === TiposSolicitacao.TP_SOLI_SALARIO ||
      this.current === TiposSolicitacao.TP_SOLI_MOVIM_OCUPACAO_SALARIO ||
      this.current === TiposSolicitacao.TP_SOLI_SALARIO_ESCALA ||
      this.current === TiposSolicitacao.TP_SOLI_SUBSTITUICAO ||
      this.current === TiposSolicitacao.TP_SOLI_AUMENTO_QUADRO;

    const advertencia = this.current === TiposSolicitacao.TP_SOLI_ADVERTENCIA ||
      this.current === TiposSolicitacao.TP_SOLI_ADVERTENCIA_ANOT_VINC;

    const actions = {
      'NRESCALATRABM': () => escala && this.escalaOnChange(value),
      'VRSALARIO': () => salario && this.setPercentSal(),
      'DTINISITUFUNC': () => advertencia && this.setDiaFimSituFunc(),
      'NRQTDIASITUFUNC': () => advertencia && this.setDiaFimSituFunc(),
      'NRTPBENEFICIO': () => this.current === TiposSolicitacao.TP_SOLI_BENEFICIOS && this.filtrarBeneficio(),
      'TPPERIODOBENEF': () => beneficios && this.filtrarBeneficio(),
      'NRTIPOSOLICITACAO': () => this.tipoSolicitacaoChange(value),
      'VRBENEFICIO': () => this.formatarMoeda(fieldName),
      'QTBENEFICIO': () => this.current === TiposSolicitacao.TP_SOLI_VCOMBUST && this.setQtBeneficio(),
      'CDTIPOALTEVC': () => (this.row.NRTIPOSOLICITACAO == TiposSolicitacao.TP_SOLI_VCOMBUST || this.row.NRTIPOSOLICITACAO == TiposSolicitacao.TP_SOLI_BENEFICIOS) && this.changeDocIsRequired(value),
      'NRBENEFICIOM': () => this.preencheDadosBeneficio(),
      'VRREEMBOLSO': () => this.setPercentReembolso(),
      'NRSITUFUNCM': () => advertencia && this.setQntDias(),
    };

    if(
      this.current === TiposSolicitacao.TP_SOLI_MOVIM_OCUPACAO_SALARIO || 
      this.current === TiposSolicitacao.TP_SOLI_MOVIM_LEGAL || 
      this.current === TiposSolicitacao.TP_SOLI_MOVIM_GERENCIAL ||
      this.current === TiposSolicitacao.TP_SOLI_SALARIO_ESCALA
      ) {
      this.row.DTALTESALARIO = this.row.DTINIOCUPACAO;
      this.verificaSalarioInputsIsVazio();
      this.verificaEscalaInputsIsVazio();
      this.verificaMovimentInputsIsVazio();
      this.verificaOcupacaoInputsIsVazio();
    }
    
    if(this.current === TiposSolicitacao.TP_SOLI_VTRANS) {
      this.setValorLinha(fieldName, value);
    }
  
    const customAction = actions[fieldName];
    if (customAction) {
      customAction();
    }
  }

  private tipoSolicitacaoChange(value: string) {
    this.changeLabelVinculo(value)
    this.setDocToRequired(value);
    const isGetTodosVic = this.TP_SOLICITACAO_TODOS_VINC.includes(this.row.NRTIPOSOLICITACAO);
  }

  private alertDocumentoRequired() {
    const notValid = this.rowsDocumentos.length < 1;
    if (this.isDocRequired && notValid) {
      const msg = "É necessário anexar pelo menos um documento para prosseguir com esta solicitação.";
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
  
      return true;
    }

    return false;
  }

  private setDocToRequired(value: string) {
    const typesToRequired = [
      TiposSolicitacao.TP_SOLI_VCOMBUST,
      TiposSolicitacao.TP_SOLI_VTRANS,
      TiposSolicitacao.TP_SOLI_AUMENTO_QUADRO,
      TiposSolicitacao.TP_SOLI_SUBSTITUICAO
    ];
    
    if (typesToRequired.includes(value as TiposSolicitacao)) {
      this.isDocRequired = true;
      return;
    }

    this.isDocRequired = false;
  }

  private changeDocIsRequired(value: string) {
    if(value == 'E') {
      this.isDocRequired = false;
      return;
    }

    this.isDocRequired = true;
  }


  private verificaSalarioInputsIsVazio() {
    const { VRSALARIO, IDTPSALARIO, NRTIPOALTERA } = this.row;

    if (VRSALARIO || IDTPSALARIO || NRTIPOALTERA) {
      this.isSoliSalarioRequired = true;
      return false;
    }
    this.isSoliSalarioRequired = false;
    return true;
  }

  private verificaEscalaInputsIsVazio() {
    const { NRESCALATRABM, DTINIESCALA } = this.row;

    if (NRESCALATRABM || DTINIESCALA) {
      this.isSoliEscalaRequired = true;
      return false;
    }

    this.isSoliEscalaRequired = false;
    return true;
  }

  private verificaMovimentInputsIsVazio() {
    const { NRESTRUTLEGAL, NRESTRUTGEREN } = this.row;

    if (NRESTRUTLEGAL || NRESTRUTGEREN) {
      this.isSoliMovimentRequired = true;
      return false;
    }

    this.isSoliMovimentRequired = false;
    return true;
  }

  private verificaOcupacaoInputsIsVazio() {
    const { NROCUPACAOM, NRMOTIVOOCUPA, NRTIPOOCUPACAO } = this.row;

    if (NROCUPACAOM || NRMOTIVOOCUPA || NRTIPOOCUPACAO) {
      this.isSoliOcupacaoRequired = true;
      return false;
    }

    this.isSoliOcupacaoRequired = false;
    return true;
  }

  // Escala
  private async escalaOnChange(value) {
    if (value) {
      this.loading = true;
      const nrEscala = this.row.NRESCALATRABM;
      const escala = this.escalas.find((escala) => escala.NRESCALATRABM === nrEscala);

      this.isEscala12x36 = escala.NRTPJORNADA == '2';  
      this.row = this.isEscala12x36 ? this.row : (({ CDTIPODIATRABALHO, ...rest }) => rest)(this.row);
      
      try {
        await Promise.all([
          this.loadTurnos(),
          this.isEscala12x36 ? this.getTurnoParOuImpar() : null,
        ]);


      } finally {
        this.loading = false;
      }
    } else {
      this.row.NRTURNO = undefined;
      this.isEscala12x36 = false;
    }
  }

  public async loadOcupacoes() {
    const ocupacoes = await NovaSolicitacaoController.getOcupacoes(false);
    this.ocupacoes = ocupacoes;
  }

  public async loadMotivosOcupa() {
    const motivosOcupa = await NovaSolicitacaoController.getMotivosOcupa(false);
    this.motivosOcupa = motivosOcupa;
  }

  public setDefaultRowOcupacao (dataPrevious: any) {
    if(dataPrevious) {
      this.defaultRowOcupacao.NROCUPACAOM_HIST = dataPrevious.NROCUPACAOM;
      this.defaultRowOcupacao.NRTIPOOCUPACAO_HIST = dataPrevious.NRTIPOOCUPACAO;
      this.defaultRowOcupacao.NRMOTIVOOCUPA_HIST = dataPrevious.NRMOTIVOOCUPA;
      this.defaultRowOcupacao.NRTPMODALIDSAL_HIST = dataPrevious.NRTPMODALIDSAL;

      if(!this.isEdit) {
        this.defaultRowOcupacao.DTINIOCUPACAO = this.getDataInicialPorRegra();
        this.defaultRowOcupacao.NRTPMODALIDSAL = '1';
      }
    }
  }


  // Ocupação
  private async setOcupacaoFields() {
    await this.ocupacaoAdvancedValidations();

    this.loading = true;
    try {
      const [ocupacaoPrevious] = await Promise.all([
        NovaSolicitacaoController.getDadosPreviosSolicitacao(this.row.NRVINCULOM, 9),
        this.loadOcupacoes(),
        this.loadMotivosOcupa()
      ]);

      if(this.isEdit) {
        this.preencherCamposEdit();
      }

      this.setDefaultRowOcupacao(ocupacaoPrevious);
      this.row.DTINIOCUPACAO = this.getDataInicialPorRegra();

      const defaultRowOcupacaoCopy = Util.deepCopy(this.defaultRowOcupacao);
      this.row = {...this.row, ...defaultRowOcupacaoCopy};

    } finally {
      this.loading = false;
    }
  }


  // Salário
  private async setSalarioFields() {
    this.loading = true;

    try {
      await Promise.all([
        this.loadTipoAlteraSal(),
        this.loadModalidadeSal(),
        this.loadUltimoSalario()
      ]);

      if(this.isEdit) {
        this.preencherCamposEdit();
      }

      this.setDefaultRowSalario();

      const defaultRowSalarioCopy = Util.deepCopy(this.defaultRowSalario);
      this.row = {...this.row, ...defaultRowSalarioCopy};

    } finally {
      this.loading = false;
    }
  }

  public setDefaultRowSalario() {
    this.defaultRowSalario.NRTPMODALIDSAL_HIST = this.dadosUltimoSal.NRTPMODALIDSAL;
    this.defaultRowSalario.IDTPSALARIO_HIST = this.dadosUltimoSal.IDTPSALARIO;
    this.defaultRowSalario.NRTIPOALTERA_HIST = this.dadosUltimoSal.NRTIPOALTERA;
    this.defaultRowSalario.VRSALARIOATUAL_HIST = this.dadosUltimoSal.VRSALARIO;
    
    if(!this.isEdit) {
      this.defaultRowSalario.DTALTESALARIO = this.getDataInicialPorRegra();
      this.defaultRowSalario.NRTPMODALIDSAL = '1';
      this.defaultRowSalario.NROCORRENCIA = '1';
    }

    if (this.defaultRowSalario.VRSALARIOATUAL_HIST) {
      this.defaultRowSalario.VRSALARIOATUAL_HIST = parseFloat(this.defaultRowSalario.VRSALARIOATUAL_HIST).toFixed(2);
    }
  } 

  public async loadTipoAlteraSal() {
    const tipos = await NovaSolicitacaoController.getTipoAlteraSal(false);
    this.tiposAlteraSal = tipos;
  }

  public async loadModalidadeSal() {
    const modalidades = await NovaSolicitacaoController.getModalidadeSalarial(false);
    this.modalidadesSal = modalidades;
  }

  public async loadUltimoSalario() {
    const nrVinculo = this.row.NRVINCULOM;

    const dadosSalario = await NovaSolicitacaoController.getUltimoSalario(
      nrVinculo, false
    );
    this.dadosUltimoSal = dadosSalario;
  }

  private setPercentSal() {
    if (this.row.VRSALARIO) {
      this.row.VRSALARIO = parseFloat(this.row.VRSALARIO).toFixed(2);

      this.row.PERCALTERA = (
        (
          (
            FormatUtils.enterValueValidations(this.row.VRSALARIO) /
            FormatUtils.enterValueValidations(this.row.VRSALARIOATUAL_HIST)
          ) - 1
        ) * 100
      ).toFixed(2);
    } else {
      this.row.PERCALTERA = '';
    }
  }

  private setPercentReembolso() {
    if (this.row.VRREEMBOLSO) {
      this.row.VRREEMBOLSO = parseFloat(this.row.VRREEMBOLSO).toFixed(2);
    }
  }

  private formatarMoeda(label: string) {
    if(this.row[label]) {
      this.row[label] = parseFloat(this.row[label]).toFixed(2);
    }
  }

  private desformatarMoeda(label: string) {
    if (this.row[label]) {
      let valor = parseFloat(String(this.row[label]).replace(",", "."));
      this.row[label] = parseFloat(valor.toFixed(2).replace(/\.00$/, ''));
    }
  }

  private setQtBeneficio() {
    this.$nextTick(() => {
      if(this.row.CDTIPOVC == 'K' && this.row.QTBENEFICIO) {
        this.formatarMoeda('QTBENEFICIO');
      }
  
      if(this.row.CDTIPOVC == 'V' && this.row.QTBENEFICIO) {
        this.row.QTBENEFICIO = Math.floor(parseFloat(this.row.QTBENEFICIO.replace(",", ".")));
      }
    });
  }

  // Desligamento
  private async setDesligamentoFields() {
    this.isAvisoPrevioRequired = false;

    await this.desligamentoAdvancedValidations();
    
    if(this.isEdit) {
      this.preencherCamposEdit();
    } else {
      this.row.CDREPOSICAOVAGA = "N";
      this.row.CDPESSOANAOGRATA = "N";
      this.row.CDPOSSUIBENSDAEMPRESA = "N";
      this.row.DSREPOSICAOVAGA = "Não";
      this.row.DSPESSOANAOGRATA = "Não";
      this.row.DSPOSSUIBENSDAEMPRESA = "Não";
      await this.preencherEndereco();
    }

    this.loading = true;

    try {
      await Promise.all([
        this.loadDadosVinculo(),
        this.loadTiposAvisoPrevio(),
        this.loadTiposDemissao(),
        this.loadMotivosRescisao(),
        this.loadPeriodoEstab()
      ]);

      // Pendente de ajuste
      if(this.dadosVinculo) {
        this.row.NROCUPACAOM = `${this.dadosVinculo.NROCUPACAOM} - ${this.dadosVinculo.NMOCUPACAOH}`;
        this.row.NRESTRUTSIND = `${this.dadosVinculo.NRESTRUTSIND} - ${this.dadosVinculo.NMESTRUTURASIND}`;
        await this.setarPeriodoExperiencia();
      }

    } finally {
      this.loading = false;
    }
  }

  private verificaPeriodoExperiencia(setarValor = false): boolean {
    if (!this.dadosVinculo) {
      if (setarValor) {
        this.row.CDPEREXP = 'N';
      }
      return false;
    }

    const { DTVENCCONTREXPER: dataVencimento, NRDIASCONTRATOEXPPRO: diasProrrogacao } = this.dadosVinculo;
    
    if (!dataVencimento || !diasProrrogacao) {
      if (setarValor) {
        this.row.CDPEREXP = 'N';
      }
      return false;
    }
  
    try {
      const dataSolicitacao = parse(this.row.DTSOLICITACAO, 'dd/MM/yyyy', new Date());
      const data = dataVencimento.split(' ')[0];
      const dataVencimentoBase = parse(data, 'dd/MM/yyyy', new Date());
      const dataVencimentoComProrrogacao = addDays(dataVencimentoBase, parseInt(diasProrrogacao));
  
      const emPeriodoExperiencia = dataSolicitacao <= dataVencimentoComProrrogacao;
      
      if (setarValor) {
        this.row.CDPEREXP = emPeriodoExperiencia ? 'S' : 'N';
      }
      
      return emPeriodoExperiencia;
    } catch (error) {
      if (setarValor) {
        this.row.CDPEREXP = 'N';
      }
      return false;
    }
  }

  private get isEmPeriodoExperiencia(): boolean {
    const emPeriodoExp = this.verificaPeriodoExperiencia(false);
    if (emPeriodoExp) {
      this.row.CDCUMPRIRAVISOPREV = 'N';
    }
    return emPeriodoExp;
  }
  
  private async setarPeriodoExperiencia(): Promise<void> {
    this.verificaPeriodoExperiencia(true);
  }

  private async verificaPeriodoExperienciaPRONTA(): Promise<void> {
    const { DTVENCCONTREXPER: dataVencimento, NRDIASCONTRATOEXPPRO: diasProrrogacao } = this.dadosVinculo;
    
    if (!dataVencimento || !diasProrrogacao) {
      this.row.CDPEREXP = 'N';
      return;
    }

    try {
      const dataSolicitacao =  parse(this.row.DTSOLICITACAO, 'dd/MM/yyyy', new Date());
      const data = dataVencimento.split(' ')[0];
      const dataVencimentoBase = parse(data, 'dd/MM/yyyy', new Date());
      const dataVencimentoComProrrogacao = addDays(dataVencimentoBase, parseInt(diasProrrogacao));

      this.row.CDPEREXP = dataSolicitacao <= dataVencimentoComProrrogacao ? 'S' : 'N';      
    } catch (error) {
      this.row.CDPEREXP = 'N';
    }
  }

  private setDateRescicao() {
    const dtAviso = this.row.DTAVISOPREVIO;
    if (Util.isEmptyOrBlank(dtAviso)) {
      this.row = { ...this.row, DTRESCISAOVINC: null, DTRESCISAOPROJETADA: null }
      return;
    }
    const isAvisoPrevio = this.row.CDCUMPRIRAVISOPREV === 'S';
    let dtRescisao = dtAviso;

    if(isAvisoPrevio) {
      const avisoDate = parse(dtAviso, 'dd/MM/yyyy', new Date());
      dtRescisao = format(addDays(avisoDate, 30), 'dd/MM/yyyy');
    }

    this.row.DTRESCISAOVINC = dtRescisao;
  
    this.calcularDtProjetada();
  }

  private handleJustaCausa() {
    const isJustaCausa = this.row.CDJUSTACAUSA === 'S';
    if(isJustaCausa) {
      this.row = { ...this.row, CDCUMPRIRAVISOPREV: 'N' }
    }
  }

  // Valida se o campo DSTPAVIPRE deve ser obrigatório (this.isAvisoPrevioRequired = true)
  // quando DTAVISOPREVIO é diferente de DTRESCISAOVINC e NRTPAVIPRE está vazio ele é obrigatório.
  private validaAvisoPrevio() {
    if(this.row.DTAVISOPREVIO && this.row.DTAVISOPREVIO != this.row.DTRESCISAOVINC && !this.row.NRTPAVIPRE) {
      this.isAvisoPrevioRequired = true;
      return;
    }

    this.isAvisoPrevioRequired = false;
  }

  private async preencherEndereco() {
    this.enderecoVinculo  = await VinculoController.getEnderecoVinculo(this.row.NRVINCULOM);
  
    this.row.NRCEPENDERECO = this.enderecoVinculo.NRCEPENDERECO || null; 
    this.row.CDTIPOENDERECO = this.enderecoVinculo.CDTIPOENDERECO || null;  
    this.row.NMPAIS = this.enderecoVinculo.NMPAIS || null; 
    this.row.SGESTADO = this.enderecoVinculo.SGESTADO || null;   
    this.row.NMESTADO = this.enderecoVinculo.NMESTADO || null;  
    this.row.NMMUNICIPIO = this.enderecoVinculo.NMMUNICIPIO || null;
    this.row.NMBAIRROENDERECO = this.enderecoVinculo.NMBAIRROENDERECO || null;
    this.row.DSLOGRADOURO = this.enderecoVinculo.DSLOGRADOURO || null;
    this.row.DSENDERECO = this.enderecoVinculo.DSENDERECO || null;    
    this.row.NRIMOVELENDERECO = this.enderecoVinculo.NRIMOVELENDERECO || null;
    this.row.DSCOMPLEENDERECO = this.enderecoVinculo.DSCOMPLEENDERECO || null;
  }

  private handleChangePessoaNaoGrata() {
    
  }

  public goBackToMain() {
    this.clearFieldsOnBack();
    this.removeCssClassFromBannerHistoric();
    this.current = 'main';
  }

  // Rotina que, chamada ao selecionar o botão voltar, limpa os campos do tipo de solicitação, se definido em 'tiposSolicitacaoProperties'
  private clearFieldsOnBack() {
    if (this.tiposSolicitacaoProperties.clearFieldsOnBack.includes(this.current)) {
      for(const field of this.fields) {
        this.row[field.name] = undefined;
      }
    }
  }




  goBack() {
    if (this.isCurrentMain) {
      this.vinculoLabel = 'Vínculo';
      this.closePopup();
      return;
    }

    this.goBackToMain();
  }

  private async loadTiposAvisoPrevio() {
    const tiposAvisoPrevio = await NovaSolicitacaoController.getTpAvisoPrevio();
    this.tiposAviso = tiposAvisoPrevio;
  }

  private async loadTiposDemissao() {
    const tiposDemissao = await NovaSolicitacaoController.getTpDemissao();
    this.tiposDemissao = tiposDemissao;
  }

  private async loadMotivosRescisao() {
    const motivosRescisao = await NovaSolicitacaoController.getMotivoResc();
    this.motivosRescisao = motivosRescisao;
  }

  private async loadValidacaoSitufunc() {
    const validacaoResponse = await SituacaoFuncionalController.validaUltSituFuncDiferenteTrabalho(
      this.$store.getters.user.nrorg,
      this.row.NRVINCULOM,
      this.$store.getters.periodoDemonstrativoAtual.NRPERIODOAPURACAO
    );

    if (!validacaoResponse.isValid) {

      // Confirmation Dialog
      await DialogUtils.show(
        this.actionText.situFuncWanr.title,
        validacaoResponse.message,
        () => null,
        () => this.goBackToMain(),
        true
      );
    }
  }

  private async validaPeriodoEstab() {
    const isDp = this.user.dp;
    let bloqueio = !isDp;
    const validacaoResponse = await SituacaoFuncionalController.validaDataRescisaoPeriodoEstabilidade(
      this.$store.getters.user.nrorg,
      this.row.NRVINCULOM,
      this.row.DTRESCISAOVINC,
      this.periodosEstabVinculo,
      isDp
    );

    if (!validacaoResponse.isValid) {

      // Confirmation Dialog
      DialogUtils.show(
        this.actionText.periodoEstabWanr.title,
        validacaoResponse.message,
        () => null,
        () => this.goBackToMain(),
        true,
        bloqueio
      );
    }
  }

  public async loadPeriodoEstab() {
    const periodosEstabVinc = await SituacaoFuncionalController.getPeriodosEstabilidade(
      this.$store.getters.user.nrorg,
      this.row.NRVINCULOM
    );

    this.periodosEstabVinculo = periodosEstabVinc;
  }



  // Dependente
  private async setDependenteFields() {
    this.loading = true;

    try {
      await this.loadTiposRelacionamento();
    } finally {
      this.loading = false;
    }
  }

  private async loadTiposRelacionamento() {
    this.tiposRelacionamento = await NovaSolicitacaoController.getTipoRelacionamento();
  }




  // VT
  private async setVTFields() {
    await this.vinculoDemitidoOuAfastado();
    this.isRequiredVT = this.isRequiredVTInit;

     const [previousData] = await Promise.all([
      this.getPreviousDataSolicitation(),
      this.loadLinhas(),
      this.loadTiposLinha(),
      this.loadNumerosIntegracao(),
      this.loadSentidosLinha()
    ]);

    if(this.isEdit) {
      this.preencherCamposEdit();
    }

    this.tarifasVT = previousData.TARIFAS;
    this.linhasVTVinculo = previousData.LINHAS;

    if(this.row.CDTIPOALTEVT === 'E') {
      this.isInclusaoVT = false;
      this.setPreviousLinhaVT(previousData.LINHAS);
    } else {
      this.isInclusaoVT = true;
    }

  }

  private async loadLinhas() {
    this.linhas = await NovaSolicitacaoController.getLinhaTransporteAtiva();
  }

  private async loadTiposLinha() {
    this.tiposLinha = await NovaSolicitacaoController.getTipolinhavinc();
  }

  private async loadNumerosIntegracao() {
    this.numerosIntegracao = await NovaSolicitacaoController.getIntegtransp();
  }

  private async loadSentidosLinha() {
    this.sentidosLinha = await NovaSolicitacaoController.getSentidolinha();
  }

  private setPreviousLinhaVT(data: any) {
    if(!Array.isArray(data)) return;

    data.forEach((linha, i) => {
      const index = i + 1;
      if(index > 8) return;
      this.setDadosLinhaFields(index, false, linha.NRLINHATARIFA, linha.NRTIPOLINHAVINC, linha.VRTARIFA, linha.QTLINHATARIFA);
    });
  }

  private setValorLinha(fieldName: any, value: any) {

    if(fieldName === 'NRLINHATRANSP') {
      const linha = this.linhas.find((linha) => linha && linha.NRLINHATRANSP === this.row.NRLINHATRANSP);
      if (!linha || !linha.VRTARIFA) {
        this.setDadosLinhaFields(1, true, null, null, null, null);
        if(value) {
          this.alertTarifaNaoEncontrada();
        }
        return;
      }
      this.row.VRTARIFA = linha.VRTARIFA;
    }

    for (let index = 2; index <= 8; index++) {
      if(fieldName === `NRLINHATRANSP_${index}`) {
        const linha = this.linhas.find((linha) => linha && linha.NRLINHATRANSP == this.row[`NRLINHATRANSP_${index}`]);

        if(!linha || !linha.VRTARIFA) {
          this.setDadosLinhaFields(index, true, null, null, null, null);
          if(value) {
            this.alertTarifaNaoEncontrada();
          }
          break;
        }

        this.row[`VRTARIFA_${index}`] = linha.VRTARIFA;
        this.isRequiredVT[index] = true;
        break;
      }
    }
  }

  private setDadosLinhaFields(index: number, isRemove: boolean, NRLINHATRANSP: any, NRTIPOLINHAVINC: any, VRTARIFA: any, QTLINHATARIFA: any) {
    this.$nextTick(() => {
      const rowCopy = Util.deepCopy(this.row);
      if(index === 1) {
        this.row.NRLINHATRANSP = NRLINHATRANSP;
        this.row.NRTIPOLINHAVINC = NRTIPOLINHAVINC;
        this.row.VRTARIFA = VRTARIFA;
        this.row.QTLINHATARIFA = QTLINHATARIFA;

        if(isRemove) {
          const { NRLINHATRANSP, NRTIPOLINHAVINC, VRTARIFA, QTLINHATARIFA, ...restRow} = rowCopy;
          this.row = restRow;
        }
        return;
      }

      this.row[`NRLINHATRANSP_${index}`] = NRLINHATRANSP;
      this.row[`NRTIPOLINHAVINC_${index}`] = NRTIPOLINHAVINC;
      this.row[`VRTARIFA_${index}`] = VRTARIFA;
      this.row[`QTLINHATARIFA_${index}`] = QTLINHATARIFA;

      if(this.isInclusaoVT) {
        this.isRequiredVT[index] = true;
      }

      if(isRemove) {        
        const {
          [`NRLINHATRANSP_${index}`]: NRLINHATRANSPValue,
          [`NRTIPOLINHAVINC_${index}`]: NRTIPOLINHAVINCValue,
          [`VRTARIFA_${index}`]: VRTARIFAValue,
          [`QTLINHATARIFA_${index}`]: QTLINHATARIFAValue,
          ...restRow
        } = rowCopy;

        this.row = restRow;
        this.isRequiredVT[index] = false;
      }

      if(!this.isInclusaoVT) {
        this.isRequiredVT = this.isRequiredVTInit;
      }
      
    });
  }

  private alertTarifaNaoEncontrada() {
    const message = 'A tarifa para esta linha ainda não foi cadastrada. Por favor, entre em contato com o departamento de Recursos Humanos';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
  }

  private onSaveVTValidation() {
    if(!this.linhasVTVinculo && !this.linhasVTVinculo.length) {
      return true;
    }

    let linhaExist = null;

    this.linhasVTVinculo.forEach((linha) => {
      for (let index = 2; index <= 8; index++) {
        if(this.row.NRLINHATRANSP == linha.NRLINHATARIFA || this.row[`NRLINHATRANSP_${index}`] == linha.NRLINHATARIFA) {
          linhaExist = linha;
          break;
        }
      }
    });

    if(linhaExist && this.row.CDTIPOALTEVT == 'I') {
      const message = `Este vínculo já possuí a linha ${linhaExist.NRDSLINHATRANSP} ativa`;
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      return false;
    }

    return true;
  }


  private async setBeneficioFields() {
    const defaultRowBeneficioCopy = Util.deepCopy(this.defaultRowBeneficio);

    if(this.isEdit) {
      this.preencherCamposEdit();
    }

    this.row = {
      ...this.row,
      ...defaultRowBeneficioCopy,
    };

    await this.loadBeneficios();
    await this.loadPessoas();
  }

  private async loadBeneficios() {
    this.beneficios = await NovaSolicitacaoController.getBeneficios();
    this.beneficiosFiltrados = this.beneficios;
  }

  private async loadTipoBeneficios() {
    this.tiposBeneficio = await SolicitacaoController.getTipoBeneficio();
  }

  private async loadPessoas() {
    this.pessoas = await NovaSolicitacaoController.getPessoaRelacionamentos(this.row.NRPESSOAPRIN);
  }

  private validarCpfDependente() {
    const cpf: string = this.row.NRCPFDEP;
    const valid = DocumentoUtil.validaCPF(cpf);

    if (!valid && cpf) {
      const message = 'O CPF inserido não é válido!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return false;
    }

    return true;
  }

  // Pessoal
  private async setPessoalFields() {
    if(this.isEdit) {
      this.preencherCamposEdit();
    }

    const nrparcnegocio = this.vinculoSelected ? this.vinculoSelected.NRPARCNEGOCIO : null;

    this.row = {
      ...this.row,
      ...this.defaultRowAdmissao,
      NRPARCNEGOCIORESP: nrparcnegocio
    };

    await Promise.all([
      this.loadEstruturasGerenciais(),
      this.loadOcupacoes(),
      this.loadTiposProcesso(),
      this.loadTemplates()
    ]);
  }

  public async loadEstruturasLegais() {
    this.estruturasLegais = await NovaSolicitacaoController.getEstruturas(
      'LEGAL'
    );
  }

  public async loadEstruturasGerenciais() {
    this.estruturasGerenciais = await NovaSolicitacaoController.getEstruturas(
      'GERENCIAL'
    );
  }

  private async loadEstruturasSindicais() {
    this.estruturasSindicais = await NovaSolicitacaoController.getEstrutura(
      'SINDICAL'
    );
  }

  private async loadResponsaveis() {
    this.responsaveis = await NovaSolicitacaoController.getParcnegocioVinculos();
  }

  private async loadTiposProcesso() {
    this.tiposProcesso = await NovaSolicitacaoController.getTipoprocessos();
  }

  private async loadTemplates() {
    this.templates = await NovaSolicitacaoController.getTemplate();
  }

  private async loadVinculosEmpregaticios() {
    this.vinculosEmpregaticios = await AdmissaoController.getVinculoEmpregaticio();
  }

  private async loadTiposVinculo() {
    this.tiposVinculo = await AdmissaoController.getTipoVinculo();
  }

  private async loadGrausInstrucao() {
    try {
      const grausInstrucao = await AdmissaoController.getGrauinstrucao();
      this.grausInstrucao = grausInstrucao;
    } catch {
      const msg = 'Não foi possível carregar os dados do campo Grau de Instrução';
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
    }
  }

  private async loadTodosVinculos() {
    this.todosVinculos = await SolicitacaoController.getTodosVinculosRescindidos();
  }

  private validateDatePessoal(): boolean {
    const inicio: string = this.row.DTSOLICITA;
    const fim: string = this.row.DTLIMSOLICITA;

    if (Util.isEmptyOrBlank(inicio) || Util.isEmptyOrBlank(fim)) {
      return true;
    }

    const dtInicio = parse(inicio, 'dd/MM/yyyy', new Date());
    const dtFim = parse(fim, 'dd/MM/yyyy', new Date());
  
    if(isBefore(dtFim, dtInicio)) {
      const message = 'A data de fim deve ser superior à data de início!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return false;
    }

    return true;
  }

  private validateNrVagas(): boolean {
    const nrVagas: number = this.row.NRVAGAS;

    if (nrVagas <= 0 ) {
      const message = 'A quantidade de vagas deve ser maior que 0!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return false;
    }

    return true;
  }

  private validaDtAdmissaoPrevista() {
    if (Util.isEmptyOrBlank(this.row.DTPREVISTAADMISSAO) || Util.isEmptyOrBlank(this.row.DTSOLICITA)) {
      return true;
    }

    const dtSolicita = parse(this.row.DTSOLICITA, 'dd/MM/yyyy', new Date());
    const dtAdmissao = parse(this.row.DTPREVISTAADMISSAO, 'dd/MM/yyyy', new Date());
  
    if(isBefore(dtAdmissao, dtSolicita)) {
      SnackbarUtils.showMessage("A data de admissão deve ser posterior à data de início do período de disponibilidade da vaga!", SnackbarUtils.TYPE_ERROR);
      return false;
    }

    return true;
  }

  private validateLimitesProcessos(): boolean {  
    const limites = {
      DSMOTIVO: { limite: 100, mensagem: "Motivo" },
      LOCALIDADE: { limite: 100, mensagem: "Localidade" },
      DSDESCRICAO: { limite: 4000, mensagem: "Descrição" }
    };
  
    for (const campo in limites) {
      if (this.validateLimiteCaracteres(this.row[campo], limites[campo].limite)) {
        SnackbarUtils.showMessage(`O limite de caracteres do campo ${limites[campo].mensagem} é ${limites[campo].limite}`, SnackbarUtils.TYPE_ERROR);
        return false;
      }
    }
  
    return true;
  }

  private validateLimiteCaracteres(text: string, max: number) {
    if(text && typeof text === 'string') {
      return text.length > max;
    }

    return false;
  }

  private async tipoSolicitacaoOnInput() {
    if(!this.row.NRTIPOSOLICITACAO) {
      const rowCopy = Util.deepCopy(this.row);
      this.row = { ...rowCopy, NRVINCULOM: null };
    }

    this.aplicaDataMinimaSolicitacao();

    this.getTodosVinculosOnInput();

    this.updateConsiderationsVisibilty();
  }

  private get isTpSolicitacaoBlockDataAnterior(): boolean {
    return this.TP_SOLICITACAO_BLOCK_DATA_ANTERIOR.includes(this.row.NRTIPOSOLICITACAO);
  }

  private aplicaDataMinimaSolicitacao(): void {
   if (this.isTpSolicitacaoBlockDataAnterior) {
      this.dataMinimimaSolicitacao = dataAtualStr;
      this.hintDataSolicitacao = 'Obs.: não é possível escolher uma data anterior a hoje.'

      if (!this.alertDataMinimaSolicitacao()) {
        this.row.DTSOLICITACAO = null;
      }
    } else {
      this.dataMinimimaSolicitacao = null;
      this.hintDataSolicitacao = null;
    }
  }

  private get isDataMinimaValida(): boolean {
    return !(this.isTpSolicitacaoBlockDataAnterior && this.isDataSolicitacaoAnteriorDataAtual);
  }

  private alertDataMinimaSolicitacao(): boolean {
    if(this.isEdit) {
      return true;
    }

    if (!this.isDataMinimaValida) {
      SnackbarUtils.showMessage('Para a Solicitação de Férias, não é possível escolher uma data anterior a hoje!',
        SnackbarUtils.TYPE_ALERT
      );
    }

    return this.isDataMinimaValida;
  }

  private get isDataSolicitacaoAnteriorDataAtual(): boolean {
    return isBefore(parse(this.row.DTSOLICITACAO, 'dd/MM/yyyy', new Date()), dataAtualDate);
  }

  private async getTodosVinculosOnInput() {
    const isGetTodosVic = this.TP_SOLICITACAO_TODOS_VINC.includes(this.row.NRTIPOSOLICITACAO);
    if(!isGetTodosVic) {
      this.vinculos = this.vinculosProp;
      return;
    }

    try {
      await this.loadTodosVinculos();

      this.vinculos = [...this.vinculosProp, ...this.todosVinculos];

    } catch (error) {
      
    }
  }

  private async vinculoOnInput() {
    if (Util.isEmptyOrBlank(this.row.NRVINCULOM)) {
      return;
    }

    if (this.row.NRTIPOSOLICITACAO === TiposSolicitacao.TP_SOLI_DESLIGAMENTO) {
      await this.loadDadosVinculo();
      this.verificaPeriodoExperiencia(true);
    }

    if(this.tiposSolicitacaoBloqueioDemitido.includes(this.row.NRTIPOSOLICITACAO) && await this.blockIfSelectedVinculoIsAfastado()) {
      this.clearVinculoFormData();
      await DialogUtils.show('Aviso', Messages.VINC_AFAST_OR_DESLIG_BLOCK, () => {}, () => {}, false, true);
    }

    await this.confirmIfSelectedVinculoIsAfastado();
  }

  private dataDeSolicitacaoOnInput(): void {
    this.validaDataAnteriorCompetencia('DTSOLICITACAO');

    if (!this.alertDataMinimaSolicitacao()) {
      this.row.DTSOLICITACAO = null;
    }
  }

  public async validaDataAnteriorCompetencia(dataLabel: string) {
    if (Util.isEmptyOrBlank(this.row[dataLabel])) {
      return;
    }

    const dtIniCompetencia = startOfMonth(new Date());
    const dtInicio = parse(this.row[dataLabel], 'dd/MM/yyyy', new Date());
  
    if(isBefore(dtInicio, dtIniCompetencia)) {

      SnackbarUtils.showMessage("Não é permitido o uso de datas retroativas à competência atual!", SnackbarUtils.TYPE_ERROR);
      this.$nextTick(() => {
        this.row[dataLabel] = null;
      });
      
    }
  }

  private async validaDataAnteriorDataAtual(dataLabel: string) {
    if (Util.isEmptyOrBlank(this.row[dataLabel])) {
      return;
    }

    const dtAtual = new Date();
    const dtInicio = parse(this.row[dataLabel], 'dd/MM/yyyy', new Date());
  
    if(isBefore(dtInicio, dtAtual) && !isSameDay(dtInicio, dtAtual)) {

      SnackbarUtils.showMessage("Não é permitido o uso de datas retroativas à data atual!", SnackbarUtils.TYPE_ERROR);
      this.$nextTick(() => {
        this.row[dataLabel] = null;
      });
      
    }
  }

  private async validaDataAnteriorComLimite(dataLabel: string) {
    if (Util.isEmptyOrBlank(this.row[dataLabel])) {
        return;
    }

    const dtIniCompetencia = startOfMonth(new Date());
    const dtLimite = subMonths(dtIniCompetencia, 1);
    const dtInicio = parse(this.row[dataLabel], 'dd/MM/yyyy', new Date());

    if (isBefore(dtInicio, dtLimite)) {
        SnackbarUtils.showMessage(
            "Não é permitido o uso de datas retroativas a mais de dois meses da competência atual!",
            SnackbarUtils.TYPE_ERROR
        );
        this.$nextTick(() => {
            this.row[dataLabel] = null;
        });
    }
  }

  private updateConsiderationsVisibilty() {
    this.setConsiderationsInvisible();
    this.row.DSCONSIDERACAO = this.tipoSolicitacaoSelected ? this.tipoSolicitacaoSelected.DSCONSIDERACAO : null;
    this.considerationsIsVisible = !!this.row.DSCONSIDERACAO;
  }

  private setConsiderationsInvisible() {
    this.considerationsIsVisible = false;
  }

  private updateMainGridFieldsVisibility() {
    this.setConsiderationsInvisible();
  }

  private getObservacaoLGPD(
    observacao: string,
  ): string {
    if (!this.row._eula) {
      return observacao;
    };

    const data = DateUtil.getCurrentDate();
    const time = DateUtil.getCurrentTime();

    const obsLGPD = `
      (Usuário concordou com aceite de privacidade (LGPD) em ${data} às ${time})`;

    const obs = (observacao || '') + obsLGPD;

    return obs;
  }

  private async setTransferenciaLegalFields() {
    if(this.isEdit) {
      this.preencherCamposEdit();
    } else {
      await this.vinculoDemitidoOuAfastado();
    }

    this.isEscala12x36 = false;

    this.loading = true;
    try {
      const [previouMovim, previousEscala] = await Promise.all([
        NovaSolicitacaoController.getDadosPreviosSolicitacao(this.row.NRVINCULOM, 2),
        NovaSolicitacaoController.getDadosPreviosSolicitacao(this.row.NRVINCULOM, 14),
        this.loadTiposTransferencia(),
        this.loadTransferencias(),
        this.loadMotivosTransferencia(),
        this.loadEstruturasLegais(),
        this.loadEstruturasGerenciais(),
        this.loadEscalas(),
        this.loadTipoAlteraSal(),
        this.loadModalidadeSal(),
        this.loadUltimoSalario()
      ]);

      await this.setDefaultRowEscala(previousEscala);
      this.setDefaultRowTransferenciaLegal(previouMovim.LEGAL, previouMovim.GERENCIAL);
      this.setDefaultRowSalario();

      if(!this.isEdit) {
        this.row.NRTIPOTRANSFER = '1';
        this.row.NRTPMOVTRANSFM = '8';
      }
  
      const defaultRowTransferenciaCopy = Util.deepCopy(this.defaultRowTransferenciaLegal);
      const defaultRowSalarioCopy = Util.deepCopy(this.defaultRowSalario);
      const defaultRowEscalaCopy = Util.deepCopy(this.defaultRowEscala);

      this.row = {...this.row, ...defaultRowTransferenciaCopy, ...defaultRowSalarioCopy, ...defaultRowEscalaCopy};

    } finally {
      this.loading = false;
    }
  }

  public async loadTiposTransferencia() {
    this.tiposTransferencia = await NovaSolicitacaoController.getTipoTransferencia();
  }

  public async loadTransferencias() {
    this.transferencias = await NovaSolicitacaoController.getMovimentacaoTransferencia();
  }

  public async loadMotivosTransferencia() {
    this.motivosTransferencia = await NovaSolicitacaoController.getMotivoTransferencia();
  }

  private validateDateTransferencia(): boolean {
    const inicio: string = this.row.DTINIMOVIMENT;
    const fim: string = this.row.DTFIMMOVIMENT;

    const dtInicioMovimento = DateUtil.getDateDDMMYYYY((this.row.DTINIMOVIMENT || ''));
    const dateCurrent = new Date();
    const firstDayMonth = startOfMonth(dateCurrent);
    const firstDayNextMonth = startOfMonth(addMonths(dateCurrent, 1));

    const isDateValid = isSameDay(dtInicioMovimento, firstDayMonth) || isSameDay(dtInicioMovimento, firstDayNextMonth);
    if (!isDateValid) {
      const msg = 'A data de início da movimentação é inválida. Somente datas do primeiro dia do mês atual ou do primeiro dia do próximo mês são permitidas.';
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
      return false;
    }

    if(!fim) return true;

    const inicioAfterFim = DateUtil.compareDates(inicio, fim) === -1;

    if (!inicioAfterFim) {
      const message = 'A data de fim deve ser superior à data de início!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      return false;
    }

    return true;
  }

  public setDefaultRowTransferenciaLegal (dataPrevLegal: any, dataPrevGeren: any) {
    if(dataPrevLegal) {
      this.defaultRowTransferenciaLegal.NRTPMOVTRANSFM_HIST = dataPrevLegal.NRTPMOVTRANSFM;
      this.defaultRowTransferenciaLegal.NRESTRUTURAM_LEGAL_HIST = dataPrevLegal.NRESTRUTURAM;
      this.defaultRowTransferenciaLegal.NRMOTIVOTRANSF_HIST = dataPrevLegal.NRMOTIVOTRANSF;
    }
    if(dataPrevGeren) {
      this.defaultRowTransferenciaLegal.NRESTRUTURAM_GEREN_HIST = dataPrevGeren.NRESTRUTURAM;
    }
  }

  // VT
  private async setVCFields() {
    if(this.isEdit) {
      this.preencherCamposEdit();
    } else {
      await this.vinculoDemitidoOuAfastado();
    }

    await this.loadBeneficiosVCombust();

    const defaultRowVCombustCopy = Util.deepCopy(this.defaultRowVCombust);
    this.row = {...this.row, ...defaultRowVCombustCopy};
    
    if(!this.isEdit) {
      this.setPessoaRow();
    }

    this.isInclusaoVC = this.row.CDTIPOALTEVC !== 'E';
  }

  private async loadBeneficiosVCombust() {
    this.beneficios = await SolicitacaoController.getBeneficiosVCombust();
    this.beneficiosFiltrados = this.beneficios;
    if (this.beneficios && this.beneficios.length === 0) {
      SnackbarUtils.showMessage('Nenhum benefício de vale combustível foi identificado.', SnackbarUtils.TYPE_ALERT);
    }
  }

  private async onSaveValeCombustivelValidation() {
    if(this.row.CDTIPOVC == 'V' && this.row.CDTIPOALTEVC != 'E') {
      this.desformatarMoeda('VRBENEFICIO');
    }

    if(this.row.CDTIPOVC == 'K' && this.row.CDTIPOALTEVC != 'E') {
      this.row.QTBENEFICIO = parseFloat(this.row.QTBENEFICIO);
    }

    const solicitacoes: any = await NovaSolicitacaoController.getSolicitacoesDia(this.row, this.isEdit);
    if (!Util.isEmptyOrBlank(solicitacoes.mensagem)) {
      const msg = solicitacoes.mensagem;
      this.row.DTALTESALARIO = null;
      await DialogUtils.show('Aviso', msg, () => {}, () => {}, false, true);
      return false;
    } 
    
    return true;
  }


  private async setAuxilioMoradiaFields() {
    if(this.isEdit) {
      this.preencherCamposEdit();
    } else {
      await this.vinculoDemitidoOuAfastado();
    }

    const defaultRowAuxilioMoradiaCopy = Util.deepCopy(this.defaultRowAuxilioMoradia);
    this.row = {...this.row, ...defaultRowAuxilioMoradiaCopy};

  }

  private async setVManutencaoFields() {
    if(this.isEdit) {
      this.preencherCamposEdit();
    } else {
      await this.vinculoDemitidoOuAfastado();
    }

    await this.loadBeneficiosVMautencao();

    this.isInclusaoVC = this.row.CDTIPOALTEVC !== 'E';
    
    if(!this.isEdit) {
      this.setPessoaRow();
    }
  }

  private async loadBeneficiosVMautencao() {
    this.beneficios = await SolicitacaoController.getBeneficiosVManutencao();
    this.beneficiosFiltrados = this.beneficios;
    if (this.beneficios && this.beneficios.length === 0) {
      SnackbarUtils.showMessage('Nenhum benefício de Vale Manutenção foi identificado.', SnackbarUtils.TYPE_ALERT);
    }
  }

  // Substituição
  private async setSubstituicaoFields() {
    this.isNmPessoaReadOnly = false;
    if(this.isEdit) {
      this.preencherCamposEdit();
    } else {
      await this.substituicaoAdvancedValidations();
    }

    const nrparcnegocio = this.vinculoSelected ? `${this.vinculoSelected.NRPARCNEGOCIO} - ${this.vinculoSelected.NMVINCULOM}` : null;

    this.row = {
      ...this.row,
      ...this.defaultRowAdmissao,
      NRVINCULOMSUBST: nrparcnegocio
    };
    try {
      const nrVinculo = this.row.NRVINCULOM;
      this.loading = true;

      const [ocupacao] = await Promise.all([
        NovaSolicitacaoController.getDadosPreviosSolicitacao(nrVinculo, 9),
        this.loadUltimoSalario(),
        this.loadMotivosAdmissao(),
        this.loadEstruturasGerenciais(),
        this.loadEstruturasLegais(),
        this.loadDadosVinculo(),
        this.loadOcupacoes(),
        this.loadVinculosEmpregaticios(),
        this.loadGrausInstrucao(),
        this.loadTiposVinculo(),
        this.loadEscalas(),
        this.loadMotivosAdmissao(),
        this.solicitacaoIsReduzido ? this.loadTiposProcesso() : null,
        this.solicitacaoIsReduzido ? this.loadTemplates() : null,
      ]);
      
      if(!this.isEdit) {
        this.row.CDTIPOADMISSAO = 'S';
        this.row.NMOCUPACAOH = ocupacao.NMOCUPACAOH;
        this.row.VRSALARIOATUAL = this.dadosUltimoSal.VRSALARIO;
      }

      if(this.dadosVinculo && !this.isEdit) {
        const { NRTIPOVINCULOM, NRVINCULOEMPREG, NRCARGO: NROCUPACAOM, NRESTRUTGEREN, NRESTRUTLEGAL, VRSALARIO, NRESCALATRABM, NRGRAUINSTR } = this.dadosVinculo;

        this.row = {
          ...this.row,
          NRTIPOVINCULOM,
          NRVINCULOEMPREG,
          NROCUPACAOM,
          NRESTRUTGEREN,
          NRESTRUTLEGAL,
          VRSALARIO,
          NRESCALATRABM,
          NRGRAUINSTR
        };
      }

      if(this.row.VRSALARIO) {
        this.row.VRSALARIO = parseFloat(this.row.VRSALARIO).toFixed(2);
      }
  
      const defaultRowSubstituicaoCopy = Util.deepCopy(this.defaultRowSubstituicao);
      this.row = {...this.row, ...defaultRowSubstituicaoCopy};
    } catch (error) {
      SnackbarUtils.showMessage('Ocorreu um problema ao buscar as informações necessárias para esta solicitação.', SnackbarUtils.TYPE_ERROR);
    } finally {
      this.loading = false;
    }
  }

  private async loadMotivosAdmissao() {
    this.motivosAdmissao = await AdmissaoController.getMotivosAdmissao();
  }

  private async loadDadosVinculo() {
    this.dadosVinculo = await SolicitacaoController.getDadosVinculo(this.vinculoSelected.NRVINCULOM);
  }

  private changeLabelVinculo(value: string) {
    if(value == TiposSolicitacao.TP_SOLI_SUBSTITUICAO) {
      this.vinculoLabel = 'Vínculo Substituído';
      return;
    }
    if(value == TiposSolicitacao.TP_SOLI_AUMENTO_QUADRO || value == TiposSolicitacao.TP_SOLI_PESSOAL) {
      this.vinculoLabel = 'Responsável pela Solicitação';
      return;
    }
    this.vinculoLabel = 'Vínculo';
  }

  private async substituicaoAdvancedValidations() {
    /* Validacoes que pode permitir o processo */
    await this.vinculoNaoDemitido();
    await this.vinculoSubstituido();
    
    const isrescindido = this.vinculoSelected && this.vinculoSelected.IDDESLGOURESCD == 'S';
    if(isrescindido) return;

    await this.vinculoPossuiEstabilidade();
    await this.vinculoIncluidoNaLeiDeCota();
    await this.vinculoAfastado();
    await this.vinculoComContratoTemp();
  }


  // Aumento de Quadro
  private async setAumentoQuadroFields() {
    this.isAumentoQuadroReadonly = false;
    this.isNmPessoaReadOnly = false;

    if(this.isEdit) {
      this.preencherCamposEdit();
    } else {
      await this.aumentoQuadroAdvancedValidations();
    }

    let nrparcnegocio = '';

    if(!this.vinculoIsNotVisible) {
      nrparcnegocio = `${this.user.nrparcnegocio} - ${this.user.nmoperador}`;
    } else {
      nrparcnegocio = this.vinculoSelected ? `${this.vinculoSelected.NRPARCNEGOCIO} - ${this.vinculoSelected.NMVINCULOM}` : null;
    }

    this.row = {
      ...this.row,
      ...this.defaultRowAdmissao,
      NRPARCNEGOCIORESP: nrparcnegocio
    };

    try {
      this.loading = true;

      await Promise.all([
        this.loadEstruturasGerenciais(),
        this.loadEstruturasLegais(),
        this.loadOcupacoes(),
        this.loadVinculosEmpregaticios(),
        this.loadGrausInstrucao(),
        this.loadTiposVinculo(),
        this.loadEscalas(),
        this.solicitacaoIsReduzido ? this.loadTiposProcesso() : null,
        this.solicitacaoIsReduzido ? this.loadTemplates() : null,
      ]);
    } finally {
      this.loading = false;
    }

    const defaultRowAumentoQuadroCopy = Util.deepCopy(this.defaultRowAumentoQuadro);
    this.row = {...this.row, ...defaultRowAumentoQuadroCopy};
  }

  private async onSaveAumentoQuadroValidation() {
    if(!this.validateDatePessoal() || !this.validateNrVagas() || !this.validaDtAdmissaoPrevista() || !this.validateLimitesProcessos()) {
      return false;
    };
    
    const [solicitacoes] = await Promise.all([
      this.validationsEstrutLegal(),
    ]);

    return true;
  }

  private validaVagasAumentoQuadro() {
    if(this.row.NRVAGAS > 1) {
      this.isAumentoQuadroReadonly = true;
      
      this.$nextTick(() => {
        const rowCopy = Util.deepCopy(this.row);
        this.row = { ...rowCopy, NMPESSOA: null, NRCPFPESSOA: null };
      });

      if(this.row.NRCPFPESSOA || this.row.NMPESSOA) {
        const message = 'Os campos de "CPF do Indicado" e "Nome do Indicado" só podem ser preenchidos se houver apenas uma vaga disponível.';
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_INFO);
      }

      return;
    }

    this.isAumentoQuadroReadonly = false;
  }

  private async onIputCpfSoliAdmissao() {
    this.isNmPessoaReadOnly = false;
    this.$nextTick(() => {
      const rowCopy = Util.deepCopy(this.row);
      this.row = { ...rowCopy, NMPESSOA: null };
    });

    const isCpfValid = this.validarCPF();
    if(!isCpfValid) return;

    await this.loadVinculoByCpf();
    this.verificaVinculoExistente();
  }

  private validarCPF() {
    const cpf: string = this.row.NRCPFPESSOA;
    const isValid = DocumentoUtil.validaCPF(cpf);

    if (!isValid) {
      const message = 'CPF inválido!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      this.$nextTick(() => {
        const rowCopy = Util.deepCopy(this.row);
        this.row = { ...rowCopy, NRCPFPESSOA: null };
      });
    }

    return isValid;
  }

  private async loadVinculoByCpf() {
    const cpf = this.row.NRCPFPESSOA;
    if(!cpf) return;
    this.vinculoCpf = await VinculoController.getVinculoByCPF(cpf.replace(/\D/g,''));
  }

  private async verificaVinculoExistente() {
    
    if(!Util.isEmptyOrBlank(this.vinculoCpf)) {
  
      if(!this.vinculoCpf || this.vinculoCpf.IDDESLGOURESCD != 'S') return;


      const dtAdmissao = this.vinculoCpf.DTADMISSAOVINC && this.vinculoCpf.DTADMISSAOVINC.split(' ')[0];
      const dtRescisao = this.vinculoCpf.DTRESCISAOVINC && this.vinculoCpf.DTRESCISAOVINC.split(' ')[0];

      const nmVinculom = this.vinculoCpf.NMVINCULOM || 'Indefinido';
      const nrVinculom = this.vinculoCpf.NRVINCULOM || 'Indefinido';

      const obs = this.vinculoCpf.DSOBSERVACAORESCISAO || '';
      const isDp = this.user.dp;

      const callbackRejectCpf = () => this.row.NRCPFPESSOA = null;
      const callbackAcceptCpf = () =>  {
        this.row.NMPESSOA = nmVinculom;
        this.isNmPessoaReadOnly = true;
      };
    

      if(this.vinculoCpf.IDVERIFICARESCISAO == 'S') {
        await DialogUtils.show(
          'Alerta', `O candidato ${nmVinculom}, já foi empregado da respectiva empresa, e foi indicado como "Pessoa não Grata". Logo, não poderá ser admitido. Observação: ${obs}`,
          callbackAcceptCpf,
          callbackRejectCpf,
          false,
          !isDp
        );

        return;
      }

      await DialogUtils.show(
        'Alerta', `Pessoa já possuiu vínculo empregatício na respectiva organização. Vínculo: ${nrVinculom} – ${nmVinculom}
        data de admissão ${dtAdmissao || 'não definida'} data de rescisão ${dtRescisao || 'não definida'}`,
        callbackAcceptCpf,
        callbackRejectCpf
      );
    }

  }

  // Salário e Escala
  private async setSalarioEscalaFields() {
    this.isEscala12x36 = false;
    this.isSoliMovimentRequired = false;
    this.isSoliOcupacaoRequired = false;

    if(this.isEdit) {
      this.preencherCamposEdit();
    } else {
      await this.ocupacaoAdvancedValidations();
    }

    this.loading = true;
    try {
      const [movimPrevious, ocupacaoPrevious, escalaPrevious] = await Promise.all([
        NovaSolicitacaoController.getDadosPreviosSolicitacao(this.row.NRVINCULOM, 2),
        NovaSolicitacaoController.getDadosPreviosSolicitacao(this.row.NRVINCULOM, 9),
        NovaSolicitacaoController.getDadosPreviosSolicitacao(this.row.NRVINCULOM, 14),
        this.loadTipoAlteraSal(),
        this.loadModalidadeSal(),
        this.loadUltimoSalario(),
        this.loadEscalas(),
        this.loadTiposTransferencia(),
        this.loadTransferencias(),
        this.loadMotivosTransferencia(),
        this.loadEstruturasLegais(),
        this.loadEstruturasGerenciais(),
        this.loadOcupacoes(),
        this.loadMotivosOcupa(),
      ]);

      this.setDefaultRowSalario();
      this.setDefaultRowTransferenciaLegal(movimPrevious.LEGAL, movimPrevious.GERENCIAL);
      this.setDefaultRowOcupacao(ocupacaoPrevious);
      this.escalaVinculo = escalaPrevious.ESCALATRABALHO;
      await this.setDefaultRowEscala(escalaPrevious);

      const defaultRowOcupacaoCopy = Util.deepCopy(this.defaultRowOcupacao);
      const defaultRowSalarioCopy = Util.deepCopy(this.defaultRowSalario);
      const defaultRowEscalaCopy = Util.deepCopy(this.defaultRowEscala);
      const defaultRowTransferenciaLegalCopy = Util.deepCopy(this.defaultRowTransferenciaLegal);
      this.row = {...this.row, ...defaultRowOcupacaoCopy, ...defaultRowSalarioCopy, ...defaultRowEscalaCopy, ...defaultRowTransferenciaLegalCopy};

    } finally {
      this.loading = false;
    }
  }

  private async setBeneficiosFields() {
    if(this.isEdit) {
      this.preencherCamposEdit();
    } else {
      await this.vinculoDemitidoOuAfastado();
    }

    await Promise.all([
      this.loadTipoBeneficios(),
      this.loadBeneficios()
    ]);

    this.isInclusaoVC = this.row.CDTIPOALTEVC !== 'E';
    if(!this.isEdit) {
      this.setPessoaRow();
    }
  }

  private filtrarBeneficio() {
    const tpBeneficio = this.row.NRTPBENEFICIO;
    const periodoBeneficio = this.row.TPPERIODOBENEF;

    const beneficios = this.beneficios.filter(beneficio => {
      const tipoBeneficioValido = !tpBeneficio || beneficio.NRTPBENEFICIO === tpBeneficio;
      const periodoBeneficioValido = !periodoBeneficio || beneficio.TPPERIODOBENEF === periodoBeneficio;
      
      return tipoBeneficioValido && periodoBeneficioValido;
    });
    this.beneficiosFiltrados = beneficios;
  }

  private setPessoaRow() {
    this.row.NRPESSOA = `${this.vinculoSelected.NRPESSOA} - ${this.vinculoSelected.NMPESSOA}`;
  }


  private async setTreinamentoFields() {
    if(this.isEdit) {
      this.preencherCamposEdit();
    } 

    const defaultRowTreinamentoCopy = Util.deepCopy(this.defaultRowTreinamento);
    this.row = {...this.row, ...defaultRowTreinamentoCopy};

    await Promise.all([
      this.loadCursos(),
      this.loadPerfisAcesso(),
      this.loadMetodos(),
    ]);

  }

  private async loadCursos() {
    this.cursos = await TreinamentoController.getCurso();
  }

  private async loadPerfisAcesso() {
    this.perfisAcesso = await TreinamentoController.getPerfilAcesso();
  }

  private async loadMetodos() {
    this.metodos = await TreinamentoController.getMetodo();
  }

  private onSaveTreinamentoValidations() {
    return this.validateDateInicioFim(this.row.DTINIPLANEJADOTRE, this.row.DTFIMPLANEJADOTRE);
  }


  private async setAdvertenciaFields() {
    if(this.isEdit) {
      this.preencherCamposEdit();
    } else {
      await this.advertenciaAdvancedValidations();
    }
    
    this.loadTiposAnotacao();

    const defaultRowAdvertenciaCopy = Util.deepCopy(this.defaultRowAdvertencia);
    this.row = {...this.row, ...defaultRowAdvertenciaCopy};
  }

  private async loadTiposAnotacao() {
    this.tiposAnotacao = await NovaSolicitacaoController.getTiposAnotacao();
  }

  private afterAdvanceActionDesligamento() {
    if(this.isEdit) {
      this.preencherCamposEdit();
    } else {
      this.setDefaultTipoDemissaoItemAfterAdvance();
    }
  }

  private setDefaultTipoDemissaoItemAfterAdvance() {
    const defaultRow = this.defaultDesligamentoItemsRow;
    this.updatePropertiesOnRow(defaultRow);
  }

  private updatePropertiesOnRow(props: any): void {
    this.row = { ...this.row, ...props };
  }

  private async onSaveOcupacaoValidations(): Promise<boolean> {

    const solicitacoes: any = await NovaSolicitacaoController.getSolicitacoesDia(this.row, this.isEdit);
    if (!Util.isEmptyOrBlank(solicitacoes.mensagem)) {
      const msg = solicitacoes.mensagem;
      this.row.DTALTESALARIO = null;
      await DialogUtils.show('Aviso', msg, () => {}, () => {}, false, true);
      return false;
    } 

    //await this.validateDateAlteOcupa();

    return true;
  }

  private async onSaveAlteSalario(): Promise<boolean> {
    if(!(await this.validateSalario())) {
      return false;
    }

    const solicitacoes = await NovaSolicitacaoController.getSolicitacoesDia(this.row, this.isEdit);
    if (!Util.isEmptyOrBlank(solicitacoes.mensagem)) {
      const msg = solicitacoes.mensagem;
      this.row.DTALTESALARIO = null;
      await DialogUtils.show('Aviso', msg, () => {}, () => {}, false, true);
      return false;
    } 

    return true;
  }

  private verificaSeInputsSalarioPreenchidos() {
    const { VRSALARIO, IDTPSALARIO, NRTIPOALTERA } = this.row;

    if (VRSALARIO && IDTPSALARIO && NRTIPOALTERA) {
      return true;
    }
    return false;
  }

  public clearInputsSalarioOfRow() {
    const rowCopy = Util.deepCopy(this.row);
    const { DTALTESALARIO, NROCORRENCIA, VRSALARIO, IDTPSALARIO, NRTIPOALTERA, VRSALARIOATUAL, ...restRow  } = rowCopy;
    this.row = restRow;
  }

  private awaitUpdateDomForValidate() {
    //Espera o Dom atualizar para fazer a validação do form/inputs
    this.$nextTick(() => {
      this.validate(true);
      this.alertAllFieldsIsRequired();
    });
  }


  private async validateSalAlteOcupa() {
    const salarioAtual = this.dadosUltimoSal.VRSALARIO;
    const tipoSalarioAtual = this.dadosUltimoSal.IDTPSALARIO;
    const novoSalario = this.row.VRSALARIO;
    const tipoNovoSalario = this.row.IDTPSALARIO;

    if(tipoSalarioAtual === 'TAREFA' || tipoNovoSalario === 'TAREFA') {
      return;
    }
    
    const isSalarioMenor = this.validaNovoSalarioMenorQueAtual(salarioAtual, tipoSalarioAtual, novoSalario, tipoNovoSalario);

    if(isSalarioMenor) {
      const msg = 'Novo Salário é menor que o Salário Atual.';
      await DialogUtils.show('Aviso', msg, () => {}, () => {}, false, true);
    }
  }

  private validaNovoSalarioMenorQueAtual(
    salarioAtual: number | string,
    tipoSalarioAtual: string,
    novoSalario: number | string,
    tipoNovoSalario: string
  ): boolean {

    // Convertendo os salários para mensal
    const salarioAtualMensal = this.converterParaMensal(Number(salarioAtual), tipoSalarioAtual);
    const novoSalarioMensal = this.converterParaMensal(Number(novoSalario), tipoNovoSalario);
  
    return novoSalarioMensal < salarioAtualMensal;
  }

  private converterParaMensal(valor: number, tipoSalario: string): number {
    if (typeof valor !== 'number') return 0;

    const tipos = {
      MENSAL: valor,
      QUINZENAL: valor * 2,
      SEMANAL: Math.ceil(valor * 4.3),
      DIARIO: Math.ceil(valor * 22),
      HORA: Math.ceil(valor * 220),
      TAREFA: valor,
    }
    if(!tipos[tipoSalario]) return 0;

    return tipos[tipoSalario]; 
  }

  private async onSaveDesligamentoValidations(): Promise<boolean> {
    const isNotJustaCausa = this.row.CDJUSTACAUSA === 'N';
    const isNotInPeriodoExp = this.row.CDPEREXP === 'N';
    const isInAvisoPrevio = this.row.CDCUMPRIRAVISOPREV === 'S';
    const isPedidoDemissao = this.row.CDINICIATIVA === 'C';
    const isNotInAvisoPrevio = !isInAvisoPrevio;
    const dtAvisoPrevisoRescisaoDiffer = this.row.DTAVISOPREVIO && this.row.DTRESCISAOVINC && this.row.DTAVISOPREVIO !== this.row.DTRESCISAOVINC;
    const dateRescisao = DateUtil.getDateDDMMYYYY(this.row.DTRESCISAOVINC || '');
    const dateAvisoPrevio = DateUtil.getDateDDMMYYYY(this.row.DTAVISOPREVIO || '');

    if (isNotJustaCausa && isNotInPeriodoExp && isNotInAvisoPrevio && dtAvisoPrevisoRescisaoDiffer) {
      SnackbarUtils.showMessage('A data de rescisão deve ser igual à data de aviso prévio.', SnackbarUtils.TYPE_ALERT);
      return false;
    }

    if (isInAvisoPrevio) {
      const minDateAvisoPrevioRequired = sub(dateRescisao, { days: 30 });

      if (isAfter(dateAvisoPrevio, minDateAvisoPrevioRequired)) {
        SnackbarUtils.showMessage('A data de aviso prévio deve ser preenchida com, no mínimo, 30 dias de antecedência à data de rescisão.', SnackbarUtils.TYPE_ALERT);
        return false;
      }
    }

    const dtBaseSindicalString = (this.vinculoSelected.DTBASESINDICAL || '').substr(0, 10);
    if (isNotJustaCausa && !isPedidoDemissao && !Util.isEmptyOrBlank(dtBaseSindicalString)) {
      const dateBaseSindicalAnoAtual = DateUtil.getDateDDMMYYYY((this.vinculoSelected.DTBASESINDICAL_ATUAL || '').substr(0, 10));
      const minDataSindical = DateUtil.getDateDDMMYYYY((this.vinculoSelected.DTBASESINDICAL_ATUAL_MIN || '').substr(0, 10));
      
      this.calcularDtProjetada();

      const dtProjetada = this.row.DTRESCISAOPROJETADA ? DateUtil.getDateDDMMYYYY(this.row.DTRESCISAOPROJETADA || '') : null;


      const dtRescisaoValid = (!isBefore(dateRescisao, minDataSindical) && !isAfter(dateRescisao, dateBaseSindicalAnoAtual));
      let dtProjetadaValid = false;

      if(dtProjetada) {
        dtProjetadaValid = (!isBefore(dtProjetada, minDataSindical) && !isAfter(dtProjetada, dateBaseSindicalAnoAtual));
      }

      if(dtProjetadaValid) {
        const isDp = this.user.dp;
        await DialogUtils.show('Aviso', Messages.SOLI_DEMISS_ANTECEDE_ACRD_CLTV, () => {}, () => {}, false, !isDp);
      }
    }
    
    return true;
  }

  private calcularDtProjetada() {

    if(!this.row.DTAVISOPREVIO || !this.row.DTRESCISAOVINC) {
      this.row.DTRESCISAOPROJETADA = '';
      return;
    }
  
    const dtAdmissao = this.vinculoSelected && this.vinculoSelected.DTADMISSAOVINC
      ? DateUtil.getDateDDMMYYYY(this.vinculoSelected.DTADMISSAOVINC.substr(0, 10))
      : null;
    const dtRescisao = DateUtil.getDateDDMMYYYY(this.row.DTRESCISAOVINC || '');
    const dtAviso = DateUtil.getDateDDMMYYYY(this.row.DTAVISOPREVIO || '');
    let dtRescisaoProjetada = "";
  
    if (dtAviso) {
      const diasAviso = differenceInDays(new Date(dtRescisao), new Date(dtAviso));
      const diasTrabalhados = differenceInDays(new Date(dtRescisao), new Date(dtAdmissao));         
      let diasAdicionais = Math.floor(diasTrabalhados / 365) * 3; // 3 dias para cada ano trabalhado
  
      if (diasAdicionais > 60) {
        diasAdicionais = 60;
      }
  
      if(this.row.NRTPDEMISSAO == 2)  {
        if (diasAviso === 0) { // data de aviso igual à data de rescisão
          dtRescisaoProjetada = addDays(new Date(dtRescisao), Math.min(30 + diasAdicionais, 90)).toLocaleDateString('pt-BR');
        } else if (diasAviso > 0) { // data de aviso menor que data de rescisão
          dtRescisaoProjetada = addDays(new Date(dtRescisao), Math.min(diasAdicionais, 90)).toLocaleDateString('pt-BR');
        }
      }
    }
  
    this.row.DTRESCISAOPROJETADA = dtRescisaoProjetada;
  
  }  

  private preencheDadosBeneficio() {

    if(!this.row.NRBENEFICIOM) {
      this.row.TPPERIODOBENEF = null;
      this.filtrarBeneficio();
      return;
    }
    
    const beneficio = this.beneficios.find(b => b.NRBENEFICIOM == this.row.NRBENEFICIOM);
    
    if(Util.isEmptyOrBlank(this.row.NRTPBENEFICIO)) {
      this.row.NRTPBENEFICIO = beneficio.NRTPBENEFICIO;
    }

    this.row.TPPERIODOBENEF = beneficio.TPPERIODOBENEF;

    this.filtrarBeneficio();

  }

  private onSavePessoalValidation(): boolean {
    return this.validateDatePessoal() && this.validateNrVagas() && this.validateLimitesProcessos();
  }

  public async onSaveTransferenciaValidation(): Promise<boolean> {

    if(!this.validateDateTransferencia()) {
      return false;
    }

    if(!(await this.validateSalario())) {
      return false;
    }

    if(!(await this.validateEscala())) {
      return false;
    }

    if(!this.verificaSalarioInputsIsVazio()) {
      this.row.DTALTESALARIO = this.row.DTINIMOVIMENT;
    }

    let validateEstrut = (nrEstrutura = '') => {};
    let isGeren = false;

    //Validações especificas da estrututra legal e gerencial
    if(this.current === TiposSolicitacao.TP_SOLI_MOVIM_LEGAL) {
      validateEstrut = this.validationsEstrutLegal;
    }

    if(this.current === TiposSolicitacao.TP_SOLI_MOVIM_GERENCIAL) {
      isGeren = true;
      validateEstrut = this.validationsEstrutGeren;
    }

    const [solicitacoes, folhaCalc] = await Promise.all([
      NovaSolicitacaoController.getSolicitacoesDia(this.row, this.isEdit),
      SolicitacaoController.getFolhaFechada(this.row.NRVINCULOM, this.row.DTINIMOVIMENT),
      isGeren ? validateEstrut(this.row.NRESTRUTURAM) : validateEstrut(),
    ]);

    if (!Util.isEmptyOrBlank(solicitacoes.mensagem)) {
      const msg = solicitacoes.mensagem;
      this.row.DTINIMOVIMENT = null;
      await DialogUtils.show('Aviso', msg, () => {}, () => {}, false, true);
      return false;
    }

    if(folhaCalc && folhaCalc.length) {
      await DialogUtils.show('Aviso', Messages.SOLIC_FECHA_FOLHA, () => {}, () => {}, false, true);
      return false;
    }

    if(this.row.VRSALARIO == this.dadosUltimoSal.VRSALARIO) {
      this.clearInputsSalarioOfRow();
      const rowCopy = Util.deepCopy(this.row);
      const { NRTPMODALIDSAL, ...restRow  } = rowCopy;
      this.row = restRow;
    }

    return true;
  }

  public async validationsEstrutLegal() {
    if(this.row.NRESTRUTGEREN) {
      const hierarquia = await SolicitacaoController.getHierarquiaByEstruturaLegalAndGeren(this.row.NRESTRUTLEGAL, this.row.NRESTRUTGEREN)

      if(hierarquia && !hierarquia.length) {
        await DialogUtils.show('Aviso', Messages.SOLIC_ESTRUTGEREN_NOT_RELAC_ESTRUTLEGAL, () => {}, () => {}, false, true);
        return false;
      } 
    }
  }

  public async validationsEstrutGeren(NRESTRUTGEREN: string = this.row.NRESTRUTGEREN) {
    const hierarquia = await SolicitacaoController.getHierarquiaByEstruturaLegalAndGeren(this.vinculoSelected.NRESTRUTLEGAL, NRESTRUTGEREN)

    if(hierarquia && !hierarquia.length) {
      await DialogUtils.show('Aviso', Messages.SOLIC_VINC_NOT_ESTRUTLEGAL, () => {}, () => {}, false, true);
      return false;
    }
  }

  private onSaveDependenteValidation(): boolean {
    return this.validarCpfDependente();
  }

  private async overrideBeneficioSaveAction(row: any): Promise<void> {
    await this.saveSoliSeparatingBeneficioData();
  }

  private async overrideVTSaveAction(row: any): Promise<void> {
    await this.saveSoliSeparatingVTData();
  }

  private async validateEscala(): Promise<boolean>{
    // removendo os campos de escala caso nenhum input esteja preenchido
    if(this.verificaEscalaInputsIsVazio()) {
      const rowCopy = Util.deepCopy(this.row);
      const { NRESCALATRABM, NRTURNO, DTINIESCALA, ...restRow  } = rowCopy;
      this.row = restRow;
    }

    return true;
  }

  public async validateSalario(): Promise<boolean>{

    if(this.verificaSeInputsSalarioPreenchidos()) {
      await this.validateSalAlteOcupa();
    }
    
    if (!this.verificaSalarioInputsIsVazio() && !this.verificaSeInputsSalarioPreenchidos()) {
      this.awaitUpdateDomForValidate();
      return false;
    }

    // removendo os campos de salario caso nenhum input esteja preenchido
    if(this.verificaSalarioInputsIsVazio()) {
      this.clearInputsSalarioOfRow();
    }

    return true;
  }

  private validateDateInicioFim(dateInicio: string, dateFim: string): boolean {
    const inicioAfterFim = DateUtil.compareDates(dateInicio, dateFim) === -1;

    if (!inicioAfterFim) {
      const message = 'A data de fim deve ser superior à data de início!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return false;
    }

    return true;
  }

  private async onSaveSubstituicaoValidation(): Promise<boolean> {
    if(!this.validateDatePessoal() || !this.validaDtAdmissaoPrevista() || !this.validateLimitesProcessos()) {
      return false;
    }

    const [solicitacoes] = await Promise.all([
      this.validationsEstrutLegal(),
    ]);

    return true;
  }

  private async onSaveSalarioEscalaValidations(): Promise<boolean> {

    const isSalarioValid = await this.validaSalarioMenor();
    if(!isSalarioValid) return false;

    let validateEstrut = () => {};

    //Validações especificas da estrututra legal e gerencial
    if(this.row.NRESTRUTLEGAL && this.row.NRESTRUTGEREN) {
      validateEstrut = this.validationsEstrutLegal;
    }

    if(this.row.NRESTRUTGEREN && !this.row.NRESTRUTLEGAL) {
      validateEstrut = this.validationsEstrutGeren;
    }

    const [solicitacoes, folhaCalc] = await Promise.all([
      NovaSolicitacaoController.getSolicitacoesDia(this.row, this.isEdit),
      SolicitacaoController.getFolhaFechada(this.row.NRVINCULOM, this.row.DTINIMOVIMENT),
      validateEstrut(),
    ]);

    if (!Util.isEmptyOrBlank(solicitacoes.mensagem)) {
      const msg = solicitacoes.mensagem;
      this.row.DTINIMOVIMENT = null;
      await DialogUtils.show('Aviso', msg, () => {}, () => {}, false, true);
      return false;
    }

    if(folhaCalc && folhaCalc.length) {
      await DialogUtils.show('Aviso', Messages.SOLIC_FECHA_FOLHA, () => {}, () => {}, false, true);
      return false;
    }


    if(this.row.VRSALARIO == this.dadosUltimoSal.VRSALARIO) {
      this.clearInputsSalarioOfRow();
    }

    return true;
  }

  private async validaSalarioMenor() {
    const escala = this.escalas.find((escala) => escala.NRESCALATRABM === this.row.NRESCALATRABM);
    if(!escala || !this.escalaVinculo) return false;

    const entradaVinculo = this.escalaVinculo.PRIENTRADA ? this.escalaVinculo.PRIENTRADA : this.escalaVinculo.SEGENTRADA;
    const saidaVinculo = this.escalaVinculo.SEGSAIDA ? this.escalaVinculo.SEGSAIDA : this.escalaVinculo.PRISAIDA;

    const entrada = escala.PRIENTRADA ? escala.PRIENTRADA : escala.SEGENTRADA;
    const saida = escala.SEGSAIDA ? escala.SEGSAIDA : escala.PRISAIDA;

    const horasEscalaVinculo = this.calcularDiferencaHoras(entradaVinculo, saidaVinculo);
    const horasEscala = this.calcularDiferencaHoras(entrada, saida);
    const isEscalaMenor = horasEscala < horasEscalaVinculo;

    const salarioAtual = this.dadosUltimoSal.VRSALARIO;
    const tipoSalarioAtual = this.dadosUltimoSal.IDTPSALARIO;
    const novoSalario = this.row.VRSALARIO;
    const tipoNovoSalario = this.row.IDTPSALARIO;

    if(tipoSalarioAtual === 'TAREFA' || tipoNovoSalario === 'TAREFA') {
      return true;
    }
    
    const isSalarioMenor = this.validaNovoSalarioMenorQueAtual(salarioAtual, tipoSalarioAtual, novoSalario, tipoNovoSalario);

    if(isSalarioMenor && !isEscalaMenor) {
      const msg = 'Novo salário é inferior ao salário atual. Por favor, considere aumentar o salário ou reduzir a escala de trabalho.';
      await DialogUtils.show('Aviso', msg, () => {}, () => {}, false, true);
    }

    return true;
  }

  private calcularDiferencaHoras(horaInicio, horaFim) {
    // Definindo o formato das horas
    const formatoHora = 'HH:mm';

    // Parseando as horas para objetos Date
    const inicio = parse(horaInicio, formatoHora, new Date());
    let fim = parse(horaFim, formatoHora, new Date());

    // Se a hora de fim for menor que a hora de início, adicionar um dia ao fim
    if (fim < inicio) {
      fim = addDays(fim, 1);
    }

    // Calculando a diferença em horas
    const diferencaHoras = differenceInHours(fim, inicio);

    return diferencaHoras;
  }


  // Separa as variacoes nos campos de beneficio e, para cada, cria uma solicitacao com os dados principais
  private async saveSoliSeparatingBeneficioData() {
    const separatedRowConfig = this.getBeneficioSeparatedRow();
    const separatedRow = separatedRowConfig.items || {};
    const rowChanged = separatedRowConfig.row || {};

    this.loading = true;
    try {
      for (const row of separatedRow) {
        const rowToSave = { ...rowChanged, ...row };
        await NovaSolicitacaoController.solicitaAlteracao(rowToSave, false);
      }
      this.closePopup();
      this.emitAfterSave();
    } finally {
      this.loading = false;
    }
  }

  // Separa as variacoes nos campos de VT e, para cada, cria uma solicitacao com os dados principais
  private async saveSoliSeparatingVTData() {
    const separatedRowConfig = this.getVTSeparatedRow();
    const separatedRow = separatedRowConfig.items || {};
    const rowChanged = separatedRowConfig.row || {};

    this.loading = true;
    try {
      for (const row of separatedRow) {
        const rowToSave = { ...rowChanged, ...row };
        await NovaSolicitacaoController.solicitaAlteracao(rowToSave, false);
      }
      this.closePopup();
      this.emitAfterSave();
    } finally {
      this.loading = false;
    }
  }

  private getVTSeparatedRow() {
    const vtItemsColumns = [
      'NRLINHATRANSP',
      'NRTIPOLINHAVINC',
      'QTLINHATARIFA',
      'VRTARIFA',
    ];

    return this.getSeparatedRow(vtItemsColumns);
  }

  private getBeneficioSeparatedRow() {
    const beneficioItemsColumns = [
      'NRBENEFICIOM',
      'DTINSCBENEFICIARIO',
      'NRPESSOA',
      'IDTPBENEFICIARIO',
    ];
    
    return this.getSeparatedRow(beneficioItemsColumns);
  }

  // Usado para buscar por variacoes nos campos de solicitacao. E. g. NRBENEFICIOM_2 (NRBENEFICIOM)
  // Essas variacoes sao armazendas em um array, para cada variacao, e removidas da row principal
  // { NRVINCULOM: 123, NRBENEFICIOM: 1, NRBENEFICIOM_2: 1, DTINSCBENEFICIARIO_2: 2 } => { row: { NRVINCULOM: 123 }, items: [{ NRBENEFICIOM: 1 }, { NRBENEFICIOM: 2, DTINSCBENEFICIARIO: 2 }] }
  private getSeparatedRow(fieldVariations: string[], variationsLimit: number = 10): { row: any, items: any } {
    const rowCopy = { ...this.row };
    const itemsRows = [];

    const initialRow = {};
    fieldVariations.forEach((columnName) => {
      if (rowCopy[columnName]) {
        initialRow[columnName] = rowCopy[columnName];
        delete rowCopy[columnName];
      }
    });
    itemsRows.push(initialRow);

    for (let i=0; i<variationsLimit; i++) {
      const separatedRow = {};
      fieldVariations.forEach((columnName) => {
        const extraColumnName = columnName + '_' + i;
        if (rowCopy[extraColumnName]) {
          separatedRow[columnName] = rowCopy[extraColumnName];
          delete rowCopy[extraColumnName];
        }
      });
      if (!Util.isEmptyOrBlank(separatedRow)) {
        itemsRows.push(separatedRow);
      }
    }
    return { row: rowCopy, items: itemsRows };
  }

  public async getTurnoParOuImpar() {
    const nrEscala = this.row.NRESCALATRABM;
    const number = this.row.CDTIPODIATRABALHO === 'I' ? 0 : 1;
    const diaReferencia = this.row.DTINIESCALA || this.row.DTINIMOVIMENT;

    if(!nrEscala || !this.isEscala12x36 || !diaReferencia) return;

    const turno = await EscalaController.getTurnoParOuImpar(nrEscala, number, diaReferencia);

    this.row = { ...this.row, NRTURNO: turno.NRTURNO };

  }

  private alertAutoFilledFields() {
    SnackbarUtils.showMessage('Os campos foram preenchidos automaticamente com base nos dados atuais do colaborador', SnackbarUtils.TYPE_INFO);
  }

  public afterAdvanceActionHistoric() {
    this.setCssClassToBannerHistoric();
    this.alertAutoFilledFields();
  }

  private hasMatchingPreviousSolicitationType() {
    try {
      const types = {
        2: {
          previous: this.defaultRowTransferenciaGeren,
          props: ['NRTIPOTRANSFER', 'NRTPMOVTRANSFM', 'NRESTRUTURAM', 'NRMOTIVOTRANSF'],
        },
        3: {
          previous: this.defaultRowSalario,
          props: ['NRTPMODALIDSAL', 'IDTPSALARIO', 'NRTIPOALTERA', 'VRSALARIO'],
        },
        9: {
          previous: this.defaultRowOcupacao,
          props: ['NROCUPACAOM', 'NRTIPOOCUPACAO', 'NRMOTIVOOCUPA', 'NRTPMODALIDSAL'],
        },
        14: {
          previous: this.defaultRowEscala,
          props: ['NRESCALATRABM', 'NRTURNO'],
        },
      };
  
      const type = types[this.row.NRTIPOSOLICITACAO];
      if (!type) return false;
  
      return this.checkPreviousValuesSolicitation(type.previous, type.props);
    } catch (error) {
      return false; 
    }
  }

  private checkPreviousValuesSolicitation(previous: any, props: any) {
    for (const prop of props) {
      if (this.row[prop] != previous[prop]) {
        return false;
      }
    }
    return true;
  }

  public async ocupacaoAdvancedValidations() {
    /* Validacoes que impedem o processo */
    await this.vinculoDemitidoOuAfastado();
  }


  async getPreviousDataSolicitation(): Promise<any> {
    const nrTipoSolicitacao = this.row.NRTIPOSOLICITACAO;
    const nrVinculo = this.row.NRVINCULOM;
    const data = await NovaSolicitacaoController.getDadosPreviosSolicitacao(nrVinculo, nrTipoSolicitacao);
    return data;
  }
  
  private async confirmIfSelectedVinculoIsAfastado() {
    if (this.vinculoSelected && this.vinculoSelected.IDDESLGOURESCD == 'S') {
      const skipValidation = await this.checkSituacaoFuncionalForValidation(this.row.NRVINCULOM);
      if (skipValidation) {
        return;
      }
      await DialogUtils.show('Confirmação', Messages.VINC_AFAST_OR_DESLIG, () => {}, () => {
        this.clearVinculoFormData();
      });
    }
  }

  private async blockIfSelectedVinculoIsAfastado() {
    if (this.vinculoSelected && this.vinculoSelected.IDDESLGOURESCD == 'S') {
      return true;
    }
    return false;
  }

  private async desligamentoAdvancedValidations() {
    /* Validacoes que impedem o processo */
    await this.vinculoDemitidoOuAfastado();
    await this.vinculoIncluidoNaLeiDeCota();
    await this.vinculoPossuiEstabilidade();

    /* Validacoes que pode permitir o processo */
    //await this.loadValidacaoSitufunc();
  }

  private async aumentoQuadroAdvancedValidations() {
    /* Validacoes que impedem o processo */
    await this.vinculoDemitidoOuAfastado();
  }


  private async getSolicitacaoDia () {
    const solicitacoes = await NovaSolicitacaoController.getSolicitacoesDia(this.row, this.isEdit);
    if (!Util.isEmptyOrBlank(solicitacoes.mensagem)) {
      const msg = solicitacoes.mensagem;
      await DialogUtils.show('Aviso', msg, () => {}, () => {}, false, true);
      return false;
    } 
  }

  private setDiaFimSituFunc() {
    let formattedData = null;
    const qtdeDias = Math.abs(Number(this.row.NRQTDIASITUFUNC));
    let qntDiasSituFunc = qtdeDias;
    //Espera o Dom atualizar para alterar o valor dos inputs
    this.$nextTick(() => {
      if(!this.row.DTINISITUFUNC || !this.row.NRQTDIASITUFUNC) {
        this.row.DTFIMSITUFUNC = null;
        return
      }
  
      if(this.row.NRQTDIASITUFUNC == 0) {
        qntDiasSituFunc = 1;
        this.row.NRQTDIASITUFUNC = 1;
      } 
  
      this.row.NRQTDIASITUFUNC = qtdeDias;
      const dateInicio = DateUtil.getDateDDMMYYYY((this.row.DTINISITUFUNC || '').substr(0, 10));
      formattedData = format(subDays(addDays(dateInicio, qtdeDias), 1), 'dd/MM/yyyy')
      this.row.DTFIMSITUFUNC = formattedData;
    });
    
    // Força a atualização do DOM
    Vue.set(this.row, 'NRQTDIASITUFUNC', qntDiasSituFunc);
    Vue.set(this.row, 'DTFIMSITUFUNC', formattedData);
  }

  private setQntDias() {
    let qntDiasSituFunc = this.row.NRQTDIASITUFUNC;
    //Espera o Dom atualizar para alterar o valor dos inputs
    this.$nextTick(() => {
      if(this.row.NRSITUFUNCM && this.row.NRSITUFUNCM == '18') {
        qntDiasSituFunc = 1;
        this.row.NRQTDIASITUFUNC = 1;
      }
    });
    
    // Força a atualização do DOM
    Vue.set(this.row, 'NRQTDIASITUFUNC', qntDiasSituFunc);
  }

  private async onSaveAdvertenciaValidation(): Promise<boolean> {

    if(this.row.NRQTDIASITUFUNC < 1) {
      SnackbarUtils.showMessage('A quantidade de dias não pode ser menor que 1', SnackbarUtils.TYPE_ERROR);
      return false;
    }

    const solicitacoes: any = await NovaSolicitacaoController.getSolicitacoesDia(this.row, this.isEdit);
    if (!Util.isEmptyOrBlank(solicitacoes.mensagem)) {
      const msg = solicitacoes.mensagem;
      this.row.DTALTESALARIO = null;
      await DialogUtils.show('Aviso', msg, () => {}, () => {}, false, true);
      return false;
    } 

    return true;
  }

  private async advertenciaAdvancedValidations() {
    /* Validacoes que impedem o processo */
    await this.vinculoDemitidoOuAfastado();
  }

  // Validações
  async vinculoDemitidoOuAfastado() {
    const isDp = this.user.dp;
    const skipValidation = await this.checkSituacaoFuncionalForValidation(this.row.NRVINCULOM);

    if (this.vinculoSelected && this.vinculoSelected.IDDESLGOURESCD == 'S' && !skipValidation) {
      await DialogUtils.show('Aviso', Messages.SOLI_VINC_AFAST_OR_DEM, () => {}, () => {}, false, !isDp);
    }
  }

  private async vinculoAfastado() {
    const isDp = this.user.dp;
    if (this.vinculoSelected && this.vinculoSelected.IDAFASTSITUFUNC == 'S') {
      await DialogUtils.show('Aviso', Messages.SOLI_VINC_AFAST, () => {}, () => {}, false, !isDp);
    }
  }

  private async vinculoNaoDemitido() {
    if (this.vinculoSelected && this.vinculoSelected.IDDESLGOURESCD != 'S') {
      await DialogUtils.show('Aviso', Messages.SOLIC_VINC_NAO_DEMITIDO);
    }
  }

  private async vinculoComContratoTemp() {
    const isDp = this.user.dp;
    if (this.vinculoSelected && this.vinculoSelected.NRVINCULOEMPREG == "8") {
      await DialogUtils.show('Aviso', Messages.SOLIC_VINC_COM_CONTRATO_TEMP, () => {}, () => {}, false, !isDp);
    }
  }

  private async vinculoIncluidoNaLeiDeCota() {
    const isDp = this.user.dp;
    if (this.vinculoSelected && this.vinculoSelected.IDCOTAPCDAPRENDIZ == 'S') {
      await DialogUtils.show('Aviso', Messages.SOLI_VINC_EM_LEI_DE_COTA, () => {}, () => {}, false, !isDp);
    }
  }

  private async vinculoPossuiEstabilidade() {
    const isDp = this.user.dp;
    const vinculo = this.vinculoSelected;
  
    if (!vinculo || vinculo.IDSITUACAOESTAB !== 'S') return;
  
    let dataFimStr = "Não informada";
    const motivo = vinculo.DSMOTIVOESTAB || 'Não informado';
    let bloqueio = !isDp;
    if (vinculo.DTFIMESTABVINC) {
      dataFimStr = vinculo.DTFIMESTABVINC.split(' ')[0];
  
      const dataFim = DateUtil.parseDate(dataFimStr);
      const dtCompetencia = DateUtil.parseDate(DateUtil.getDateCompetenc());
  
      const mesmaCompetencia = 
        dataFim.getMonth() === dtCompetencia.getMonth() &&
        dataFim.getFullYear() === dtCompetencia.getFullYear();
  
      if (mesmaCompetencia) {
        bloqueio = false;
      }
    }
  
    const mensagem = 
      `Este colaborador possui ESTABILIDADE até a data ${dataFimStr}. ` +
      `Tipo de estabilidade: “${motivo}”. Sendo necessário a avaliação do RH para desligamento ou substituição. ` +
      `ENTRE EM CONTATO COM O RH PARA VALIDAR A SOLICITAÇÃO.`;
  
    await DialogUtils.show('Aviso', mensagem, () => {}, () => {}, false, bloqueio);
  }

  private async vinculoSubstituido() {
    const isDp = this.user.dp;

    const nrvinculo = this.row.NRVINCULOM; 
    const substituicao = await SolicitacaoController.getSolicitacaoSubstituicaoOrVinculoSubst(nrvinculo);

    const solicitacaoAprovada = substituicao.SOLICITACOES.find((soli) => soli.IDAPROVACAOSEC == 'A');
    const solicitacaoPendente = substituicao.SOLICITACOES.find((soli) => soli.IDAPROVACAOSEC != 'A');

    let isAccept = false;
    const callbackAccept = () => isAccept = true;
    const callbackReject = () => isAccept = false;

    if(solicitacaoAprovada) {
      const message = `Este colaborador já foi substituído através da MP Nr. ${solicitacaoAprovada.NRSOLICITACAO}. Sendo necessário a avaliação do RH para desligamento ou substituição. ENTRE EM CONTATO COM O RH PARA VALIDAR A SOLICITAÇÃO.`;
      await DialogUtils.show('Aviso', message, callbackAccept, callbackReject, false, !isDp);
      return isAccept;
    }

    if(solicitacaoPendente) {
      const message = `Este colaborador já possui uma solicitação de substituição pendente através da MP de número"${solicitacaoPendente.NRSOLICITACAO}".`;
      await DialogUtils.show('Aviso', message, callbackAccept, callbackReject, false, !isDp);
      return isAccept;
    }

    if(Array.isArray(substituicao.VINCULO) && substituicao.VINCULO.length) {
      const message = `Este colaborador já foi substituído ou esta em processo de substituição. Sendo necessário a avaliação do RH para desligamento ou substituição. ENTRE EM CONTATO COM O RH PARA VALIDAR A SOLICITAÇÃO.`;
      await DialogUtils.show('Aviso', message, callbackAccept, callbackReject, false, !isDp);
      return isAccept;
    }

    return true;
  }

  private clearVinculoFormData() {
    this.row.NRVINCULOM = null;
    this.row.NMVINCULOM = null; 
  }

  private removeIdByDescription(text: string) {
    try {
      const partes = text.split("|", 2);
      return partes[1].trim(); 
    } catch (error) {
      return text;
    }
  }

  private setDescriptionInRowValues() {

    // campos com ID | Descrição descrição ex: 620 | TURNO 1
    const fieldsWithId = ['NRNMESCALATRABM', 'NRDSTURNO', 'NRNMESTRUTURA', 'NRNMOCUPACAO', 'NRDSBENEFICIO', 'NRDSLINHATRANSP'];

    // Setando para os fields
    const fieldsWithDescription = this.fields.filter((field) => field.descriptionField || field.type === 'radio');

    fieldsWithDescription.forEach((field) => {

      if(field.type === 'radio') {
        const item = field.items.find((item) => item.value == this.row[field.name]);
        if(!item || !this.row[field.name]) return;
        this.row[field.name] = `${this.row[field.name]} - ${item.label}`;
        return;
      }

      const item = field.items.find((item) => item[field.valueField] == this.row[field.name]);
      if(!item || !this.row[field.name]) return;

      const description = fieldsWithId.includes(field.descriptionField) ? this.removeIdByDescription(item[field.descriptionField]) : item[field.descriptionField];

      this.row[field.name] = `${this.row[field.name]} - ${description}`;
    });

    // Setando para os fields Main
    // campos para serem ignorados ao seta a descricao
    const ignoreFields = ['NRVINCULOM', 'NRTIPOSOLICITACAO' ,'DSAPROVACAOSEC', 'IDAPROVACAOSEC'];

    const fieldsMainWithDescription = this.fieldsMain.filter((field) => (
      (field.descriptionField || field.type === 'radio') && !ignoreFields.includes(field.valueField)
    ));

    fieldsMainWithDescription.forEach((field) => {

      if(field.type === 'radio') {
        const item = field.items.find((item) => item.value == this.row[field.name]);
        if(!item || !this.row[field.name]) return;
        this.row[field.name] = `${this.row[field.name]} - ${item.label}`;
        return;
      }

      const item = field.items.find((item) => item[field.valueField] == this.row[field.name]);
      if(!item || !this.row[field.name]) return;
      this.row[field.name] = `${this.row[field.name]} - ${item[field.descriptionField]}`;
    });

    this.removeFieldRowEmpty(); 

  }

  private removeFieldRowEmpty() {
    for (const key in this.row) {
        if (this.row.hasOwnProperty(key)) {
            if (this.row[key] === null || this.row[key] === '' || this.row[key] === undefined) {
              delete this.row[key];
            }
        }
    }
  }

  private setCssClassToBannerHistoric() {
    const banner = document.querySelector('.nova-solicitacao-content');

    banner.classList.add('banner-not-content');
  }

  private removeCssClassFromBannerHistoric() {
    const banner = document.querySelector('.nova-solicitacao-content');
  
    banner.classList.remove('banner-not-content');
  }

  async preencherCamposEdit() {
    const itens = await SolicitacaoController.getItemSolicitacao(this.selectedRow.NRSOLICITACAO);
    
    itens.forEach(item => {
      const valor = item.DSVALORITEMSOLI.split(' - ')[0];
      this.row = {
        ...this.row,
        [item.DSCHAVEITEMSOLI]: valor,
      }
    });
  }

  private onAdvanceDefault() {
    if(this.isEdit) {
      this.preencherCamposEdit();
    }
  }

  private limpaDtAvisoPrevio() {
    if (this.row.NRTPDEMISSAO === '3') {
        this.row = {...this.row, DTAVISOPREVIO: null};
        return;
    }
  }

  private async checkSituacaoFuncionalForValidation(nrVinculo: number): Promise<boolean> {
    if (this.nrOrg === '1410' && this.row.NRTIPOSOLICITACAO == '5') {

      const situacaoFuncional = await SituacaoFuncionalController.getUtlimaSituacaoFuncional(
        this.$store.getters.user.nrorg,
        nrVinculo,
        this.$store.getters.periodoDemonstrativoAtual.NRPERIODOAPURACAO
      );

      return situacaoFuncional.NRSITUFUNCM === '100148';
    }
    return false;
  }

  public injectFields(novaSolicitacao: INovaSolicitacao): void {
    this.injectedFieldRelation[novaSolicitacao.TP_SOLICITACAO] = novaSolicitacao.fields;
  }

  public injectActions(novaSolicitacao: INovaSolicitacao): void {
    this.typeActionsConfig[novaSolicitacao.TP_SOLICITACAO] = {
      onAdvanceAction: novaSolicitacao.onAdvance || null,
      afterAdvanceAction: novaSolicitacao.afterAdvance || null,
      onSaveValidation: novaSolicitacao.onSaveValidation || null,
      overrideSaveAction: novaSolicitacao.overrideSave || null,
      itemsStageNotNecessary: novaSolicitacao.itemsStageNotNecessary || false,
    };
  }

  private getDataInicialPorRegra(): string | null {
    const regra = this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO;
    const baseDate: Date = new Date();
  
    switch (regra) {
      case 'P':
        return format(startOfMonth(addMonths(baseDate, 1)), 'dd/MM/yyyy');
      case 'A':
        return format(startOfMonth(baseDate), 'dd/MM/yyyy');
      default:
        return DateUtil.getDateCompetenc();
    }
  }

  public getIntervaloDataRegra(tipo: 'min' | 'max'): string | null {
    const regra = this.tipoSolicitacaoSelected && this.tipoSolicitacaoSelected.IDREGRADTINICIO;
   
    const hoje = new Date();
    let intervaloBase: Date;
  
    switch (regra) {
      case 'P':
        intervaloBase = addMonths(startOfMonth(hoje), 1);
        break;
      case 'A':
        intervaloBase = startOfMonth(hoje);
        break;
      default:
        return null; // intervalo livre :)
    }
  
    const data = tipo === 'min'
      ? startOfMonth(intervaloBase)
      : endOfMonth(intervaloBase);
  
    return format(data, 'yyyy-MM-dd');
  }
  // #endregion
}


export default NovaSolicitacaoPopup;

